/*
 * @license
 * Palo Alto Theme (c)
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */

!(function (t, e, i, s, r) {
    "use strict";
    function o(t, e) {
        let i;
        return function () {
            if (t) {
                let s = () => t.apply(this, arguments);
                clearTimeout(i), (i = setTimeout(s, e));
            }
        };
    }
    (window.theme = window.theme || {}),
        (window.theme.sizes = { mobile: 480, small: 768, large: 1024, widescreen: 1440 }),
        (window.theme.keyboardKeys = { TAB: "Tab", ENTER: "Enter", NUMPADENTER: "NumpadEnter", ESCAPE: "Escape", SPACE: "Space", LEFTARROW: "ArrowLeft", RIGHTARROW: "ArrowRight" }),
        (window.theme.focusable = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    let a = () => {
            let t = document.querySelector("body"),
                e = t.querySelector("[data-site-header]");
            if (!e) return;
            let i = "true" === e.getAttribute("data-transparent"),
                s = t.querySelector("[data-main]").children[0];
            if (!s) return;
            let r = s.querySelector("[data-prevent-transparent-header]:first-of-type");
            (window.isHeaderTransparent = i && s.classList.contains("supports-transparent-header") && !r),
                CSS.supports("(selector(:has(*)))") || (t.classList.toggle("is-first-section-transparent", window.isHeaderTransparent), e.classList.toggle("site-header--transparent", window.isHeaderTransparent));
        },
        n = g(),
        l = {
            body: "body",
            main: "[data-main]",
            collectionFilters: "[data-collection-filters]",
            footer: '[data-section-type*="footer"]',
            header: "[data-header-height]",
            stickyHeader: '[data-site-header][data-position="fixed"]',
            announcementBar: "[data-announcement-bar]",
            collectionStickyBar: "[data-collection-sticky-bar]",
            logoTextLink: "[data-logo-text-link]",
        },
        h = { templateCollection: "template-collection", templateSearch: "template-search", supportsTransparentHeader: "supports-transparent-header" };
    function c() {
        document.addEventListener("theme:resize", u), d(), document.dispatchEvent(new CustomEvent("theme:vars"), { bubbles: !1 });
    }
    function d() {
        p();
    }
    function u() {
        p(!0);
    }
    function p(t = !1) {
        let e = document.querySelector(l.body),
            i = document.querySelector(l.collectionFilters),
            s = null !== document.querySelector(l.logoTextLink),
            { windowHeight: r, headerHeight: o, headerInitialHeight: a, announcementBarHeight: c, footerHeight: d, collectionStickyBarHeight: u } = (function () {
                var t, e;
                let i = {};
                return (
                    (i.windowHeight = Math.min(window.screen.height, window.innerHeight)),
                    (i.footerHeight = m(l.footer)),
                    (i.headerHeight = m(l.header)),
                    (i.headerInitialHeight =
                        parseInt((null === (t = document.querySelector(l.header)) || void 0 === t ? void 0 : t.dataset.height) || (null === (e = document.querySelector(l.header)) || void 0 === e ? void 0 : e.offsetHeight)) || 0),
                    (i.announcementBarHeight = m(l.announcementBar)),
                    (i.collectionStickyBarHeight = m(l.collectionStickyBar)),
                    i
                );
            })();
        s &&
            (o = (function () {
                document.documentElement.style.setProperty("--header-height", "auto"), document.documentElement.style.setProperty("--header-sticky-height", "auto");
                let t = document.querySelector(l.header).offsetHeight;
                return (
                    requestAnimationFrame(() => {
                        document.documentElement.style.setProperty("--header-height", `${t}px`), document.documentElement.style.setProperty("--header-sticky-height", `${t}px`);
                    }),
                    t
                );
            })());
        let p = window.isHeaderTransparent && document.querySelector(l.main).firstElementChild.classList.contains(h.supportsTransparentHeader) ? r - c : r - a - c,
            y = document.querySelector(l.stickyHeader) ? r - window.stickyHeaderHeight : r,
            v = e.classList.contains(h.templateCollection),
            f = e.classList.contains(h.templateSearch);
        if (
            (document.documentElement.style.setProperty("--footer-height", `${d}px`),
            document.documentElement.style.setProperty("--content-full", `${p}px`),
            document.documentElement.style.setProperty("--content-min", r - o - d + "px"),
            document.documentElement.style.setProperty("--collection-sticky-bar-height", `${u}px`),
            ((v && i) || (f && i)) && (y = r),
            !t)
        )
            return void document.documentElement.style.setProperty("--full-height", `${y}px`);
        let b = g();
        b !== n && (document.documentElement.style.setProperty("--full-height", `${y}px`), (n = b));
    }
    function m(t) {
        let e = document.querySelector(t);
        return e ? e.clientHeight : 0;
    }
    function g() {
        return window.matchMedia("(orientation: portrait)").matches ? "portrait" : window.matchMedia("(orientation: landscape)").matches ? "landscape" : void 0;
    }
    let y = !1,
        v = !1;
    function f() {
        setTimeout(() => {
            if (y) return;
            if (!v) return void f();
            let t = document.querySelectorAll('img[loading="lazy"]');
            t.length &&
                t.forEach((t) => {
                    t.setAttribute("loading", "eager");
                }),
                (y = !0);
        }, 3e3);
    }
    let b = {
        overflowBackground: "[data-overflow-background]",
        overflowFrame: "[data-overflow-frame]",
        overflowContent: "[data-overflow-content]",
        overflowContainer: "[data-overflow-container]",
        overflowWrapper: "[data-overflow-wrapper]",
    };
    function S(t, e) {
        let i = 0;
        e.forEach((t) => {
            i = t.offsetHeight > i ? t.offsetHeight : i;
        });
        let s = t.querySelectorAll(b.overflowBackground);
        [t, ...s].forEach((t) => {
            t.style.setProperty("min-height", `calc(${i}px + var(--header-height))`);
        });
    }
    function E(t) {
        if (window.innerWidth < window.theme.sizes.small)
            return void t.querySelectorAll(b.overflowFrame).forEach((t) => {
                let e = t.querySelectorAll(b.overflowContent);
                S(t, e);
            });
        let e = 0,
            i = t.querySelectorAll(b.overflowFrame);
        t.querySelectorAll(b.overflowContent).forEach((t) => {
            t.offsetHeight > e && (e = t.offsetHeight);
        }),
            [...i, ...t.querySelectorAll(b.overflowBackground)].forEach((t) => {
                t.style.setProperty("min-height", `${e}px`);
            }),
            t.style.setProperty("min-height", `${e}px`);
    }
    function L(t) {
        let e = t.querySelectorAll(b.overflowContainer);
        e &&
            e.forEach((t) => {
                let e = t.querySelectorAll(b.overflowContent);
                S(t, e),
                    document.addEventListener("theme:resize", () => {
                        S(t, e);
                    });
            });
        let i = t.querySelectorAll(b.overflowWrapper);
        i &&
            i.forEach((t) => {
                E(t),
                    document.addEventListener("theme:resize", () => {
                        E(t);
                    });
            });
    }
    window.lastWindowWidth = window.innerWidth;
    let k = window.pageYOffset,
        w = null,
        $ = null,
        A = null,
        q = null,
        C = 0,
        T = { quickViewVisible: "js-quick-view-visible", cartDrawerOpen: "js-drawer-open-cart" };
    function P() {
        document.body.classList.contains(T.quickViewVisible) || document.body.classList.contains(T.cartDrawerOpen) || (t.clearQueueScrollLocks(), t.enablePageScroll(), document.documentElement.removeAttribute("data-scroll-locked"));
    }
    let _ = (t, e = "", i) => {
        let s = i || document.createElement("div");
        return s.classList.add(e), s.setAttribute("data-scroll-lock-scrollable", ""), t.parentNode.insertBefore(s, t), s.appendChild(t);
    };
    function F(t) {
        t.querySelectorAll("table").forEach((t) => {
            _(t, "table-wrapper");
        });
    }
    let x = { loading: "is-loading" },
        I = { img: "img.is-loading" };
    function H(t) {
        t.querySelectorAll(I.img).forEach((t) => {
            t.complete && (t.classList.remove(x.loading), t.parentNode.classList.remove(x.loading));
        });
    }
    let D = {
            inputSearch: 'input[type="search"]',
            inputType: 'input[name="type"]',
            form: "form",
            allVisibleElements: '[role="option"]',
            ariaSelected: '[aria-selected="true"]',
            selectedOption: '[aria-selected="true"] a, button[aria-selected="true"]',
            popularSearches: "[data-popular-searches]",
            popdownBody: "[data-popdown-body]",
            mainInputSearch: "[data-main-input-search]",
            predictiveSearchResults: "[data-predictive-search-results]",
            predictiveSearch: "predictive-search",
            searchForm: "search-form",
        },
        M = "is-searched",
        O = class extends HTMLElement {
            getQuery() {
                return this.input.value.trim();
            }
            onFocus() {
                this.currentSearchTerm = this.getQuery();
            }
            onChange() {
                this.classList.toggle(M, !this.isFormCleared()), (this.searchTerm = this.getQuery());
            }
            isFormCleared() {
                return 0 === this.input.value.length;
            }
            submit() {
                this.form.submit();
            }
            reset() {
                this.input.val = "";
            }
            onFormSubmit(t) {
                (this.getQuery().length && !this.querySelector(D.selectedLink)) || t.preventDefault();
            }
            onKeydown(t) {
                ("ArrowUp" !== t.code && "ArrowDown" !== t.code) || t.preventDefault();
            }
            onKeyup(t) {
                switch ((!this.getQuery().length && this.predictiveSearch && this.close(!0), t.preventDefault(), t.code)) {
                    case "ArrowUp":
                        this.switchOption("up");
                        break;
                    case "ArrowDown":
                        this.switchOption("down");
                        break;
                    case "Enter":
                        this.selectOption();
                }
            }
            switchOption(t) {
                let e = "up" === t,
                    i = this.classList.contains(M) && this.predictiveSearchResults ? this.predictiveSearchResults : this.popularSearches;
                if (!i) return;
                this.selectedElement = i.querySelector(D.ariaSelected);
                let s = Array.from(i.querySelectorAll(D.allVisibleElements)).filter((t) => null !== t.offsetParent),
                    r = 0;
                if (e && !this.selectedElement) return;
                let o = -1,
                    a = 0;
                for (; -1 === o && a <= s.length; ) s[a] === this.selectedElement && (o = a), a++;
                !e && this.selectedElement ? (r = o === s.length - 1 ? 0 : o + 1) : e && (r = 0 === o ? s.length - 1 : o - 1), r !== o && ((this.activeElement = s[r]), this.handleFocusableDescendants());
            }
            selectOption() {
                let t = this.querySelector(D.selectedOption);
                t && t.click();
            }
            handleFocusableDescendants(t = !1) {
                var e;
                let i = this.selectedElement ? this.selectedElement : this.querySelector(D.ariaSelected);
                if ((i && i.setAttribute("aria-selected", !1), !this.activeElement || t))
                    return (
                        (this.selectedElement = null),
                        null === (e = this.activeElement) || void 0 === e || e.setAttribute("aria-selected", !1),
                        this.input.setAttribute("aria-expanded", !1),
                        void this.input.setAttribute("aria-activedescendant", "")
                    );
                this.activeElement.setAttribute("aria-selected", !0), this.input.setAttribute("aria-activedescendant", this.activeElement.id);
            }
            constructor() {
                var t;
                super(),
                    (this.input = this.querySelector(D.inputSearch)),
                    (this.form = this.querySelector(D.form)),
                    (this.popdownBody = this.closest(D.popdownBody)),
                    (this.popularSearches = null === (t = this.popdownBody) || void 0 === t ? void 0 : t.querySelector(D.popularSearches)),
                    (this.predictiveSearchResults = this.querySelector(D.predictiveSearchResults)),
                    (this.predictiveSearch = this.matches(D.predictiveSearch)),
                    (this.searchForm = this.matches(D.searchForm)),
                    (this.selectedElement = null),
                    (this.activeElement = null),
                    (this.searchTerm = ""),
                    (this.currentSearchTerm = ""),
                    (this.isSearchPage = document.body.classList.contains("template-search")),
                    this.input.addEventListener(
                        "input",
                        o((t) => {
                            this.onChange(t);
                        }, 300).bind(this)
                    ),
                    this.input.addEventListener("focus", this.onFocus.bind(this)),
                    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)),
                    this.addEventListener("keyup", this.onKeyup.bind(this)),
                    this.addEventListener("keydown", this.onKeydown.bind(this)),
                    this.isSearchPage && ((this.mainInputType = document.querySelector(`${D.mainInputSearch} ${D.inputType}`)), (this.inputType = this.querySelector(D.inputType)), (this.inputType.value = this.mainInputType.value));
            }
        };
    customElements.define("search-form", O);
    let B = "reset",
        z;
    customElements.define(
        "predictive-search",
        class extends O {
            connectedCallback() {
                this.predictiveSearchResults.addEventListener("transitionend", (t) => {
                    t.target !== this.predictiveSearchResults || this.getQuery().length || (this.classList.remove(B), requestAnimationFrame(() => this.clearResultsHTML()));
                });
            }
            onChange() {
                super.onChange(), this.classList.remove(B), this.searchTerm.length ? requestAnimationFrame(() => this.getSearchResults(this.searchTerm)) : this.classList.add(B);
            }
            onFocus() {
                super.onFocus(), this.currentSearchTerm.length && (this.searchTerm !== this.currentSearchTerm ? this.onChange() : "true" === this.getAttribute("results") ? this.open() : this.getSearchResults(this.searchTerm));
            }
            getSearchResults(t) {
                let e = t.replace(" ", "-").toLowerCase(),
                    i = parseInt(window.theme.settings.suggestionsResultsLimit),
                    s = "query";
                (s += window.theme.settings.suggestArticles ? ",article" : ""),
                    (s += window.theme.settings.suggestCollections ? ",collection" : ""),
                    (s += window.theme.settings.suggestProducts ? ",product" : ""),
                    (s += window.theme.settings.suggestPages ? ",page" : ""),
                    this.setLiveRegionLoadingState(),
                    this.cachedResults[e]
                        ? this.renderSearchResults(this.cachedResults[e])
                        : fetch(`${theme.routes.predictiveSearchUrl}?q=${encodeURIComponent(t)}&resources[type]=${s}&resources[limit]=${i}&section_id=api-predictive-search`, { signal: this.abortController.signal })
                              .then((t) => {
                                  if (!t.ok) {
                                      var e = Error(t.status);
                                      throw (this.close(), e);
                                  }
                                  return t.text();
                              })
                              .then((t) => {
                                  let i = new DOMParser().parseFromString(t, "text/html").querySelector("#shopify-section-api-predictive-search").innerHTML;
                                  this.allPredictiveSearchInstances.forEach((t) => {
                                      t.cachedResults[e] = i;
                                  }),
                                      this.renderSearchResults(i);
                              })
                              .catch((t) => {
                                  if (20 !== (null == t ? void 0 : t.code)) throw (this.close(), t);
                              });
            }
            switchOption(t) {
                super.switchOption(t), this.statusElement && (this.statusElement.textContent = "");
            }
            setLiveRegionLoadingState() {
                (this.statusElement = this.statusElement || this.querySelector("[data-predictive-search-status]")),
                    (this.loadingText = this.loadingText || this.getAttribute("data-loading-text")),
                    this.setLiveRegionText(this.loadingText),
                    this.setAttribute("loading", !0);
            }
            setLiveRegionText(t) {
                this.statusElement.setAttribute("aria-hidden", "false"),
                    (this.statusElement.textContent = t),
                    setTimeout(() => {
                        this.statusElement.setAttribute("aria-hidden", "true");
                    }, 1e3);
            }
            renderSearchResults(t) {
                (this.predictiveSearchResults.innerHTML = t), this.setAttribute("results", !0), this.setLiveRegionResults(), this.open();
            }
            setLiveRegionResults() {
                this.removeAttribute("loading"), this.setLiveRegionText(this.querySelector("[data-predictive-search-live-region-count-value]").textContent);
            }
            open() {
                this.setAttribute("open", !0);
            }
            close(t = !1) {
                this.closeResults(t);
            }
            closeResults(t = !1) {
                t && (this.reset(), this.removeAttribute("results"), this.classList.remove(B)), this.removeAttribute("loading"), this.removeAttribute("open");
            }
            clearResultsHTML() {
                this.predictiveSearchResults.innerHTML = "";
            }
            constructor() {
                super(),
                    (this.abortController = new AbortController()),
                    (this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search")),
                    (this.predictiveSearchResults = this.querySelector("[data-predictive-search-results]")),
                    (this.cachedResults = {});
            }
        }
    ),
        (window.requestIdleCallback =
            window.requestIdleCallback ||
            function (t) {
                var e = Date.now();
                return setTimeout(function () {
                    t({
                        didTimeout: !1,
                        timeRemaining: function () {
                            return Math.max(0, 50 - (Date.now() - e));
                        },
                    });
                }, 1);
            }),
        (window.cancelIdleCallback =
            window.cancelIdleCallback ||
            function (t) {
                clearTimeout(t);
            }),
        window.addEventListener(
            "resize",
            o(function t() {
                document.dispatchEvent(new CustomEvent("theme:resize", { bubbles: !0 })),
                    window.lastWindowWidth !== window.innerWidth && (document.dispatchEvent(new CustomEvent("theme:resize:width", { bubbles: !0 })), (window.lastWindowWidth = window.innerWidth));
            }, 50)
        ),
        window.addEventListener(
            "scroll",
            function () {
                z && window.cancelAnimationFrame(z),
                    (z = window.requestAnimationFrame(function () {
                        !(function () {
                            let t = window.pageYOffset;
                            t > k ? (($ = !0), (w = !1)) : t < k ? (($ = !1), (w = !0)) : ((w = null), ($ = null)),
                                (k = t),
                                document.dispatchEvent(new CustomEvent("theme:scroll", { detail: { up: w, down: $, position: t }, bubbles: !1 })),
                                w && !A && document.dispatchEvent(new CustomEvent("theme:scroll:up", { detail: { position: t }, bubbles: !1 })),
                                $ && !q && document.dispatchEvent(new CustomEvent("theme:scroll:down", { detail: { position: t }, bubbles: !1 })),
                                (q = $),
                                (A = w);
                        })();
                    }));
            },
            { passive: !0 }
        ),
        window.addEventListener("theme:scroll:lock", function e(i) {
            setTimeout(() => {
                C && clearTimeout(C), t.disablePageScroll(i.detail, { allowTouchMove: (t) => "TEXTAREA" === t.tagName }), document.documentElement.setAttribute("data-scroll-locked", "");
            });
        }),
        window.addEventListener("theme:scroll:unlock", function t(e) {
            let i = e.detail;
            i ? (C = setTimeout(P, i)) : P();
        }),
        "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
            ? ((document.documentElement.className = document.documentElement.className.replace("no-touch", "supports-touch")), (window.theme.touch = !0))
            : (window.theme.touch = !1),
        document.addEventListener(
            "load",
            (t) => {
                "IMG" == t.target.tagName && t.target.classList.contains(x.loading) && (t.target.classList.remove(x.loading), t.target.parentNode.classList.remove(x.loading));
            },
            !0
        );
    let W = o(() => {
        a();
    }, 300);
    window.addEventListener("DOMContentLoaded", () => {
        c(),
            L(document),
            F(document),
            H(document),
            document.documentElement.classList.remove("is-loading"),
            document.documentElement.classList.add("is-loaded"),
            window.fastNetworkAndCPU &&
                ((document.onreadystatechange = () => {
                    "complete" === document.readyState && ((v = !0), f());
                }),
                requestIdleCallback(f));
    }),
        document.addEventListener("shopify:section:load", (t) => {
            let e = t.target;
            window.dispatchEvent(new Event("resize"), { bubbles: !0 }), L(e), F(e), c(), W();
        }),
        document.addEventListener("shopify:section:reorder", () => {
            W();
        }),
        document.addEventListener("shopify:section:unload", () => {
            W();
        }),
        (function () {
            function t(t) {
                var e = window.innerWidth || document.documentElement.clientWidth,
                    i = window.innerHeight || document.documentElement.clientHeight,
                    s = t.getBoundingClientRect();
                return s.top >= 0 && s.bottom <= i && s.left >= 0 && s.right <= e;
            }
            function e(t) {
                var e = window.innerWidth || document.documentElement.clientWidth,
                    i = window.innerHeight || document.documentElement.clientHeight,
                    s = t.getBoundingClientRect(),
                    r = (s.left >= 0 && s.left <= e) || (s.right >= 0 && s.right <= e),
                    o = (s.top >= 0 && s.top <= i) || (s.bottom >= 0 && s.bottom <= i);
                return r && o;
            }
            window.visibilityHelper = {
                isElementTotallyVisible: t,
                isElementPartiallyVisible: e,
                inViewportPartially: function (t, i) {
                    function s() {
                        var s = e(t);
                        s != r && ((r = s), "function" == typeof i && i(s, t));
                    }
                    var r = e(t);
                    window.addEventListener("load", s), window.addEventListener("resize", s), window.addEventListener("scroll", s);
                },
                inViewportTotally: function (e, i) {
                    function s() {
                        var s = t(e);
                        s != r && ((r = s), "function" == typeof i && i(s, e));
                    }
                    var r = t(e);
                    window.addEventListener("load", s), window.addEventListener("resize", s), window.addEventListener("scroll", s);
                },
            };
        })(),
        (window.Shopify = window.Shopify || {}),
        (window.Shopify.theme = window.Shopify.theme || {}),
        (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
        (window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}),
        (window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || []);
    let R = window.Shopify.theme.sections.registered,
        V = window.Shopify.theme.sections.instances,
        N = { id: "data-section-id", type: "data-section-type" },
        U = class {
            getStack() {
                return this.callStack;
            }
            constructor(t = null, e = []) {
                (this.type = t),
                    (this.components = (function (t) {
                        if ((void 0 !== t && "object" != typeof t) || null === t) throw TypeError("Theme Sections: The components object provided is not a valid");
                        return t;
                    })(e)),
                    (this.callStack = { onLoad: [], onUnload: [], onSelect: [], onDeselect: [], onBlockSelect: [], onBlockDeselect: [], onReorder: [] }),
                    e.forEach((t) => {
                        for (let [e, i] of Object.entries(t)) {
                            let s = this.callStack[e];
                            Array.isArray(s) && "function" == typeof i ? s.push(i) : (console.warn(`Unregisted function: '${e}' in component: '${this.type}'`), console.warn(i));
                        }
                    });
            }
        },
        j = class {
            callFunctions(t, e = null) {
                this.callStack[t].forEach((t) => {
                    let i = { id: this.id, type: this.type, container: this.container };
                    e ? t.call(i, e) : t.call(i);
                });
            }
            onLoad() {
                this.callFunctions("onLoad");
            }
            onUnload() {
                this.callFunctions("onUnload");
            }
            onSelect(t) {
                this.callFunctions("onSelect", t);
            }
            onDeselect(t) {
                this.callFunctions("onDeselect", t);
            }
            onBlockSelect(t) {
                this.callFunctions("onBlockSelect", t);
            }
            onBlockDeselect(t) {
                this.callFunctions("onBlockDeselect", t);
            }
            onReorder(t) {
                this.callFunctions("onReorder", t);
            }
            constructor(t, e) {
                (this.container = (function (t) {
                    if (!(t instanceof Element)) throw TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
                    if (null === t.getAttribute(N.id)) throw Error("Theme Sections: The section container provided does not have an id assigned to the " + N.id + " attribute.");
                    return t;
                })(t)),
                    (this.id = t.getAttribute(N.id)),
                    (this.type = e.type),
                    (this.callStack = e.getStack());
                try {
                    this.onLoad();
                } catch (i) {
                    console.warn(`Error in section: ${this.id}`), console.warn(this), console.warn(i);
                }
            }
        };
    function K(t, e) {
        if ("string" != typeof t) throw TypeError("Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered");
        if (void 0 !== R[t]) throw Error('Theme Sections: A section of type "' + t + '" has already been registered. You cannot register the same section type twice');
        Array.isArray(e) || (e = [e]);
        let i = new U(t, e);
        return (R[t] = i), R;
    }
    function Q(t, e) {
        (t = J(t)),
            void 0 === e && (e = document.querySelectorAll("[" + N.type + "]")),
            (e = Y(e)),
            t.forEach(function (t) {
                let i = R[t];
                void 0 !== i &&
                    (e = e.filter(function (e) {
                        return !(G(e).length > 0) && null !== e.getAttribute(N.type) && (e.getAttribute(N.type) !== t || (V.push(new j(e, i)), !1));
                    }));
            });
    }
    function G(t) {
        var e = [];
        if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var i = t[0];
        return (
            t instanceof Element || i instanceof Element
                ? Y(t).forEach(function (t) {
                      e = e.concat(
                          V.filter(function (e) {
                              return e.container === t;
                          })
                      );
                  })
                : ("string" == typeof t || "string" == typeof i) &&
                  J(t).forEach(function (t) {
                      e = e.concat(
                          V.filter(function (e) {
                              return e.type === t;
                          })
                      );
                  }),
            e
        );
    }
    function X(t) {
        for (var e, i = 0; i < V.length; i++)
            if (V[i].id === t) {
                e = V[i];
                break;
            }
        return e;
    }
    function J(t) {
        return (
            "*" === t
                ? (t = Object.keys(R))
                : "string" == typeof t
                ? (t = [t])
                : t.constructor === j
                ? (t = [t.prototype.type])
                : Array.isArray(t) &&
                  t[0].constructor === j &&
                  (t = t.map(function (t) {
                      return t.type;
                  })),
            (t = t.map(function (t) {
                return t.toLowerCase();
            }))
        );
    }
    function Y(t) {
        return (
            NodeList.prototype.isPrototypeOf(t) && t.length > 0
                ? (t = Array.prototype.slice.call(t))
                : (NodeList.prototype.isPrototypeOf(t) && 0 === t.length) || null === t
                ? (t = [])
                : !Array.isArray(t) && t instanceof Element && (t = [t]),
            t
        );
    }
    window.Shopify.designMode &&
        (document.addEventListener("shopify:section:load", function (t) {
            var e = t.detail.sectionId,
                i = t.target.querySelector("[" + N.id + '="' + e + '"]');
            null !== i && Q(i.getAttribute(N.type), i);
        }),
        document.addEventListener("shopify:section:reorder", function (t) {
            var e = t.detail.sectionId,
                i = t.target.querySelector("[" + N.id + '="' + e + '"]');
            "object" == typeof G(i)[0] &&
                G(i).forEach(function (t) {
                    t.onReorder();
                });
        }),
        document.addEventListener("shopify:section:unload", function (t) {
            var e = t.detail.sectionId,
                i = t.target.querySelector("[" + N.id + '="' + e + '"]');
            "object" == typeof G(i)[0] &&
                G(i).forEach(function (t) {
                    var e = V.map(function (t) {
                        return t.id;
                    }).indexOf(t.id);
                    V.splice(e, 1), t.onUnload();
                });
        }),
        document.addEventListener("shopify:section:select", function (t) {
            var e = X(t.detail.sectionId);
            "object" == typeof e && e.onSelect(t);
        }),
        document.addEventListener("shopify:section:deselect", function (t) {
            var e = X(t.detail.sectionId);
            "object" == typeof e && e.onDeselect(t);
        }),
        document.addEventListener("shopify:block:select", function (t) {
            var e = X(t.detail.sectionId);
            "object" == typeof e && e.onBlockSelect(t);
        }),
        document.addEventListener("shopify:block:deselect", function (t) {
            var e = X(t.detail.sectionId);
            "object" == typeof e && e.onBlockDeselect(t);
        }));
    let Z = (t, e) => {
        let i, s;
        return function r(...o) {
            let a = Date.now();
            (s = clearTimeout(s)), !i || a - i >= e ? (t.apply(null, o), (i = a)) : (s = setTimeout(r.bind(null, ...o), e - (a - i)));
        };
    };
    function tt(t) {
        (this.status = t.status || null), (this.headers = t.headers || null), (this.json = t.json || null), (this.body = t.body || null);
    }
    tt.prototype = Error.prototype;
    let te = "[data-collapsible-trigger]",
        ti = "[data-collapsible-content]",
        ts = "is-expanded",
        tr = "aria-expanded",
        to = "aria-controls",
        ta = {},
        tn = class {
            init() {
                this.triggers.forEach((t) => {
                    t.addEventListener("click", this.collapsibleToggleEvent), t.addEventListener("keyup", this.collapsibleToggleEvent);
                });
            }
            collapsibleToggle(t) {
                t.preventDefault();
                let e = t.target.matches(te) ? t.target : t.target.closest(te),
                    i = e.getAttribute(to),
                    s = document.getElementById(i),
                    r = e.hasAttribute("data-collapsible-trigger-mobile"),
                    o = e.classList.contains(ts),
                    a = t.code === theme.keyboardKeys.SPACE,
                    n = t.code === theme.keyboardKeys.ESCAPE,
                    l = window.innerWidth < theme.sizes.small;
                (this.isTransitioning && !this.transitionOverride) ||
                    ((!t.code || a || n) &&
                        ((!o && n) ||
                            (r && !l) ||
                            ((this.isTransitioning = !0),
                            (e.disabled = !0),
                            this.single &&
                                this.triggers.forEach((t) => {
                                    let i = t.classList.contains(ts);
                                    if (e == t || !i) return;
                                    let s = t.getAttribute(to),
                                        r = document.getElementById(s);
                                    requestAnimationFrame(() => {
                                        this.closeItem(r, t);
                                    });
                                }),
                            o
                                ? requestAnimationFrame(() => {
                                      this.closeItem(s, e);
                                  })
                                : requestAnimationFrame(() => {
                                      this.openItem(s, e);
                                  }))));
            }
            openItem(t, e) {
                let i = t.querySelector(ti),
                    s = i.offsetHeight;
                "mobile-nav__sublist" == i.className && (s += 80),
                    this.setDropdownHeight(t, s, e, !0),
                    e.classList.add(ts),
                    e.setAttribute(tr, !0),
                    e.dispatchEvent(new CustomEvent("theme:form:sticky", { bubbles: !0, detail: { element: "accordion" } }));
            }
            closeItem(t, e) {
                let i = t.querySelector(ti).offsetHeight;
                requestAnimationFrame(() => {
                    (i = 0), this.setDropdownHeight(t, i, e, !1), e.classList.remove(ts);
                }),
                    this.setDropdownHeight(t, i, e, !1),
                    e.classList.remove(ts),
                    e.setAttribute(tr, !1);
            }
            setDropdownHeight(t, e, i, s) {
                (t.style.height = `${e}px`),
                    t.setAttribute(tr, s),
                    t.classList.toggle(ts, s),
                    this.resetHeightTimer && clearTimeout(this.resetHeightTimer),
                    0 == e &&
                        (this.resetHeightTimer = setTimeout(() => {
                            t.style.height = "";
                        }, 500)),
                    s
                        ? (this.resetHeightTimer = setTimeout(() => {
                              (t.style.height = "auto"), (this.isTransitioning = !1);
                          }, 500))
                        : (this.isTransitioning = !1),
                    setTimeout(() => {
                        i.disabled = !1;
                    }, 500);
            }
            onUnload() {
                this.triggers.forEach((t) => {
                    t.removeEventListener("click", this.collapsibleToggleEvent), t.removeEventListener("keyup", this.collapsibleToggleEvent);
                });
            }
            constructor(t) {
                (this.container = t),
                    (this.single = this.container.querySelector("[data-collapsible-single]")),
                    (this.triggers = this.container.querySelectorAll(te)),
                    (this.resetHeightTimer = 0),
                    (this.isTransitioning = !1),
                    (this.transitionOverride = this.container.hasAttribute("data-collapsible-transition-override")),
                    (this.collapsibleToggleEvent = (t) => Z(this.collapsibleToggle(t), 1250)),
                    this.init();
            }
        },
        tl = {
            onLoad() {
                ta[this.id] = new tn(this.container);
            },
            onUnload() {
                ta[this.id].onUnload();
            },
        },
        th = "[data-quantity-minus]",
        tc = "[data-quantity-plus]",
        td = class {
            init() {
                (this.quantity = this.holder.querySelector("[data-quantity-holder]")),
                    this.quantity &&
                        ((this.field = this.quantity.querySelector("[data-quantity-field]")),
                        (this.buttons = this.quantity.querySelectorAll("[data-quantity-button]")),
                        (this.increaseButton = this.quantity.querySelector(tc)),
                        (this.quantityValue = Number(this.field.value || 0)),
                        (this.cartItemID = this.field.getAttribute("data-id")),
                        (this.maxValue = Number(this.field.getAttribute("max")) > 0 ? Number(this.field.getAttribute("max")) : null),
                        (this.minValue = Number(this.field.getAttribute("min")) > 0 ? Number(this.field.getAttribute("min")) : 0),
                        (this.disableIncrease = this.disableIncrease.bind(this)),
                        (this.emptyField = !1),
                        (this.updateQuantity = this.updateQuantity.bind(this)),
                        (this.decrease = this.decrease.bind(this)),
                        (this.increase = this.increase.bind(this)),
                        this.disableIncrease(),
                        this.quantity.classList.contains("read-only") || (this.changeValueOnClick(), this.changeValueOnInput()));
            }
            changeValueOnClick() {
                this.buttons.forEach((t) => {
                    t.addEventListener("click", (t) => {
                        t.preventDefault(), (this.quantityValue = Number(this.field.value || 0));
                        let e = t.target,
                            i = e.matches(th) || e.closest(th),
                            s = e.matches(tc) || e.closest(tc);
                        i && this.decrease(), s && this.increase(), this.updateQuantity();
                    });
                });
            }
            changeValueOnInput() {
                this.field.addEventListener("input", () => {
                    (this.quantityValue = this.field.value), this.updateQuantity();
                });
            }
            updateQuantity() {
                this.maxValue < this.quantityValue && null !== this.maxValue && (this.quantityValue = this.maxValue),
                    this.minValue > this.quantityValue && (this.quantityValue = this.minValue),
                    (this.field.value = this.quantityValue),
                    this.disableIncrease(),
                    document.dispatchEvent(new CustomEvent("theme:cart:update")),
                    this.quantityUpdateCart && this.updateCart();
            }
            decrease() {
                this.quantityValue > this.minValue ? this.quantityValue-- : (this.quantityValue = 0);
            }
            increase() {
                this.quantityValue++;
            }
            disableIncrease() {
                this.increaseButton.classList.toggle("is-disabled", this.quantityValue >= this.maxValue && null !== this.maxValue);
            }
            updateCart() {
                if ("" === this.quantityValue) return;
                let t = new CustomEvent("theme:cart:update", { bubbles: !0, detail: { id: this.cartItemID, quantity: this.quantityValue } });
                this.holder.dispatchEvent(t);
            }
            constructor(t, e = !1) {
                (this.holder = t), (this.quantityUpdateCart = e);
            }
        },
        tu = {
            state: { firstFocusable: null, lastFocusable: null, trigger: null },
            trapFocus: function (t) {
                var e = Array.from(t.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])')).filter(function (t) {
                    var e = t.offsetWidth,
                        i = t.offsetHeight;
                    return 0 !== e && 0 !== i && "none" !== getComputedStyle(t).getPropertyValue("display");
                });
                (e = e.filter(function (t) {
                    return !t.classList.contains("deferred-media__poster");
                })),
                    (this.state.firstFocusable = e[0]),
                    (this.state.lastFocusable = e[e.length - 1]),
                    t.elementToFocus || (t.elementToFocus = this.state.firstFocusable || t.container),
                    this._setupHandlers(),
                    document.addEventListener("focusin", this._onFocusInHandler),
                    document.addEventListener("focusout", this._onFocusOutHandler),
                    t.container.setAttribute("tabindex", "-1"),
                    t.elementToFocus.focus();
            },
            removeTrapFocus: function (t) {
                let e = !document.body.classList.contains("no-outline");
                t && t.container && t.container.removeAttribute("tabindex"), document.removeEventListener("focusin", this._onFocusInHandler), this.state.trigger && e && this.state.trigger.focus();
            },
            _manageFocus: function (t) {
                t.code === theme.keyboardKeys.TAB &&
                    (t.target !== this.state.lastFocusable || t.shiftKey || (t.preventDefault(), this.state.firstFocusable.focus()),
                    t.target === this.state.firstFocusable && t.shiftKey && (t.preventDefault(), this.state.lastFocusable.focus()));
            },
            _onFocusOut: function () {
                document.removeEventListener("keydown", this._manageFocusHandler);
            },
            _onFocusIn: function (t) {
                (t.target !== this.state.lastFocusable && t.target !== this.state.firstFocusable) || document.addEventListener("keydown", this._manageFocusHandler);
            },
            _setupHandlers: function () {
                this._onFocusInHandler || (this._onFocusInHandler = this._onFocusIn.bind(this)),
                    this._onFocusOutHandler || (this._onFocusOutHandler = this._onFocusIn.bind(this)),
                    this._manageFocusHandler || (this._manageFocusHandler = this._manageFocus.bind(this));
            },
        },
        tp = {};
    function tm(t = {}) {
        if ((t.type || (t.type = "json"), t.url))
            return tp[t.url]
                ? tp[t.url]
                : (function (t, e) {
                      let i = new Promise((i, s) => {
                          var r, o, a;
                          let n, l, h;
                          "text" === e
                              ? fetch(t)
                                    .then((t) => t.text())
                                    .then((t) => {
                                        i(t);
                                    })
                                    .catch((t) => {
                                        s(t);
                                    })
                              : ((r = t),
                                (o = function () {
                                    i();
                                }),
                                (a = function () {
                                    s();
                                }),
                                (n = document.getElementsByTagName("head")[0]),
                                (l = !1),
                                ((h = document.createElement("script")).src = r),
                                (h.onload = h.onreadystatechange = function () {
                                    l || (this.readyState && "loaded" != this.readyState && "complete" != this.readyState) ? a() : ((l = !0), o());
                                }),
                                n.appendChild(h));
                      });
                      return (tp[t] = i), i;
                  })(t.url, t.type);
        if (t.json)
            return tp[t.json]
                ? Promise.resolve(tp[t.json])
                : window
                      .fetch(t.json)
                      .then((t) => t.json())
                      .then((e) => ((tp[t.json] = e), e));
        if (t.name) {
            let e = "".concat(t.name, t.version);
            return tp[e]
                ? tp[e]
                : (function (t) {
                      let e = "".concat(t.name, t.version),
                          i = new Promise((e, i) => {
                              try {
                                  window.Shopify.loadFeatures([
                                      {
                                          name: t.name,
                                          version: t.version,
                                          onLoad(t) {
                                              var s, r, o;
                                              (s = e), (r = i), (o = t) ? r(o) : s();
                                          },
                                      },
                                  ]);
                              } catch (s) {
                                  i(s);
                              }
                          });
                      return (tp[e] = i), i;
                  })(t);
        }
        return Promise.reject();
    }
    (window.isYoutubeAPILoaded = !1), (window.isVimeoAPILoaded = !1);
    let tg = { videoIframe: "[data-video-id]", videoWrapper: ".video-wrapper", youtubeWrapper: "[data-youtube-wrapper]" },
        ty = [],
        tv = "notification-popup-visible";
    function tf(t) {
        let i = e.data(t);
        i &&
            (i.on("dragStart", (t, e) => {
                document.ontouchmove = function (t) {
                    t.preventDefault();
                };
            }),
            i.on("dragEnd", (t, e) => {
                document.ontouchmove = function (t) {
                    return !0;
                };
            }));
    }
    let tb = "html5",
        tS = "youtube",
        tE = "vimeo",
        tL = "[data-deferred-media]",
        tk = class {
            init() {
                this.container.querySelectorAll("[data-video]").forEach((t) => {
                    let e = t.querySelector("[data-deferred-media-button]");
                    e && e.addEventListener("click", this.loadContent.bind(this, t)), this.autoplayVideo && this.loadContent(t);
                });
            }
            loadContent(t) {
                if (t.querySelector(tL).getAttribute("loaded")) return;
                let e = document.createElement("div");
                e.appendChild(t.querySelector("template").content.firstElementChild.cloneNode(!0));
                let i = t.dataset.mediaId,
                    s = e.querySelector("video, iframe"),
                    r = this.hostFromVideoElement(s),
                    o = t.querySelector(tL);
                o.appendChild(s),
                    o.setAttribute("loaded", !0),
                    (this.players[i] = {
                        mediaId: i,
                        sectionId: this.id,
                        container: t,
                        element: s,
                        host: r,
                        ready: () => {
                            this.createPlayer(i);
                        },
                    });
                let a = this.players[i];
                switch (a.host) {
                    case tb:
                        this.loadVideo(a, tb);
                        break;
                    case tE:
                        window.isVimeoAPILoaded ? this.loadVideo(a, tE) : tm({ url: "https://player.vimeo.com/api/player.js" }).then(() => this.loadVideo(a, tE));
                        break;
                    case tS:
                        window.isYoutubeAPILoaded ? this.loadVideo(a, tS) : tm({ url: "https://www.youtube.com/iframe_api" }).then(() => this.loadVideo(a, tS));
                }
            }
            hostFromVideoElement(t) {
                if ("VIDEO" === t.tagName) return tb;
                if ("IFRAME" === t.tagName) {
                    if (/^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(t.src)) return tS;
                    if (t.src.includes("vimeo.com")) return tE;
                }
                return null;
            }
            loadVideo(t, e) {
                t.host === e && t.ready();
            }
            createPlayer(t) {
                let e = this.players[t];
                switch (e.host) {
                    case tb:
                        e.element.addEventListener("play", () => {
                            e.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 });
                        }),
                            e.element.addEventListener("pause", () => {
                                e.container.dispatchEvent(new CustomEvent("theme:media:pause"), { bubbles: !0 });
                            }),
                            this.autoplayVideo && this.observeVideo(e, t);
                        break;
                    case tE:
                        (e.player = new Vimeo.Player(e.element)),
                            e.player.play(),
                            e.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 }),
                            (window.isVimeoAPILoaded = !0),
                            e.player.on("play", () => {
                                e.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 });
                            }),
                            e.player.on("pause", () => {
                                e.container.dispatchEvent(new CustomEvent("theme:media:pause"), { bubbles: !0 });
                            }),
                            this.autoplayVideo && this.observeVideo(e, t);
                        break;
                    case tS:
                        if (e.host == tS && e.player) return;
                        YT.ready(() => {
                            let i = e.container.dataset.videoId;
                            (e.player = new YT.Player(e.element, {
                                videoId: i,
                                events: {
                                    onReady(t) {
                                        t.target.playVideo(), e.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 });
                                    },
                                    onStateChange(t) {
                                        1 == t.data && e.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 }),
                                            2 == t.data && e.container.dispatchEvent(new CustomEvent("theme:media:pause"), { bubbles: !0 }),
                                            0 == t.data && e.container.dispatchEvent(new CustomEvent("theme:media:pause"), { bubbles: !0 });
                                    },
                                },
                            })),
                                (window.isYoutubeAPILoaded = !0),
                                this.autoplayVideo && this.observeVideo(e, t);
                        });
                }
                e.container.addEventListener("theme:media:visible", (t) => this.onVisible(t)), e.container.addEventListener("theme:media:hidden", (t) => this.onHidden(t)), e.container.addEventListener("xrLaunch", (t) => this.onHidden(t));
            }
            observeVideo(t) {
                new IntersectionObserver(
                    (e, i) => {
                        e.forEach((e) => {
                            let i = 0 == e.intersectionRatio,
                                s = !t.element.closest(".media--hidden");
                            i ? this.pauseVideo(t) : s && this.playVideo(t);
                        });
                    },
                    { rootMargin: "200px", threshold: [0, 0.25, 0.75, 1] }
                ).observe(t.element);
            }
            playVideo(t) {
                t.player && t.player.playVideo ? t.player.playVideo() : t.element && t.element.play ? t.element.play() : t.player && t.player.play && t.player.play(),
                    t.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 });
            }
            pauseVideo(t) {
                if (t.player && t.player.pauseVideo) "1" == t.player.playerInfo.playerState && t.player.pauseVideo();
                else if (t.player && t.player.pause) t.player.pause();
                else if (t.element && !t.element.paused) {
                    var e;
                    null === (e = t.element) || void 0 === e || e.pause();
                }
            }
            onHidden(t) {
                if (void 0 !== t.target.dataset.mediaId) {
                    let e = t.target.dataset.mediaId,
                        i = this.players[e];
                    this.pauseVideo(i);
                }
            }
            onVisible(t) {
                if (void 0 !== t.target.dataset.mediaId) {
                    let e = t.target.dataset.mediaId,
                        i = this.players[e];
                    setTimeout(() => {
                        this.playVideo(i);
                    }, 50),
                        this.pauseContainerMedia(e);
                }
            }
            pauseOtherMedia(t, e) {
                let i = `[data-media-id="${t}"]`,
                    s = e.querySelectorAll(`[data-product-single-media-wrapper]:not(${i})`);
                s.length &&
                    s.forEach((t) => {
                        t.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }), t.classList.add("media--hidden");
                    });
            }
            constructor(t) {
                (this.container = t),
                    (this.id = this.container.getAttribute("data-section-id")),
                    (this.autoplayVideo = "true" === this.container.getAttribute("data-autoplay-video")),
                    (this.players = {}),
                    (this.pauseContainerMedia = (t, e = this.container) => this.pauseOtherMedia(t, e)),
                    this.init();
            }
        };
    function tw(t, e, i = [], s = !1) {
        let r = new FormData(t),
            o = new URLSearchParams(r);
        if (!e) return o.toString();
        let a = new FormData(e),
            n = new URLSearchParams(a),
            l = [];
        for (let h of r.entries()) "" === h[1] && l.push(h[0]);
        for (let c of a.entries()) "" === c[1] && l.push(c[0]);
        for (let d = 0; d < l.length; d++) {
            let u = l[d];
            o.has(u) && o.delete(u), n.has(u) && n.delete(u);
        }
        for (let p of o.keys()) n.has(p) && n.delete(p);
        if (i.length > 0)
            for (let m = 0; m < i.length; m++) {
                let g = i[m];
                o.has(g) && o.delete(g), n.has(g) && n.delete(g);
            }
        return s && (n.has("type") && n.delete("type"), o.set("type", s)), `${o.toString()}&${n.toString()}`;
    }
    let t$ = class {
            calculateTrack(t) {
                if (!t) return this.scrollbar.style.setProperty("--thumb-scale", 0), void this.scrollbar.style.setProperty("--thumb-position", "0px");
                let e = t.clientWidth / this.scrollbarThumb.parentElement.clientWidth,
                    i = t.offsetLeft / this.scrollbarThumb.parentElement.clientWidth;
                this.scrollbar.style.setProperty("--thumb-scale", e), this.scrollbar.style.setProperty("--thumb-position", this.trackWidth * i + "px");
            }
            calculateScrollbar() {
                if (this.scrollbarItems.children.length) {
                    let t = [...this.scrollbarItems.children];
                    (this.trackWidth = 0),
                        t.forEach((t) => {
                            this.trackWidth += t.getBoundingClientRect().width + parseInt(window.getComputedStyle(t).marginRight);
                        }),
                        this.scrollbar.style.setProperty("--track-width", `${this.trackWidth}px`);
                }
            }
            onScrollbarChange(t) {
                t && t.detail && t.detail.element && this.container.contains(t.detail.element) && this.calculateTrack(t.detail.element);
            }
            events() {
                document.addEventListener("theme:resize:width", this.calcScrollbarEvent), document.addEventListener("theme:custom-scrollbar:change", this.onScrollbarChangeEvent);
            }
            unload() {
                document.removeEventListener("theme:resize:width", this.calcScrollbarEvent), document.removeEventListener("theme:custom-scrollbar:change", this.onScrollbarChangeEvent);
            }
            constructor(t) {
                (this.container = t),
                    (this.scrollbarItems = t.querySelector("[data-custom-scrollbar-items]")),
                    (this.scrollbar = t.querySelector("[data-custom-scrollbar]")),
                    (this.scrollbarThumb = t.querySelector("[data-custom-scrollbar-thumb]")),
                    (this.trackWidth = 0),
                    (this.calcScrollbarEvent = () => this.calculateScrollbar()),
                    (this.onScrollbarChangeEvent = (t) => this.onScrollbarChange(t)),
                    this.scrollbar && this.scrollbarItems && (this.events(), this.calculateScrollbar(), this.scrollbarItems.children.length && this.calculateTrack(this.scrollbarItems.querySelector(".current")));
            }
        },
        tA = "[data-tooltip-container]",
        tq = "is-animating",
        tC = "is-visible",
        tT = "is-hiding",
        tP = "data-tooltip",
        t_ = "data-tooltip-stop-mouseenter",
        tF = {},
        tx = class {
            init() {
                if (!document.querySelector(tA)) {
                    let t = `<div class="${this.rootClass}__inner"><div class="${this.rootClass}__arrow" data-tooltip-arrow></div><div class="${this.rootClass}__text"></div></div>`,
                        e = document.createElement("div");
                    (e.className = `${this.rootClass} ${this.isAnimatingClass}`), e.setAttribute("data-tooltip-container", ""), (e.innerHTML = t), document.body.appendChild(e);
                }
                this.tooltip.addEventListener("mouseenter", this.addPinMouseEvent),
                    this.tooltip.addEventListener("mouseleave", this.removePinMouseEvent),
                    this.tooltip.addEventListener("theme:tooltip:init", this.addPinEvent),
                    document.addEventListener("theme:tooltip:close", this.removePinEvent);
                let i = document.querySelector(tA);
                theme.settings.animations &&
                    this.animatedContainer &&
                    this.animatedContainer.addEventListener("transitionend", (t) => {
                        "transform" === t.propertyName && i.classList.remove(tq);
                    });
            }
            addPin(t = !1) {
                let e = document.querySelector(tA),
                    i = e.querySelector("[data-tooltip-arrow]");
                if (e && ((t && !this.tooltip.hasAttribute(t_)) || !t)) {
                    let s = e.querySelector(`.${this.rootClass}__inner`);
                    e.querySelector(`.${this.rootClass}__text`).textContent = this.label;
                    let r = s.offsetWidth,
                        o = this.tooltip.getBoundingClientRect(),
                        a = o.top,
                        n = o.width,
                        l = a + o.height + window.scrollY,
                        h = o.left - r / 2 + n / 2,
                        c = "50%",
                        d = h + r - window.innerWidth;
                    d > 0 && (h -= d),
                        h < 0 && ((c = `calc(50% + ${h}px)`), (h = 0)),
                        (i.style.left = c),
                        (e.style.transform = `translate(${h}px, ${l}px)`),
                        e.classList.remove(tT),
                        e.classList.add(tC),
                        document.addEventListener("theme:scroll", this.removePinEvent);
                }
            }
            removePin(t, e = !1, i = !1) {
                let s = document.querySelector(tA),
                    r = s.classList.contains(tC);
                s &&
                    ((e && !this.tooltip.hasAttribute(t_)) || !e) &&
                    (r &&
                        (i || t.detail.hideTransition) &&
                        (s.classList.add(tT),
                        this.hideTransitionTimeout && clearTimeout(this.hideTransitionTimeout),
                        (this.hideTransitionTimeout = setTimeout(() => {
                            s.classList.remove(tT);
                        }, this.transitionSpeed))),
                    s.classList.remove(tC),
                    (s.style.transform = "translate(100%, 0)"),
                    document.removeEventListener("theme:scroll", this.removePinEvent));
            }
            unload() {
                this.tooltip.removeEventListener("mouseenter", this.addPinMouseEvent),
                    this.tooltip.removeEventListener("mouseleave", this.removePinMouseEvent),
                    this.tooltip.removeEventListener("theme:tooltip:init", this.addPinEvent),
                    document.removeEventListener("theme:tooltip:close", this.removePinEvent),
                    document.removeEventListener("theme:scroll", this.removePinEvent);
            }
            constructor(t) {
                (this.tooltip = t),
                    this.tooltip.hasAttribute(tP) &&
                        ((this.rootClass = "tooltip-default"),
                        (this.isAnimatingClass = tq),
                        (this.label = this.tooltip.getAttribute(tP)),
                        (this.transitionSpeed = 200),
                        (this.hideTransitionTimeout = 0),
                        (this.animatedContainer = this.tooltip.closest("[data-aos]")),
                        (this.addPinEvent = () => this.addPin()),
                        (this.addPinMouseEvent = () => this.addPin(!0)),
                        (this.removePinEvent = (t) => Z(this.removePin(t), 50)),
                        (this.removePinMouseEvent = (t) => this.removePin(t, !0, !0)),
                        this.init());
            }
        },
        tI = {
            onLoad() {
                (tF[this.id] = []),
                    this.container.querySelectorAll("[data-tooltip]").forEach((t) => {
                        tF[this.id].push(new tx(t));
                    });
            },
            onUnload() {
                tF[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
        },
        tH = "data-se-min-value",
        tD = "data-se-max-value",
        t8 = "data-se-step";
    function tM(t) {
        return t.replace(/http(s)?:/, "");
    }
    function tO() {
        this.entries = [];
    }
    function tB(t) {
        if ("object" != typeof t) throw TypeError(t + " is not an object.");
        if (0 === Object.keys(t).length && t.constructor === Object) throw Error(t + " is empty.");
    }
    (tO.prototype.add = function (t, e, i) {
        this.entries.push({ element: t, event: e, fn: i }), t.addEventListener(e, i);
    }),
        (tO.prototype.removeAll = function () {
            this.entries = this.entries.filter(function (t) {
                return t.element.removeEventListener(t.event, t.fn), !1;
            });
        });
    let t9 = "[data-swatch]",
        tz = "product__media--featured-visible",
        tW = "product__media__hover-img--visible",
        tR = "no-outline",
        tV = "is-visible",
        tN = "selector-wrapper--large",
        tU = "data-swatch-index",
        tj = "data-variant-id",
        tK = "data-loaded",
        tQ = "data-fetched-image",
        t0 = "data-fetched-image-index",
        t3 = "data-grid-image-default",
        tG = "data-grid-image-target",
        t1 = "data-grid-image-target-default",
        tX = {},
        tJ = {},
        tY = class {
            init() {
                this.setStyles(), this.variant && this.outer && (this.handleHovers(), this.handleClicks()), !this.image && this.swatchLink && this.swatchLink.classList.add("swatch__link--no-image");
            }
            setStyles() {
                this.colorMatch && this.colorMatch.hex && this.element.style.setProperty("--swatch", `${this.colorMatch.hex}`),
                    this.colorMatch && this.colorMatch.path && this.element.style.setProperty("background-image", `url(${this.colorMatch.path})`);
            }
            handleHovers() {
                this.swatchLink.addEventListener("mouseenter", () => {
                    var t;
                    if (((this.imageReplace = null), this.imageId && !this.outer.querySelector(`[${tG}="${this.imageId}"]`) && ((this.gridImage = this.outer.querySelector("[data-grid-image]")), this.image && this.gridImage))) {
                        let e = window.devicePixelRatio || 1,
                            i = this.gridImage.offsetWidth * e;
                        if ((this.gridImage.hasAttribute(t1) ? this.gridImage.getAttribute(t1) : "") === this.imageId && this.gridImage.hasAttribute(t3)) return void (this.imageReplace = this.gridImage.getAttribute(t3));
                        if (this.element.hasAttribute(tQ)) this.imageReplace = this.element.getAttribute(tQ);
                        else {
                            let s = (function (t, e) {
                                if (null === e) return t;
                                if ((null == t && (t = window.theme.assets.noImage), "master" === e)) return tM(t);
                                let i = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);
                                if (i) {
                                    let s = t.split(i[0]),
                                        r = i[0];
                                    return tM(`${s[0]}_${e}${r}`);
                                }
                                return null;
                            })(this.image, `${180 * Math.ceil(i / 180)}x`);
                            window
                                .fetch(s)
                                .then((t) => t.blob())
                                .then((t) => {
                                    let e = URL.createObjectURL(t);
                                    (this.imageReplace = `url("${e}")`),
                                        this.element.setAttribute(tQ, this.imageReplace),
                                        this.element.hasAttribute(tU) &&
                                            this.outer.hasAttribute(t0) &&
                                            parseInt(this.element.getAttribute(tU)) === parseInt(this.outer.getAttribute(t0)) &&
                                            (this.replaceImages(), this.outer.removeAttribute(t0));
                                })
                                .catch((t) => {
                                    console.log(`Error: ${t}`);
                                });
                        }
                    }
                    if (((this.loadHovers = this.outer.querySelector("[data-load-hovers]")), this.loadHovers && !(null === (t = this.loadHovers) || void 0 === t ? void 0 : t.hasAttribute(tK)))) {
                        let r = document.createElement("div");
                        r.appendChild(this.loadHovers.querySelector("template").content.firstElementChild.cloneNode(!0)), this.loadHovers.appendChild(r), this.loadHovers.setAttribute(tK, !0);
                    }
                });
            }
            handleClicks() {
                this.swatchLink.addEventListener("click", (t) => {
                    document.body.classList.contains(tR) && (t.preventDefault(), this.updateImagesAndLinksOnEvent());
                }),
                    this.swatchLink.addEventListener("keyup", (t) => {
                        let e = !document.body.classList.contains(tR);
                        (t.code !== theme.keyboardKeys.ENTER && t.code !== theme.keyboardKeys.NUMPADENTER) ||
                            e ||
                            (t.preventDefault(), this.swatchLink.dispatchEvent(new Event("mouseenter", { bubbles: !0 })), this.updateImagesAndLinksOnEvent());
                    });
            }
            updateImagesAndLinksOnEvent() {
                this.updateLinks(), this.replaceImages();
            }
            updateLinks() {
                (this.linkElements = this.outer.querySelectorAll("[data-grid-link]")),
                    (this.quickView = this.outer.querySelector("[data-button-quick-view]")),
                    this.linkElements.length &&
                        this.linkElements.forEach((t) => {
                            var e, i;
                            let s = ((e = t.getAttribute("href")), (i = this.variant), /variant=/.test(e) ? e.replace(/(variant=)[^&]+/, "$1" + i) : /\?/.test(e) ? e.concat("&variant=").concat(i) : e.concat("?variant=").concat(i));
                            t.setAttribute("href", s);
                        }),
                    this.quickView && "quick_buy" === theme.settings.quickBuy && this.quickView.setAttribute(tj, this.variant);
            }
            replaceImages() {
                if (
                    ((this.imageSecondary = this.outer.querySelector("[data-product-image-secondary]")),
                    this.outer.removeAttribute(t0),
                    !this.imageReplace && this.element.hasAttribute(tU) && this.outer.setAttribute(t0, parseInt(this.element.getAttribute(tU))),
                    this.imageReplace && this.gridImage && this.imageId)
                ) {
                    this.gridImage.setAttribute(tG, this.imageId), this.gridImage.hasAttribute(t3) || this.gridImage.setAttribute(t3, window.getComputedStyle(this.gridImage).backgroundImage);
                    let t = () => {
                        requestAnimationFrame(() => {
                            this.gridImage.style.setProperty("background-image", this.imageReplace),
                                requestAnimationFrame(() => {
                                    this.imageSecondary.classList.remove(tz);
                                });
                        }),
                            this.imageSecondary.removeEventListener("animationend", t);
                    };
                    requestAnimationFrame(() => {
                        this.imageSecondary.classList.add(tz), this.imageSecondary.style.setProperty("background-image", this.imageReplace);
                    }),
                        this.imageSecondary.addEventListener("animationend", t);
                }
                "image" === theme.settings.productGridHover && (this.hoverImages = this.outer.querySelectorAll("[data-product-image-hover]")),
                    this.hoverImages.length > 1 &&
                        this.hoverImages.forEach((t) => {
                            t.classList.remove(tW), t.getAttribute(tj) === this.variant ? t.classList.add(tW) : this.hoverImages[0].classList.add(tW);
                        });
            }
            constructor(t) {
                (this.element = t),
                    (this.swatchLink = this.element.nextElementSibling),
                    (this.colorString = t.getAttribute("data-swatch")),
                    (this.image = this.element.getAttribute("data-swatch-image")),
                    (this.imageId = this.element.getAttribute("data-swatch-image-id")),
                    (this.variant = this.element.getAttribute("data-swatch-variant")),
                    (this.outer = this.element.closest("[data-product-block]")),
                    (this.gridImage = null),
                    (this.imageDefault = null),
                    (this.hoverImages = []),
                    (this.loadHovers = null);
                let e = new (class {
                    getColor() {
                        return this.match;
                    }
                    init() {
                        return tm({ json: theme.assets.swatches })
                            .then((t) => this.matchColors(t, this.settings.color))
                            .catch((t) => {
                                console.log("failed to load swatch colors script"), console.log(t);
                            });
                    }
                    matchColors(t, e) {
                        let i = "#E5E5E5",
                            s = null,
                            r = theme.assets.base || "/",
                            o = e.toLowerCase().replace(/\s/g, ""),
                            a = t.colors;
                        if (a) {
                            let n = null;
                            if (
                                a.filter((t, e) => {
                                    if (Object.keys(t).toString().toLowerCase().replace(/\s/g, "") === o) return (n = e), t;
                                }).length &&
                                null !== n
                            ) {
                                let l = Object.values(a[n])[0];
                                (i = l), (l.includes(".jpg") || l.includes(".jpeg") || l.includes(".png") || l.includes(".svg")) && ((s = `${r}${l}`), (i = "#888888"));
                            }
                        }
                        return { color: this.settings.color, path: s, hex: i };
                    }
                    constructor(t = {}) {
                        (this.settings = { color: "ash", ...t }), (this.match = this.init());
                    }
                })({ color: this.colorString });
                e.getColor().then((t) => {
                    (this.colorMatch = t), this.init();
                });
            }
        },
        t2 = class extends HTMLElement {
            init() {
                (this.swatchElements = this.querySelectorAll(t9)),
                    this.swatchElements.forEach((t) => {
                        new tY(t);
                    });
            }
            constructor() {
                super(),
                    (this.handle = this.getAttribute("data-swatch-handle")),
                    (this.label = this.getAttribute("data-swatch-label").trim().toLowerCase()),
                    (function (t) {
                        let e = `${theme.routes.root}products/${t}.js`;
                        return window
                            .fetch(e)
                            .then((t) => t.json())
                            .catch((t) => {
                                console.error(t);
                            });
                    })(this.handle).then((t) => {
                        (this.product = t), (this.colorOption = t.options.find((t) => t.name.toLowerCase() === this.label || null)), this.colorOption && ((this.swatches = this.colorOption.values), this.init());
                    });
                let t = this.closest("[data-section-type]"),
                    e = this.querySelector("[data-swatches-more]");
                null == e ||
                    e.addEventListener("click", () => {
                        this.classList.add(tV);
                    }),
                    null == t ||
                        t.addEventListener("touchstart", (t) => {
                            this.contains(t.target) || this.classList.remove(tV);
                        });
            }
        },
        t6 = class {
            checkSwatchesHeight(t) {
                let e = t.querySelector("[data-swatches-label]"),
                    i = t.querySelector("[data-swatches-button]"),
                    s = parseInt(window.getComputedStyle(t).getPropertyValue("padding-top")),
                    r = parseInt(window.getComputedStyle(e).getPropertyValue("margin-bottom")),
                    o = parseInt(window.getComputedStyle(i).getPropertyValue("margin-bottom")),
                    a = t.closest("[data-option-position]");
                a.classList.remove(tN), t.offsetHeight - s > e.offsetHeight + r + 2 * i.offsetHeight + 2 * o && (t.style.setProperty("--swatches-max-height", `${t.offsetHeight}px`), a.classList.add(tN));
            }
            onUnload() {
                this.swatchesContainers.forEach((t) => {
                    document.removeEventListener("theme:resize:width", this.checkSwatchesHeightOnResize);
                });
            }
            constructor(t) {
                (this.container = t),
                    (this.swatchesContainers = this.container.querySelectorAll("[data-swatches-container]")),
                    this.swatchesContainers.forEach((t) => {
                        (this.checkSwatchesHeightOnResize = () => this.checkSwatchesHeight(t)), this.checkSwatchesHeight(t), document.addEventListener("theme:resize:width", this.checkSwatchesHeightOnResize);
                    });
            }
        },
        t4 = (t) => {
            (tX = []),
                t.querySelectorAll(t9).forEach((t) => {
                    tX.push(new tY(t));
                });
        },
        tZ = {
            onLoad() {
                t4(this.container);
            },
        },
        t5 = {
            onLoad() {
                tJ[this.id] = new t6(this.container);
            },
            onUnload() {
                tJ[this.id].onUnload();
            },
        },
        t7 = "[data-product-media-container]",
        et = "[data-product-media-slideshow-slide]",
        ee = "fill",
        ei = "js-quick-view-visible",
        es = {},
        er = class {
            productGridSlideshow() {
                let t = this.container.querySelectorAll("[data-product-media-slideshow]"),
                    i = this.container.querySelectorAll(t7);
                t.length &&
                    t.forEach((t) => {
                        let i = t.closest(t7),
                            s = i.querySelector("[data-product-slideshow-progress]"),
                            r = t.querySelectorAll(et).length,
                            o = !this.sliders.length,
                            a = new e.data(t),
                            n = 0;
                        !a.isActive &&
                            r > 1 &&
                            ((a = new e(t, {
                                draggable: o,
                                cellSelector: et,
                                contain: !0,
                                wrapAround: !0,
                                imagesLoaded: !0,
                                lazyLoad: !0,
                                pageDots: !1,
                                prevNextButtons: !1,
                                adaptiveHeight: !1,
                                pauseAutoPlayOnHover: !1,
                                selectedAttraction: 0.2,
                                friction: 1,
                                on: {
                                    ready: () => {
                                        this.container.style.setProperty("--autoplay-speed", "2200ms");
                                    },
                                    change() {
                                        n && clearTimeout(n),
                                            s.classList.remove(ee),
                                            requestAnimationFrame(() => {
                                                s.classList.add(ee);
                                            }),
                                            (n = setTimeout(() => {
                                                s.classList.remove(ee);
                                            }, 2200));
                                    },
                                    dragEnd() {
                                        a.playPlayer();
                                    },
                                },
                            })),
                            window.theme.touch ||
                                (i.addEventListener("mouseenter", () => {
                                    s.classList.add(ee),
                                        n && clearTimeout(n),
                                        (n = setTimeout(() => {
                                            s.classList.remove(ee);
                                        }, 2200)),
                                        (a.options.autoPlay = 2200),
                                        a.playPlayer();
                                }),
                                i.addEventListener("mouseleave", () => {
                                    a.stopPlayer(), n && clearTimeout(n), s.classList.remove(ee);
                                })));
                    }),
                    i.length &&
                        i.forEach((t) => {
                            t.addEventListener("click", (t) => {
                                t.target.matches(".flickity-button") && t.preventDefault();
                            });
                        });
            }
            popupClose() {
                let t = document.querySelector("[data-product]");
                t && t.querySelector("[data-popup-close]").dispatchEvent(new Event("click"));
            }
            onBlockSelect() {
                this.body.classList.contains(ei) && this.popupClose();
            }
            onDeselect() {
                this.body.classList.contains(ei) && this.popupClose();
            }
            onUnload() {
                this.body.classList.contains(ei) && this.popupClose();
            }
            constructor(t) {
                (this.container = t),
                    (this.body = document.body),
                    (this.sliders = this.container.querySelectorAll("[data-slider]")),
                    "slideshow" !== theme.settings.productGridHover || window.theme.touch || this.productGridSlideshow(),
                    new sf(this.container);
            }
        },
        eo = {
            onLoad() {
                es[this.id] = new er(this.container);
            },
            onBlockSelect() {
                es[this.id].onBlockSelect();
            },
            onDeselect() {
                es[this.id].onDeselect();
            },
            onUnload() {
                es[this.id].onUnload();
            },
        },
        ea = "#AjaxinateLoop",
        en = "#AjaxinatePagination",
        el = "data-ajaxinate-id",
        eh = "is-loaded",
        ec = {},
        ed = class {
            init() {
                this.loadMoreFix(),
                    (this.ajaxinateContainer = this.container.querySelectorAll(ea)),
                    this.ajaxinateContainer.forEach((t) => {
                        let e = `${ea}[${el}="${t.dataset.ajaxinateId}"]`,
                            i = `${en}[${el}="${t.dataset.ajaxinateId}"]`;
                        if (t.children.length > 0) {
                            let r = new s({ container: e, pagination: i, method: "scroll" });
                            t.classList.add(eh), this.endlessScroll.push(r);
                        }
                    });
            }
            update(t) {
                this.ajaxinateContainer = this.container.querySelectorAll(ea);
                let e = (e) => e.settings.container === t,
                    i = this.endlessScroll.find(e);
                if (i) {
                    let r = this.endlessScroll.findIndex(e);
                    this.endlessScroll.splice(r, 1), (i.settings.method = "scroll"), i.destroy();
                }
                let o = [...this.ajaxinateContainer].find((e) => `${ea}[${el}="${e.dataset.ajaxinateId}"]` === t);
                if (!o) return;
                let a = `${ea}[${el}="${o.dataset.ajaxinateId}"]`,
                    n = `${en}[${el}="${o.dataset.ajaxinateId}"]`;
                if (!(o.children.length > 0)) return;
                let l = new s({ container: a, pagination: n, method: "scroll" });
                o.classList.add(eh), this.endlessScroll.push(l);
            }
            loadMoreFix() {
                s.prototype.loadMore = function () {
                    (this.request = new XMLHttpRequest()),
                        (this.request.onreadystatechange = function () {
                            if (!this.request.responseXML || (this.request.readyState, this.request.status, 0)) return;
                            let t = this.request.responseXML.querySelector(this.settings.container),
                                e = this.request.responseXML.querySelector(this.settings.pagination);
                            this.containerElement.insertAdjacentHTML("beforeend", t.innerHTML),
                                null == e
                                    ? this.removePaginationElement()
                                    : ((this.paginationElement.innerHTML = e.innerHTML), this.settings.callback && "function" == typeof this.settings.callback && this.settings.callback(this.request.responseXML), this.initialize());
                        }.bind(this)),
                        this.request.open("GET", this.nextPageUrl, !0),
                        (this.request.responseType = "document"),
                        this.request.send();
                };
            }
            unload() {
                this.endlessScroll.length > 0 &&
                    (this.endlessScroll.forEach((t) => {
                        (t.settings.method = "scroll"), t.destroy();
                    }),
                    this.ajaxinateContainer.forEach((t) => t.classList.remove(eh)));
            }
            constructor(t) {
                (this.container = t), (this.endlessScroll = []), theme.settings.enableInfinityScroll && this.init();
            }
        },
        eu = "[data-toggle-filters]",
        ep = "[data-collapsible-trigger]",
        em = "[data-collection-sort-options]",
        eg = "[data-input-sort]",
        ey = "[data-collection-filters]",
        ev = "[data-collection-filter]",
        ef = "[data-collection-filters-form]",
        eb = "[data-filter-reset-button]",
        eS = "[data-collection-products]",
        eE = "[data-products-count]",
        eL = "[data-field-price-min]",
        ek = "[data-field-price-max]",
        ew = "[data-se-min-value]",
        e$ = "[data-se-max-value]",
        eA = "data-se-min-value",
        eq = "data-se-max-value",
        eC = "data-se-min",
        eT = "data-se-max",
        eP = "[data-tooltip]",
        e_ = "[data-show-more-trigger]",
        eF = "is-active",
        ex = "is-expanded",
        eI = "is-loading",
        eH = "collection__filters--visible",
        eD = "collection__sort__option-wrapper--visible",
        e8 = "data-filter-active",
        eM = "tabindex",
        eO = "aria-expanded",
        eB = {},
        e9 = class {
            initFacetedFilters() {
                "tag" != this.filterMode &&
                    "group" != this.filterMode &&
                    this.enableFilters &&
                    (this.rangeSlider = new (class {
                        init() {
                            if (((this.slider = this.container.querySelector("[data-range-slider]")), !this.slider)) return;
                            (this.resizeFilters = o(this.reset.bind(this), 50)),
                                (this.onMoveEvent = (t) => this.onMove(t)),
                                (this.onStopEvent = (t) => this.onStop(t)),
                                (this.onStartEvent = (t) => this.onStart(t)),
                                (this.startX = 0),
                                (this.x = 0),
                                (this.touchLeft = this.slider.querySelector("[data-range-left]")),
                                (this.touchRight = this.slider.querySelector("[data-range-right]")),
                                (this.lineSpan = this.slider.querySelector("[data-range-line]")),
                                (this.min = parseFloat(this.slider.getAttribute("data-se-min"))),
                                (this.max = parseFloat(this.slider.getAttribute("data-se-max"))),
                                (this.step = 0),
                                (this.normalizeFact = 20);
                            let t = this.min;
                            this.slider.hasAttribute(tH) && (t = parseFloat(this.slider.getAttribute(tH)));
                            let e = this.max;
                            this.slider.hasAttribute(tD) && (e = parseFloat(this.slider.getAttribute(tD))),
                                t < this.min && (t = this.min),
                                e > this.max && (e = this.max),
                                t > e && (t = e),
                                this.slider.getAttribute(t8) && (this.step = Math.abs(parseFloat(this.slider.getAttribute(t8)))),
                                this.reset(),
                                window.addEventListener("theme:resize", this.resizeFilters),
                                (this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth),
                                (this.selectedTouch = null),
                                (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact),
                                this.setMinValue(t),
                                this.setMaxValue(e),
                                this.touchLeft.addEventListener("mousedown", this.onStartEvent),
                                this.touchRight.addEventListener("mousedown", this.onStartEvent),
                                this.touchLeft.addEventListener("touchstart", this.onStartEvent, { passive: !0 }),
                                this.touchRight.addEventListener("touchstart", this.onStartEvent, { passive: !0 }),
                                this.slider.classList.add("is-initialized");
                        }
                        reset() {
                            (this.touchLeft.style.left = "0px"),
                                (this.touchRight.style.left = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
                                (this.lineSpan.style.marginLeft = "0px"),
                                (this.lineSpan.style.width = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
                                (this.startX = 0),
                                (this.x = 0),
                                (this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth),
                                (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact);
                        }
                        setMinValue(t) {
                            let e = (t - this.min) / (this.max - this.min);
                            (this.touchLeft.style.left = Math.ceil(e * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact))) + "px"),
                                (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                                (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                                this.slider.setAttribute(tH, t);
                        }
                        setMaxValue(t) {
                            let e = (t - this.min) / (this.max - this.min);
                            (this.touchRight.style.left = Math.ceil(e * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact)) + this.normalizeFact) + "px"),
                                (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                                (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                                this.slider.setAttribute(tD, t);
                        }
                        onStart(t) {
                            t.preventDefault();
                            let e = t;
                            t.touches && (e = t.touches[0]),
                                t.currentTarget === this.touchLeft ? (this.x = this.touchLeft.offsetLeft) : t.currentTarget === this.touchRight && (this.x = this.touchRight.offsetLeft),
                                (this.startX = e.pageX - this.x),
                                (this.selectedTouch = t.currentTarget),
                                document.addEventListener("mousemove", this.onMoveEvent),
                                document.addEventListener("mouseup", this.onStopEvent),
                                document.addEventListener("touchmove", this.onMoveEvent, { passive: !0 }),
                                document.addEventListener("touchend", this.onStopEvent, { passive: !0 });
                        }
                        onMove(t) {
                            let e = t;
                            t.touches && (e = t.touches[0]),
                                (this.x = e.pageX - this.startX),
                                this.selectedTouch === this.touchLeft
                                    ? (this.x > this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10 ? (this.x = this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10) : this.x < 0 && (this.x = 0),
                                      (this.selectedTouch.style.left = this.x + "px"))
                                    : this.selectedTouch === this.touchRight &&
                                      (this.x < this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10 ? (this.x = this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10) : this.x > this.maxX && (this.x = this.maxX),
                                      (this.selectedTouch.style.left = this.x + "px")),
                                (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                                (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                                this.calculateValue(),
                                this.slider.getAttribute("on-change") && Function("min, max", this.slider.getAttribute("on-change"))(this.slider.getAttribute(tH), this.slider.getAttribute(tD)),
                                this.onChange(this.slider.getAttribute(tH), this.slider.getAttribute(tD));
                        }
                        onStop(t) {
                            document.removeEventListener("mousemove", this.onMoveEvent),
                                document.removeEventListener("mouseup", this.onStopEvent),
                                document.removeEventListener("touchmove", this.onMoveEvent, { passive: !0 }),
                                document.removeEventListener("touchend", this.onStopEvent, { passive: !0 }),
                                (this.selectedTouch = null),
                                this.calculateValue(),
                                this.onChanged(this.slider.getAttribute(tH), this.slider.getAttribute(tD));
                        }
                        onChange(t, e) {
                            let i = this.slider.closest("[data-range-holder]");
                            if (i) {
                                let s = i.querySelector("[data-field-price-min]"),
                                    r = i.querySelector("[data-field-price-max]");
                                s && r && ((s.value = parseInt(t)), (r.value = parseInt(e)));
                            }
                        }
                        onChanged(t, e) {
                            this.slider.hasAttribute("data-range-filter-update") && this.slider.dispatchEvent(new CustomEvent("theme:filter:range-update", { bubbles: !0 }));
                        }
                        calculateValue() {
                            let t = (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue,
                                e = this.lineSpan.offsetLeft / this.initialValue,
                                i = e + t;
                            if (((e = e * (this.max - this.min) + this.min), (i = i * (this.max - this.min) + this.min), 0 !== this.step)) {
                                let s = Math.floor(e / this.step);
                                (e = this.step * s), (s = Math.floor(i / this.step)), (i = this.step * s);
                            }
                            this.selectedTouch === this.touchLeft && this.slider.setAttribute(tH, e), this.selectedTouch === this.touchRight && this.slider.setAttribute(tD, i);
                        }
                        unload() {
                            document.removeEventListener("theme:filters:init", this.initListener), window.removeEventListener("theme:resize", this.resizeFilters);
                        }
                        constructor(t) {
                            (this.container = t), this.init(), (this.initListener = () => this.init()), document.addEventListener("theme:filters:init", this.initListener);
                        }
                    })(this.container));
            }
            initTooltips() {
                var t, e;
                (this.tooltips = this.container.querySelectorAll(eP)),
                    window.innerWidth < theme.sizes.small && (this.tooltips = null === (e = this.productGrid) || void 0 === e ? void 0 : e.querySelectorAll(eP)),
                    null === (t = this.tooltips) ||
                        void 0 === t ||
                        t.forEach((t) => {
                            new tx(t);
                        });
            }
            updateRange() {
                let t = this.filtersForm.querySelector(ew),
                    e = this.filtersForm.querySelector(e$),
                    i = this.filtersForm.querySelector(eL),
                    s = this.filtersForm.querySelector(ek);
                if (t.hasAttribute(eA) && e.hasAttribute(eq)) {
                    let r = parseFloat(i.placeholder, 10),
                        o = parseFloat(s.placeholder, 10),
                        a = parseFloat(t.getAttribute(eA), 10),
                        n = parseFloat(e.getAttribute(eq), 10);
                    (r === a && o === n) || ((i.value = parseInt(a)), (s.value = parseInt(n)), this.filtersForm.dispatchEvent(new Event("input", { bubbles: !0 })));
                }
            }
            onSubmitHandler(t) {
                t.preventDefault();
                let e = new FormData(this.filtersForm),
                    i = new URLSearchParams(e),
                    s = [],
                    r = "";
                this.isSearchPage && ((this.searchForm = this.container.querySelector("[data-search-form]")), (this.currentType = this.container.getAttribute("data-current-type")));
                let o = this.filtersForm.querySelector(ew),
                    a = this.filtersForm.querySelector(e$),
                    n = this.filtersForm.querySelector(eL),
                    l = this.filtersForm.querySelector(ek);
                if (o && a && n && l && o.hasAttribute(eC) && a.hasAttribute(eT)) {
                    let h = parseFloat(o.getAttribute(eC), 10),
                        c = parseFloat(a.getAttribute(eT), 10),
                        d = n.value ? parseFloat(n.value, 10) : h,
                        u = l.value ? parseFloat(l.value, 10) : c;
                    d <= h && u >= c && (s.push("filter.v.price.gte"), s.push("filter.v.price.lte"), i.delete("filter.v.price.gte"), i.delete("filter.v.price.lte"));
                }
                if (((r = i.toString()), this.isSearchPage)) {
                    r = tw(this.searchForm, this.filtersForm, s);
                    let p = "";
                    "all" === this.currentType && (p = "&type=product"), r.indexOf("&type=product") > -1 && (p = ""), (r += p);
                }
                try {
                    if ("/collections/vendors" == window.location.pathname) {
                        let m = window.location.search.split("&")[0];
                        r = (m = m.replaceAll("?", "")) + "&" + r;
                    }
                } catch (g) {}
                this.renderSection(r, t);
            }
            onHistoryChange(t) {
                var e;
                if (!this.filters) return;
                let i = (null === (e = t.state) || void 0 === e ? void 0 : e.searchParams) || "";
                (!this.isSearchPage || (t.state || (i = window.location.search), i.indexOf("type=product") > -1)) && this.renderSection(i, null, !1);
            }
            renderSection(t, e, i = !0) {
                this.startLoading();
                try {
                    if ("/collections/vendors" == window.location.pathname && "" == t) {
                        let s = window.location.search.split("&")[0];
                        t = s = s.replaceAll("?", "");
                    }
                } catch (r) {}
                let o = `${window.location.pathname}?section_id=${this.sectionId}&${t}`,
                    a = (t) => t.url === o;
                this.filterData.some(a) ? this.renderSectionFromCache(a, e) : this.renderSectionFromFetch(o, e), i && this.updateURLHash(t);
            }
            renderSectionFromFetch(t) {
                fetch(t)
                    .then((t) => t.text())
                    .then((e) => {
                        let i = e;
                        (this.filterData = [...this.filterData, { html: i, url: t }]),
                            (this.inputSort = this.container.querySelectorAll(eg)),
                            this.renderFilters(i),
                            this.bindFilterButtonsEvents(),
                            this.hideFiltersOnMobile(),
                            this.renderProductGrid(i),
                            this.updateProductsCount(i),
                            this.finishLoading(),
                            this.mobileFiltersScrollLock(),
                            this.handleSearchPageActiveTab();
                    });
            }
            renderSectionFromCache(t, e) {
                let i = this.filterData.find(t).html;
                this.renderFilters(i, e), this.hideFiltersOnMobile(), this.renderProductGrid(i), this.updateProductsCount(i), this.finishLoading(), this.mobileFiltersScrollLock(), this.handleSearchPageActiveTab();
            }
            handleSearchPageActiveTab() {
                this.isSearchPage && ((this.scrollable = this.container.querySelector("[data-custom-scrollbar]")), this.scrollable && !this.customScrollbar && (this.customScrollbar = new t$(this.container)));
            }
            renderProductGrid(t) {
                let e = new DOMParser().parseFromString(t, "text/html").querySelector(eS);
                e && ((this.productGrid.innerHTML = e.innerHTML), this.initProductGridEvents(theme.settings.enableInfinityScroll), this.filterShowMore());
            }
            updateProductsCount(t) {
                let e = new DOMParser().parseFromString(t, "text/html").querySelector(eE);
                e && (this.productsCount.innerHTML = e.innerHTML);
            }
            renderFilters(t) {
                let e = new DOMParser().parseFromString(t, "text/html").querySelector(ey);
                e &&
                    ((this.filters.innerHTML = e.innerHTML),
                    (this.filtersForm = document.querySelector(ef)),
                    this.bindFilterButtonsEvents(),
                    this.bindToggleButtonsEvents(),
                    t4(this.container),
                    (this.collapsible = new tn(this.container)),
                    document.dispatchEvent(new CustomEvent("theme:filters:init", { bubbles: !0 })));
            }
            updateURLHash(t) {
                history.pushState({ searchParams: t }, "", `${window.location.pathname}${t && "?".concat(t)}`);
            }
            bindFilterButtonsEvents() {
                this.inputSort.length > 0 &&
                    this.inputSort.forEach((t) => {
                        t.addEventListener("change", this.updateCollectionFormSortEvent);
                    }),
                    this.filtersForm && (this.filtersForm.addEventListener("input", this.debouncedSubmitEvent.bind(this)), this.filtersForm.addEventListener("theme:filter:range-update", this.updateRangeEvent)),
                    this.collectionSortOptions && this.collectionSortOptions.addEventListener("keyup", this.onTabHandlerEvent),
                    "tag" != this.filterMode &&
                        "group" != this.filterMode &&
                        this.enableFilters &&
                        this.container.querySelectorAll(eb).forEach((t) => {
                            t.addEventListener("click", this.onFilterResetClick, { once: !0 });
                        });
            }
            onFilterResetClick(t) {
                t.preventDefault(), this.renderSection(new URL(t.currentTarget.href).searchParams.toString());
            }
            bindToggleButtonsEvents() {
                var t;
                this.container.querySelectorAll(eu).forEach((t) => {
                    t.addEventListener("click", this.onFilterToggleClick);
                }),
                    this.container.querySelectorAll("[data-close-filters]").forEach((t) => {
                        t.addEventListener("click", this.hideFiltersDrawer);
                    }),
                    this.container.querySelectorAll("[data-open-filters]").forEach((t) => {
                        t.addEventListener("click", this.showFiltersDrawer);
                    }),
                    null === (t = this.container.querySelector("[data-collection-wrapper]")) || void 0 === t || t.addEventListener("keyup", this.onKeyUpHandler);
            }
            onTabHandler(t) {
                if (t.code === theme.keyboardKeys.SPACE || t.code === theme.keyboardKeys.ENTER || t.code === theme.keyboardKeys.NUMPADENTER) {
                    let e = t.target.previousElementSibling.value;
                    this.filtersForm.querySelectorAll(eg).forEach((t) => {
                        t.checked && (t.checked = !1), t.value === e && (t.checked = !0);
                    }),
                        this.filtersForm.dispatchEvent(new Event("input", { bubbles: !0 })),
                        t.target.dispatchEvent(new Event("click", { bubbles: !0 }));
                }
            }
            onKeyUpHandler(t) {
                t.code === theme.keyboardKeys.ESCAPE && this.hideFiltersDrawer();
            }
            onFilterToggleClick(t) {
                t.preventDefault(), d(), this.filters.classList.contains(eH) ? this.hideFiltersDrawer() : this.showFiltersDrawer();
            }
            sortDropdownToggle() {
                this.collectionSortOptions && this.collectionSortOptions.classList.toggle(eD);
            }
            bodyClick(t) {
                if (!this.collectionSortOptions) return;
                let e = this.sortToggle.contains(t.target);
                this.collectionSortOptions.classList.contains(eD) && !e && this.sortDropdownToggle();
            }
            updateCollectionFormSort(t) {
                let e = t.target,
                    i = e.value,
                    s = e.closest(em);
                this.container.querySelectorAll(eg).forEach((t) => {
                    t.value === i && (t.checked = !0);
                }),
                    null !== s && this.filtersForm.dispatchEvent(new Event("input", { bubbles: !0 }));
            }
            showFiltersDrawer() {
                (this.a11y.state.trigger = document.querySelector(eu)), this.a11y.trapFocus({ container: this.filters }), this.mobileFiltersScrollLock();
            }
            mobileFiltersScrollLock() {
                if (window.innerWidth < theme.sizes.small) {
                    let t = document.querySelector("[data-collection-filters-list]");
                    this.filters.classList.contains(eH) || this.filters.classList.add(eH), document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: t }));
                }
            }
            hideFiltersOnMobile() {
                let t = this.container.querySelectorAll(`${ep}:not(${e_})`);
                window.innerWidth < theme.sizes.small &&
                    requestAnimationFrame(() => {
                        t.forEach((t) => {
                            let e = "true" === t.getAttribute(e8);
                            t.classList.contains(ex) && !e && t.dispatchEvent(new Event("click"));
                        });
                    });
            }
            showFiltersOnDesktop() {
                let t = this.container.querySelectorAll(`${ep}:not(${e_})`),
                    e = this.container.getAttribute("data-filters-default-state"),
                    i = "first-open" === e,
                    s = "open" === e,
                    r = "closed" === e,
                    o = this.enableSorting ? 1 : 0;
                t.forEach((t, e) => {
                    let a = t.classList.contains(ex),
                        n = "true" === t.getAttribute(e8),
                        l = n && !a && s;
                    (n && !l) || (((r && a) || (i && !a && e === o) || (i && a && e !== o) || (s && !a) || l) && t.dispatchEvent(new Event("click")));
                });
            }
            hideFiltersDrawer() {
                let t = this.filters.classList.contains(eH),
                    e = this.container.classList.contains(eI);
                t && (this.filters.classList.remove(eH), this.a11y.removeTrapFocus()), e || document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: 300 }));
            }
            filtersResizeEvents() {
                window.innerWidth >= theme.sizes.small ? (this.showFiltersOnDesktop(), this.hideFiltersDrawer()) : this.hideFiltersOnMobile();
            }
            filterShowMore() {
                (this.showMore = this.container.querySelectorAll("[data-show-more]")),
                    0 !== this.showMore.length &&
                        this.showMore.forEach((t) => {
                            let e = t.querySelector(ep),
                                i = t.querySelector("[data-show-more-actions]");
                            if (!i) return;
                            let s = i.querySelector(e_),
                                r = i.querySelector("[data-show-more-container]"),
                                o = r.querySelectorAll(window.theme.focusable);
                            "true" === r.getAttribute(eO) ||
                                o.forEach((t) => {
                                    t.setAttribute(eM, "-1");
                                }),
                                s.addEventListener("keyup", (t) => {
                                    (t.code !== theme.keyboardKeys.SPACE && t.code !== theme.keyboardKeys.ENTER && t.code !== theme.keyboardKeys.NUMPADENTER) || this.updateShowMoreFocusableElements(t, o);
                                }),
                                s.addEventListener("click", (t) => {
                                    this.updateShowMoreFocusableElements(t, o);
                                }),
                                e.addEventListener("keyup", (t) => {
                                    (t.code !== theme.keyboardKeys.SPACE && t.code !== theme.keyboardKeys.ENTER && t.code !== theme.keyboardKeys.NUMPADENTER) || this.updateCollapsedContainerFocusableElements(e, s, o);
                                }),
                                e.addEventListener("click", () => {
                                    this.updateCollapsedContainerFocusableElements(e, s, o);
                                });
                        });
            }
            updateCollapsedContainerFocusableElements(t, e, i) {
                requestAnimationFrame(() => {
                    let s = "true" === t.getAttribute(eO),
                        r = "true" === e.getAttribute(eO);
                    i.forEach((t) => {
                        !s && r && t.setAttribute(eM, "-1"), s && r && t.removeAttribute(eM);
                    });
                });
            }
            updateShowMoreFocusableElements(t, e) {
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        let i = "true" === t.target.getAttribute(eO);
                        e.forEach((t, e) => {
                            if (i) return t.removeAttribute(eM), void (0 === e && t.focus());
                            t.setAttribute(eM, "-1");
                        });
                    });
                });
            }
            initTagFilters() {
                ("tag" == this.filterMode || "group" == this.filterMode) && this.enableFilters && ((this.tags = this.container.dataset.tags.split("+").filter((t) => t)), this.bindFilterTagButtonsEvents(), this.bindSortChangeEvent());
            }
            renderTagFiltersProducts(t) {
                this.startLoading(),
                    "object" == typeof this.endlessCollection && this.endlessCollection.unload(),
                    fetch(t)
                        .then((t) => t.text())
                        .then((e) => {
                            let i = e,
                                s = new DOMParser().parseFromString(i, "text/html"),
                                r = s.querySelector(eS).innerHTML,
                                o = s.querySelector(ey).innerHTML;
                            (this.productGrid.innerHTML = r),
                                (this.filters.innerHTML = o),
                                (this.inputSort = this.container.querySelectorAll(eg)),
                                (this.filtersForm = document.querySelector(ef)),
                                (this.filterData = [...this.filterData, { html: i, url: t }]),
                                (this.alreadyClicked = !1),
                                this.bindFilterTagButtonsEvents(),
                                this.bindFilterButtonsEvents(),
                                this.bindSortChangeEvent(),
                                this.bindToggleButtonsEvents(),
                                this.initProductGridEvents(theme.settings.enableInfinityScroll),
                                this.updateProductsCount(i),
                                this.mobileFiltersScrollLock(),
                                this.hideFiltersOnMobile(),
                                t4(this.container),
                                (this.collapsible = new tn(this.container)),
                                this.filterShowMore(),
                                history.replaceState && window.history.pushState({ path: t }, "", t);
                        })
                        .catch((t) => {
                            this.finishLoading(), console.log(`Error: ${t}`);
                        });
            }
            bindFilterTagButtonsEvents() {
                this.container.querySelectorAll("[data-collection-filter-tag-button]").forEach((t) => {
                    t.addEventListener("click", this.onFilterTagButtonClick.bind(this));
                }),
                    this.container.querySelectorAll("[data-filter-tag-reset-button]").forEach((t) => {
                        t.addEventListener("click", this.onFilterTagClearClick);
                    }),
                    this.container.querySelectorAll(eb).forEach((t) => {
                        t.addEventListener("click", this.onFilterTagResetClick);
                    });
            }
            bindSortChangeEvent() {
                this.container.querySelectorAll(eg).forEach((t) => {
                    t.addEventListener("input", this.debouncedSortEvent.bind(this));
                });
            }
            onFilterTagButtonClick(t) {
                if ((t.preventDefault(), this.alreadyClicked)) return;
                this.alreadyClicked = !0;
                let e = t.currentTarget,
                    i = e.dataset.tag;
                if (e.parentNode.classList.contains(eF)) {
                    let s = this.tags.indexOf(i);
                    e.parentNode.classList.remove(eF), s > -1 && this.tags.splice(s, 1);
                } else e.parentNode.classList.add(eF), this.tags.push(i);
                let r = this.collectionHandle + "/" + this.tags.join("+") + "?sort_by=" + this.getSortValue();
                this.container.querySelector(ev).classList.remove(ex), this.container.querySelector(ev).setAttribute(eO, !1), this.container.setAttribute("data-tags", "[" + this.tags + "]"), this.renderTagFiltersProducts(r);
            }
            onFilterTagClearClick(t) {
                if ((t.preventDefault(), this.alreadyClicked)) return;
                this.alreadyClicked = !0;
                let e = t.currentTarget.dataset.tag,
                    i = this.tags.indexOf(e);
                i > -1 && this.tags.splice(i, 1);
                let s = this.collectionHandle + "/" + this.tags.join("+") + "?sort_by=" + this.getSortValue();
                this.container.setAttribute("data-tags", "[" + this.tags + "]"), this.renderTagFiltersProducts(s);
            }
            onSortChange() {
                let t = this.collectionHandle + "/" + this.tags.join("+") + "?sort_by=" + this.getSortValue();
                this.renderTagFiltersProducts(t);
            }
            getSortValue() {
                let t = "";
                return (
                    this.inputSort.forEach((e) => {
                        e.checked && (t = e.value);
                    }),
                    t
                );
            }
            onFilterTagResetClick(t) {
                if ((null == t || t.preventDefault(), this.alreadyClicked)) return;
                (this.alreadyClicked = !0),
                    this.container.querySelectorAll("[data-collection-filter-tag]").forEach((t) => {
                        t.classList.remove(eF);
                    }),
                    this.container.querySelectorAll(ev).forEach((t) => {
                        t.classList.remove(ex), t.setAttribute(eO, !1);
                    }),
                    (this.tags = []),
                    this.container.setAttribute("data-tags", "");
                let e = this.collectionHandle + "/?sort_by=" + this.getSortValue();
                this.renderTagFiltersProducts(e);
            }
            getProductsOffsetTop() {
                return this.productGrid.getBoundingClientRect().top - document.body.getBoundingClientRect().top - this.filtersStickyBar.offsetHeight;
            }
            getStickyBarOffsetTop() {
                return this.filtersStickyBar.getBoundingClientRect().top - document.body.getBoundingClientRect().top;
            }
            initProductGridEvents(t) {
                if (t) return this.initInfinityScroll(), void this.initProductGridEvents(!1);
                (this.productGridEvents = new er(this.container)),
                    this.initTooltips(),
                    setTimeout(() => {
                        this.finishLoading();
                    }, 450);
            }
            initInfinityScroll() {
                this.isSearchPage
                    ? !this.enableFilters || document.dispatchEvent(new CustomEvent("theme:tab:ajaxinate", { bubbles: !0, detail: "product" }))
                    : ("object" == typeof this.endlessCollection && this.endlessCollection.unload(),
                      (this.endlessCollection = new ed(this.container)),
                      0 !== this.endlessCollection.endlessScroll.length && (this.endlessCollection.endlessScroll[0].settings.callback = () => this.initProductGridEvents(!1)));
            }
            startLoading() {
                this.container.classList.add(eI), window.innerWidth >= theme.sizes.small && document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 }));
                let t = this.getProductsOffsetTop();
                window.scrollTo({ top: t, left: 0, behavior: "smooth" });
            }
            finishLoading() {
                let t = document.querySelectorAll('[data-section-type="popups"] .popup--visible'),
                    e = t.length > 0;
                if ((this.container.classList.remove(eI), e)) {
                    let i = 0;
                    [...t].forEach((t) => {
                        t.hasAttribute("data-prevent-scroll-lock") && (i += 1);
                    }),
                        i === t.length && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: 300 }));
                } else window.innerWidth >= theme.sizes.small && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: 300 }));
            }
            onDeselect() {
                this.productGridEvents && this.productGridEvents.onDeselect();
            }
            onUnload() {
                "object" == typeof this.endlessCollection && this.endlessCollection.unload(),
                    this.productGridEvents && this.productGridEvents.onUnload(),
                    this.collapsible && this.collapsible.onUnload(),
                    this.rangeSlider && this.rangeSlider.unload(),
                    this.filters && document.removeEventListener("theme:resize:width", this.resizeEvent),
                    document.removeEventListener("click", this.bodyClickEvent),
                    this.groupTagFilters.length > 0 && this.onFilterTagResetClick(),
                    this.finishLoading();
            }
            constructor(t) {
                var e;
                (this.container = t),
                    (this.sectionId = t.dataset.sectionId),
                    (this.enableFilters = "true" === t.dataset.enableFilters),
                    (this.enableSorting = "true" === t.dataset.enableSorting),
                    (this.filterMode = t.dataset.filterMode),
                    (this.collectionHandle = this.container.dataset.collection),
                    (this.isSearchPage = null != t.closest("[data-search-performed]")),
                    (this.productGrid = this.container.querySelector(eS)),
                    (this.productsCount = this.container.querySelector(eE)),
                    (this.groupTagFilters = this.container.querySelectorAll(ev)),
                    (this.filters = this.container.querySelector(ey)),
                    (this.filterTriggers = this.container.querySelectorAll(ep)),
                    (this.filtersStickyBar = this.container.querySelector("[data-collection-sticky-bar]")),
                    (this.filtersForm = this.container.querySelector(ef)),
                    (this.inputSort = this.container.querySelectorAll(eg)),
                    (this.sortToggle = this.container.querySelector("[data-sort-toggle]")),
                    (this.collectionSortOptions = this.container.querySelector(em)),
                    (this.a11y = tu),
                    (this.filterData = []),
                    (this.rangeSlider = null),
                    (this.sortDropdownEvent = () => this.sortDropdownToggle()),
                    (this.onTabHandlerEvent = (t) => this.onTabHandler(t)),
                    (this.updateCollectionFormSortEvent = (t) => this.updateCollectionFormSort(t)),
                    (this.bodyClickEvent = (t) => this.bodyClick(t)),
                    (this.onFilterResetClick = this.onFilterResetClick.bind(this)),
                    (this.onFilterTagResetClick = this.onFilterTagResetClick.bind(this)),
                    (this.onFilterTagClearClick = this.onFilterTagClearClick.bind(this)),
                    (this.onFilterToggleClick = this.onFilterToggleClick.bind(this)),
                    (this.onKeyUpHandler = this.onKeyUpHandler.bind(this)),
                    (this.updateRangeEvent = this.updateRange.bind(this)),
                    (this.debouncedSubmitEvent = o((t) => {
                        this.onSubmitHandler(t);
                    }, 500)),
                    (this.debouncedSortEvent = o((t) => {
                        this.onSortChange(t);
                    }, 500)),
                    (this.productGridEvents = {}),
                    this.filters &&
                        ((this.hideFiltersDrawer = this.hideFiltersDrawer.bind(this)),
                        (this.showFiltersDrawer = this.showFiltersDrawer.bind(this)),
                        (this.resizeEvent = o(() => {
                            this.filtersResizeEvents();
                        }, 500)),
                        this.filtersResizeEvents(),
                        document.addEventListener("theme:resize:width", this.resizeEvent)),
                    this.initTagFilters(),
                    this.initFacetedFilters(),
                    this.bindToggleButtonsEvents(),
                    this.bindFilterButtonsEvents(),
                    this.initProductGridEvents(theme.settings.enableInfinityScroll),
                    t4(this.container),
                    (this.collapsible = new tn(this.container)),
                    d(),
                    window.addEventListener("popstate", this.onHistoryChange.bind(this)),
                    null === (e = this.sortToggle) || void 0 === e || e.addEventListener("click", this.sortDropdownEvent),
                    document.addEventListener("click", this.bodyClickEvent),
                    this.filterShowMore();
            }
        },
        ez = {
            onLoad() {
                eB[this.id] = new e9(this.container);
            },
            onDeselect() {
                eB[this.id].onDeselect();
            },
            onUnload() {
                eB[this.id].onUnload();
            },
        },
        eW = "[data-tabs-link]",
        eR = "[data-tab]",
        eV = "[data-custom-scrollbar-holder]",
        eN = "[data-tooltip]",
        eU = "#AjaxinateLoop",
        ej = "current",
        eK = "hide",
        eQ = "aos-animate",
        e0 = "aos-init",
        e3 = "data-tabs-link",
        eG = "data-tab",
        e1 = "data-start-index",
        eX = "data-type",
        eJ = {},
        eY = class {
            assignSearchPageArguments() {
                this.isSearchPage &&
                    ((this.searchForm = this.container.querySelector("[data-search-form]")),
                    (this.searchFormData = new FormData(this.searchForm)),
                    (this.searchTerm = encodeURIComponent(this.searchFormData.get("q"))),
                    (this.currentType = this.container.getAttribute("data-current-type")),
                    (this.sectionId = this.container.dataset.sectionId),
                    (this.searchForAllTypes = "true" === this.container.getAttribute("data-all-types")),
                    (this.fetchURL = ""),
                    (this.searchParams = ""),
                    (this.cachedResults = {}),
                    this.handleTabsHistory(),
                    this.infiniteScrollListener(),
                    this.initInfinityScroll(this.currentType));
            }
            init() {
                let t = this.container.querySelectorAll(eW),
                    e = this.container.querySelector(`[${e3}="${this.container.hasAttribute(e1) ? this.container.getAttribute(e1) : 0}"]`),
                    i = this.container.querySelector(`[${eG}="${this.container.hasAttribute(e1) ? this.container.getAttribute(e1) : 0}"]`);
                null == i || i.classList.add(ej),
                    null == e || e.classList.add(ej),
                    this.checkVisibleTabsLinks(),
                    t.forEach((t) => {
                        this.handleTabsNavListeners(t);
                    });
            }
            handleTabsHistory() {
                window.addEventListener("popstate", this.onHistoryChange.bind(this)),
                    (this.openTabFromHistoryEvent = (t) => this.openTabFromHistory(t)),
                    this.tabsLink.forEach((t) => {
                        t.addEventListener("theme:tab:open-from-history", this.openTabFromHistoryEvent);
                    });
            }
            handleTabsNavListeners(t) {
                let e = t.getAttribute(e3),
                    i = this.container.querySelector(`[${eG}="${e}"]`);
                i &&
                    (t.addEventListener("click", (e) => {
                        this.isSearchPage && this.handleURLSearchParams(e, !0), this.tabChange(t, i);
                    }),
                    t.addEventListener("keyup", (e) => {
                        (e.code !== theme.keyboardKeys.SPACE && e.code !== theme.keyboardKeys.ENTER && e.code !== theme.keyboardKeys.NUMPADENTER) || (this.isSearchPage && this.handleURLSearchParams(e, !0), this.tabChange(t, i));
                    }));
            }
            openTabFromHistory(t) {
                let e = t.target,
                    i = this.container.querySelector(t.detail.element).getAttribute(e3),
                    s = this.container.querySelector(`[${eG}="${i}"]`);
                s && (this.handleURLSearchParams(t, !1), this.tabChange(e, s));
            }
            handleURLSearchParams(t, e = !0) {
                let i = t.target.matches(eW) ? t.target : t.target.closest(eW),
                    s = i.getAttribute(eX),
                    r = i.getAttribute(e3),
                    o = this.container.querySelector(`[${eG}="${r}"]`).querySelector("[data-current-page]"),
                    a = document.querySelector("[data-collection-filters-form]"),
                    n = o ? `&page=${o.getAttribute("data-current-page")}` : "";
                if (((this.searchParams = tw(this.searchForm, a, [], s)), "product" === s)) {
                    let l = this.searchParams.replace("&type=product", "");
                    this.searchParams = `${l}&type=product`;
                } else this.searchParams = `q=${this.searchTerm}&type=${s}`;
                theme.settings.enableInfinityScroll || "" === n || (this.searchParams += n),
                    (this.fetchURL = `${theme.routes.searchUrl}?${this.searchParams}&section_id=${this.sectionId}`),
                    e && history.pushState({ searchParams: this.searchParams }, "", `${window.location.pathname}${this.searchParams && "?".concat(this.searchParams)}`);
            }
            tabChangeFetchContent(t, e) {
                let i = t.getAttribute(eX),
                    s = t.getAttribute(e3),
                    r = this.container.querySelector(`[${eG}="${s}"]`),
                    o = this.currentType === i;
                if (this.cachedResults[s] || o)
                    return (
                        "product" !== i || this.searchFilters || (this.searchFilters = new e9(this.container)),
                        void requestAnimationFrame(() => {
                            this.handleActiveTabClasses(t, e), this.scrollToCurrentTabLink(t), this.triggerTabAnimations(e), this.checkVisibleTabsLinks(), this.updateAjaxify(e, i);
                        })
                    );
                fetch(this.fetchURL)
                    .then((t) => {
                        if (!t.ok) throw Error(t.status);
                        return t.text();
                    })
                    .then((o) => {
                        var a;
                        let n = new DOMParser().parseFromString(o, "text/html").querySelector(`[${eG}="${s}"]`).innerHTML;
                        this.searchForAllTypes && (null === (a = this.container.querySelector("[data-all-types-container]")) || void 0 === a || a.remove()),
                            (this.cachedResults[s] = n),
                            (r.innerHTML = n),
                            "product" !== i || this.searchFilters || (this.searchFilters = new e9(this.container)),
                            requestAnimationFrame(() => {
                                this.handleActiveTabClasses(t, e), this.scrollToCurrentTabLink(t), this.triggerTabAnimations(e), this.checkVisibleTabsLinks(), this.initInfinityScroll(i);
                            });
                    })
                    .catch((t) => {
                        throw t;
                    });
            }
            onHistoryChange(t) {
                var e;
                let i = (null === (e = t.state) || void 0 === e ? void 0 : e.searchParams) || window.location.search,
                    s = i.indexOf("type=product") > -1,
                    r = i.indexOf("type=article") > -1,
                    o = i.indexOf("type=page") > -1,
                    a = this.container.querySelector(`${eW}[${eX}="product"]`),
                    n = this.container.querySelector(`${eW}[${eX}="article"]`),
                    l = this.container.querySelector(`${eW}[${eX}="page"]`);
                s || r || o
                    ? (s && (null == a || a.dispatchEvent(new CustomEvent("theme:tab:open-from-history", { bubbles: !0, detail: { element: `[${eX}="product"]` } }))),
                      r && (null == n || n.dispatchEvent(new CustomEvent("theme:tab:open-from-history", { bubbles: !0, detail: { element: `[${eX}="article"]` } }))),
                      o && (null == l || l.dispatchEvent(new CustomEvent("theme:tab:open-from-history", { bubbles: !0, detail: { element: `[${eX}="page"]` } }))))
                    : (window.location = i);
            }
            initCustomScrollbar() {
                this.scrollable && !this.customScrollbar && (this.customScrollbar = new t$(this.container));
            }
            infiniteScrollListener() {
                theme.settings.enableInfinityScroll && ((this.ajaxifyFromFiltersEvent = (t) => this.ajaxifyFromFilters(t)), document.addEventListener("theme:tab:ajaxinate", this.ajaxifyFromFiltersEvent));
            }
            ajaxifyFromFilters(t) {
                this.initInfinityScroll(t.detail);
            }
            initInfinityScroll(t) {
                if (!theme.settings.enableInfinityScroll || 0 === this.container.querySelectorAll(eU).length) return;
                let e = this.container.querySelector(`${eR}.${ej}`),
                    i = null == e ? void 0 : e.querySelector(eU),
                    s = null == i ? void 0 : i.classList.contains("is-loaded");
                e ? (!i && this.endlessCollection && this.updateAjaxinateInstancesSettings(t), i && !s && this.initAjaxyfy(t)) : this.initAjaxyfy(t);
            }
            updateAjaxinateInstancesSettings(t) {
                setTimeout(() => {
                    if (0 === this.endlessCollection.endlessScroll.length) return;
                    [...this.endlessCollection.endlessScroll].forEach((t) => {
                        let e = t.containerElement,
                            i = [...this.tab].find((t) => t.classList.contains(ej));
                        !(null !== e.closest(`${eR}.${ej}`)) && i && (t.settings.method = "click");
                    });
                    let e = () => this.initProductGridEvents();
                    if ("product" === t || "all" === t) {
                        let i = (t) => t.settings.container.indexOf("resultsProducts") > -1 || t.settings.container.indexOf("allTypes") > -1,
                            s = [...this.endlessCollection.endlessScroll].find(i);
                        if (!s) return;
                        s.settings.callback = e;
                    }
                });
            }
            initAjaxyfy(t) {
                if ("object" != typeof this.endlessCollection) return (this.endlessCollection = new ed(this.container)), void this.updateAjaxinateInstancesSettings(t);
                this.endlessCollection.endlessScroll.length > 0 && (this.endlessCollection.unload(), (this.endlessCollection = new ed(this.container)), this.updateAjaxinateInstancesSettings(t));
            }
            updateAjaxify(t, e) {
                var i;
                if (0 === (null === (i = this.endlessCollection) || void 0 === i ? void 0 : i.endlessScroll.length)) return;
                let s = t.querySelector(eU),
                    r = `${eU}[data-ajaxinate-id="${null == s ? void 0 : s.dataset.ajaxinateId}"]`;
                s && (this.endlessCollection.update(r), this.updateAjaxinateInstancesSettings(e));
            }
            initProductGridEvents() {
                (this.productGridEvents = new er(this.container)), this.initTooltips();
            }
            initTooltips() {
                var t, e;
                (this.tooltips = this.container.querySelectorAll(eN)),
                    (this.productGrid = this.container.querySelector("[data-collection-products]")),
                    window.innerWidth < theme.sizes.small && (this.tooltips = null === (e = this.productGrid) || void 0 === e ? void 0 : e.querySelectorAll(eN)),
                    null === (t = this.tooltips) ||
                        void 0 === t ||
                        t.forEach((t) => {
                            new tx(t);
                        });
            }
            tabChange(t, e) {
                t.classList.contains(ej) ||
                    (this.isSearchPage ? this.tabChangeFetchContent(t, e) : (this.handleActiveTabClasses(t, e), this.scrollToCurrentTabLink(t), this.triggerTabAnimations(e), this.handleTabSliders(e), this.checkVisibleTabsLinks()));
            }
            handleActiveTabClasses(t, e) {
                var i;
                let s = this.container.querySelector(`${eR}.${ej}`),
                    r = this.container.querySelector(`${eW}.${ej}`);
                null == s || s.classList.remove(ej),
                    null == r || r.classList.remove(ej),
                    t.classList.add(ej),
                    e.classList.add(ej),
                    t.classList.contains(eK) && e.classList.add(eK),
                    null === (i = this.tabRef) ||
                        void 0 === i ||
                        i.forEach((t) => {
                            let i = t.classList.contains(ej),
                                s = t.getAttribute("data-tab-ref") === e.getAttribute(eG);
                            t.classList.toggle(ej, !i && s);
                        });
            }
            scrollToCurrentTabLink(t) {
                let e = t.closest(eV) ? t.closest(eV) : t.parentElement,
                    i = parseInt(window.getComputedStyle(e).getPropertyValue("padding-left"));
                e.scrollTo({ top: 0, left: t.offsetLeft - e.offsetWidth / 2 + t.offsetWidth / 2 + i, behavior: "smooth" }), t.dispatchEvent(new CustomEvent("theme:custom-scrollbar:change", { bubbles: !0, detail: { element: t } }));
            }
            triggerTabAnimations(t) {
                "false" != theme.settings.animations &&
                    (this.tabsContents.querySelectorAll(`.${e0}`).forEach((t) => {
                        t.classList.remove(eQ);
                    }),
                    this.animateElementsTimer && clearTimeout(this.animateElementsTimer),
                    (this.animateElementsTimer = setTimeout(() => {
                        t.querySelectorAll(`.${e0}`).forEach((t) => {
                            t.classList.add(eQ);
                        });
                    }, 150)));
            }
            handleTabSliders(t) {
                let e = t.querySelector("[data-slider]");
                e && e.dispatchEvent(new CustomEvent("theme:tab:change", { bubbles: !1 }));
            }
            checkVisibleTabsLinks() {
                let t = this.container.querySelectorAll(eW),
                    e = this.container.querySelectorAll(`${eW}.${eK}`);
                t.length - e.length < 2 ? this.container.classList.add("alt") : this.container.classList.remove("alt");
            }
            onBlockSelect(t) {
                let e = t.target;
                e && (e.dispatchEvent(new Event("click")), e.parentNode.scrollTo({ top: 0, left: e.offsetLeft - e.clientWidth, behavior: "smooth" }));
            }
            onUnload() {
                this.customScrollbar && this.customScrollbar.unload(), this.isSearchPage && theme.settings.enableInfinityScroll && document.removeEventListener("theme:tab:ajaxinate", this.ajaxifyFromFiltersEvent);
            }
            constructor(t) {
                (this.container = t),
                    (this.tabsContents = t.querySelector("[data-tabs-contents]")),
                    (this.animateElementsTimer = null),
                    (this.isSearchPage = null != t.closest('[data-search-performed="true"]')),
                    this.container &&
                        ((this.scrollable = this.container.querySelector("[data-custom-scrollbar]")),
                        (this.tabRef = this.container.querySelectorAll("[data-tab-ref]")),
                        (this.tabsLink = this.container.querySelectorAll(eW)),
                        (this.tab = this.container.querySelectorAll(eR)),
                        this.assignSearchPageArguments(),
                        this.init(),
                        this.initCustomScrollbar());
            }
        },
        e2 = {
            onLoad() {
                eJ[this.id] = new eY(this.container);
            },
            onBlockSelect(t) {
                eJ[this.id].onBlockSelect(t);
            },
            onUnload() {
                eJ[this.id].onUnload();
            },
        },
        e6 = "[data-drawer]",
        e4 = "[data-drawer-toggle]",
        eZ = "is-open",
        e5 = "js-drawer-open",
        e7 = "cv-h",
        it = "aria-expanded",
        ie = "aria-controls",
        ii = {},
        is = class {
            initListeners() {
                this.drawerToggleButtons.forEach((t) => {
                    t.addEventListener("click", this.drawerToggleEvent);
                }),
                    this.drawers.forEach((t) => {
                        t.addEventListener("keyup", this.keyPressCloseEvent), (this.collapsible = new tn(t)), (this.tabs = new eY(t));
                    }),
                    document.addEventListener("click", this.drawerCloseEvent),
                    document.addEventListener("theme:drawer:closing", this.drawerCloseEvent);
            }
            toggle(t) {
                t.preventDefault();
                let e = document.querySelector(`#${t.target.getAttribute(ie)}`);
                e && (e.classList.contains(eZ) ? this.close() : this.open(t));
            }
            open(t) {
                let e = t.target,
                    i = document.querySelector(`#${t.target.getAttribute(ie)}`);
                if (!i) return;
                let s = i.querySelector("[data-scroll]") || i;
                document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: s })),
                    document.dispatchEvent(new CustomEvent("theme:drawer:open"), { bubbles: !0 }),
                    document.body.classList.add(e5),
                    i.classList.add(eZ),
                    i.classList.remove(e7),
                    e.setAttribute(it, !0),
                    setTimeout(() => {
                        (this.a11y.state.trigger = e), this.a11y.trapFocus({ container: i });
                    });
            }
            close() {
                if (!document.body.classList.contains(e5)) return;
                let t = document.querySelector(`${e6}.${eZ}`);
                this.drawerToggleButtons.forEach((t) => {
                    t.setAttribute(it, !1);
                }),
                    this.a11y.removeTrapFocus({ container: t }),
                    t.classList.remove(eZ);
                let e = (i) => {
                    i.target === t &&
                        (requestAnimationFrame(() => {
                            t.classList.add(e7), document.dispatchEvent(new CustomEvent("theme:drawer:close"), { bubbles: !0 }), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                        }),
                        t.removeEventListener("transitionend", e));
                };
                t.addEventListener("transitionend", e), document.body.classList.remove(e5);
            }
            onUnload() {
                this.close(),
                    this.drawerToggleButtons.forEach((t) => {
                        t.removeEventListener("click", this.drawerToggleEvent);
                    }),
                    this.drawers.forEach((t) => {
                        t.removeEventListener("keyup", this.keyPressCloseEvent);
                    }),
                    document.removeEventListener("click", this.drawerCloseEvent),
                    document.removeEventListener("theme:drawer:closing", this.drawerCloseEvent),
                    this.collapsible && this.collapsible.onUnload(),
                    this.tabs && this.tabs.onUnload();
            }
            constructor(t) {
                (this.container = t),
                    (this.drawers = this.container.querySelectorAll(e6)),
                    (this.drawerToggleButtons = this.container.querySelectorAll(e4)),
                    (this.a11y = tu),
                    (this.drawerToggleEvent = Z((t) => {
                        this.toggle(t);
                    }, 150)),
                    (this.keyPressCloseEvent = Z((t) => {
                        t.code === theme.keyboardKeys.ESCAPE && this.close(t);
                    }, 150)),
                    (this.drawerCloseEvent = (t) => {
                        let e = document.querySelector(`${e6}.${eZ}`),
                            i = !1;
                        if (!e) return;
                        "click" === t.type && (i = t.target.matches(e4));
                        let s = !!e && e.contains(t.target),
                            r = e.closest("[data-quick-view-item]"),
                            o = !!r && r.contains(t.target);
                        i || s || o || this.close();
                    }),
                    this.initListeners();
            }
        },
        ir = {
            onLoad() {
                this.container.classList.contains("site-header") && (this.container = this.container.parentNode), (ii[this.id] = new is(this.container));
            },
            onUnload() {
                ii[this.id].onUnload();
            },
        },
        io = (t, e = !1, i = "block") => {
            t && (e ? t.style.removeProperty("display") : (t.style.display = i));
        },
        ia = (t) => {
            t && (t.style.display = "none");
        },
        il = "[data-header-height]",
        ih = { close: ".js-modal-close", open: ".js-modal-open-store-availability-modal", openClass: "modal--is-active", openBodyClass: "modal--is-visible", closeModalOnClick: !1, scrollIntoView: !1 },
        ic = "[data-store-availability-modal]",
        id = "[data-store-availability-modal-open]",
        iu = "sold-out",
        ip = "unavailable",
        im = { history: !1, focus: !1, mainClass: "pswp--notification pswp--not-close-btn", closeOnVerticalDrag: !1 },
        ig = class {
            init() {
                let t = [{ html: this.notificationPopupHtml }];
                (this.a11y.state.trigger = this.button), new sl(t, im, 1);
            }
            constructor(t) {
                (this.button = t), (this.a11y = tu), (this.notificationPopupHtml = this.button.getAttribute("data-notification-popup")), "" !== this.notificationPopupHtml.trim() && this.init();
            }
        },
        iy = "[data-price-wrapper]",
        iv = "[data-product-unit]",
        ib = "data-group-toggle",
        iS = "[data-notification-button-text]",
        iE = "[data-option-position]",
        iL = "hidden",
        ik = "variant--soldout",
        iw = "variant--unavailabe",
        i$ = "product__price--sale",
        iA = "count-is-low",
        iq = "count-is-in",
        iC = "count-is-out",
        iT = "count-is-unavailable",
        iP = "selector-wrapper--visible",
        i_ = "data-notification-popup",
        iF = class {
            init() {
                let t = null,
                    e = this.container.querySelector("[data-product-json]");
                e && (t = e.innerHTML),
                    t
                        ? ((this.productJSON = JSON.parse(t)),
                          this.linkForm(),
                          (this.sellout = new (class {
                              init() {
                                  this.update();
                              }
                              update() {
                                  this.getCurrentState(),
                                      this.optionElements.forEach((t) => {
                                          let e = t.value || t.getAttribute("data-value"),
                                              i = t.closest("[data-option-position]");
                                          if (!i) return;
                                          let s = i.getAttribute("data-option-position"),
                                              r = parseInt(s, 10) - 1,
                                              o = [...this.selections];
                                          o[r] = e;
                                          let a = this.productJSON.variants.find((t) => {
                                              let e = !0;
                                              for (let i = 0; i < o.length; i++) t.options[i] !== o[i] && (e = !1);
                                              return e;
                                          });
                                          t.parentElement.classList.remove(iu, ip), void 0 === a ? t.parentElement.classList.add(ip) : !1 === (null == a ? void 0 : a.available) && t.parentElement.classList.add(iu);
                                      });
                              }
                              getCurrentState() {
                                  for (var t of ((this.formData = new FormData(this.form)), (this.selections = []), this.formData.entries())) t[0].includes("options[") && this.selections.push(t[1]);
                              }
                              constructor(t, e) {
                                  (this.container = t),
                                      (this.productJSON = e),
                                      (this.form = this.container.querySelector("[data-product-form]")),
                                      (this.formData = new FormData(this.form)),
                                      (this.optionElements = this.container.querySelectorAll('[name^="options"], [data-popout-option]')),
                                      this.productJSON && this.form && this.init();
                              }
                          })(this.container, this.productJSON)))
                        : console.error("Missing product JSON");
            }
            destroy() {
                this.productForm.destroy();
            }
            linkForm() {
                this.productForm = new (class {
                    destroy() {
                        this._listeners.removeAll();
                    }
                    options() {
                        return this._serializeInputValues(this.optionInputs, function (t) {
                            return (t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2]), t;
                        });
                    }
                    variant() {
                        var t, e, i, s, r, o, a, n;
                        let l = this.options();
                        return l.length
                            ? ((t = this.product),
                              (e = l),
                              tB(t),
                              (o =
                                  ((i = t),
                                  (s = e),
                                  tB(i),
                                  (function (t) {
                                      if (!Array.isArray(t)) throw TypeError(t + " is not an array.");
                                      if (0 === t.length) throw Error(t + " is empty.");
                                      if (!t[0].hasOwnProperty("name")) throw Error(t[0] + "does not contain name key.");
                                      if ("string" != typeof t[0].name) throw TypeError("Invalid value type passed for name of option " + t[0].name + ". Value should be string.");
                                  })(s),
                                  (r = []),
                                  s.forEach(function (t) {
                                      for (var e = 0; e < i.options.length; e++)
                                          if ((i.options[e].name || i.options[e]).toLowerCase() === t.name.toLowerCase()) {
                                              r[e] = t.value;
                                              break;
                                          }
                                  }),
                                  r)),
                              (a = t),
                              (n = o),
                              tB(a),
                              (function (t) {
                                  if (Array.isArray(t) && "object" == typeof t[0]) throw Error(t + "is not a valid array of options.");
                              })(n),
                              a.variants.filter(function (t) {
                                  return n.every(function (e, i) {
                                      return t.options[i] === e;
                                  });
                              })[0] || null)
                            : this.product.variants[0];
                    }
                    plan(t) {
                        let e = { allocation: null, group: null, detail: null },
                            i = new FormData(this.form).get("selling_plan");
                        return (
                            i &&
                                t &&
                                (e.allocation = t.selling_plan_allocations.find(function (t) {
                                    return t.selling_plan_id.toString() === i.toString();
                                })),
                            e.allocation &&
                                (e.group = this.product.selling_plan_groups.find(function (t) {
                                    return t.id.toString() === e.allocation.selling_plan_group_id.toString();
                                })),
                            e.group &&
                                (e.detail = e.group.selling_plans.find(function (t) {
                                    return t.id.toString() === i.toString();
                                })),
                            e && e.allocation && e.detail && e.allocation ? e : null
                        );
                    }
                    properties() {
                        return this._serializeInputValues(this.propertyInputs, function (t) {
                            return (t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2]), t;
                        });
                    }
                    quantity() {
                        return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1;
                    }
                    getFormState() {
                        let t = this.variant();
                        return { options: this.options(), variant: t, properties: this.properties(), quantity: this.quantity(), plan: this.plan(t) };
                    }
                    _setIdInputValue(t) {
                        t && t.id ? (this.variantElement.value = t.id.toString()) : (this.variantElement.value = ""), this.variantElement.dispatchEvent(new Event("change"));
                    }
                    _onSubmit(t, e) {
                        (e.dataset = this.getFormState()), t.onFormSubmit && t.onFormSubmit(e);
                    }
                    _onOptionChange(t) {
                        this._setIdInputValue(t.dataset.variant);
                    }
                    _onFormEvent(t) {
                        return void 0 === t
                            ? Function.prototype.bind()
                            : function (e) {
                                  (e.dataset = this.getFormState()), this._setIdInputValue(e.dataset.variant), t(e);
                              }.bind(this);
                    }
                    _initInputs(t, e) {
                        return Array.prototype.slice.call(this.element.querySelectorAll(t)).map(
                            function (t) {
                                return this._listeners.add(t, "change", this._onFormEvent(e)), t;
                            }.bind(this)
                        );
                    }
                    _serializeInputValues(t, e) {
                        return t.reduce(function (t, i) {
                            return (i.checked || ("radio" !== i.type && "checkbox" !== i.type)) && t.push(e({ name: i.name, value: i.value })), t;
                        }, []);
                    }
                    _validateProductObject(t) {
                        if ("object" != typeof t) throw TypeError(t + " is not an object.");
                        if (void 0 === t.variants[0].options) throw TypeError("Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route");
                        return t;
                    }
                    constructor(t, e, i) {
                        (this.element = t),
                            (this.form = "FORM" == this.element.tagName ? this.element : this.element.querySelector("form")),
                            (this.product = this._validateProductObject(e)),
                            (this.variantElement = this.element.querySelector('[name="id"]')),
                            (i = i || {}),
                            (this._listeners = new tO()),
                            this._listeners.add(this.element, "submit", this._onSubmit.bind(this, i)),
                            (this.optionInputs = this._initInputs('[name^="options"]', i.onOptionChange)),
                            (this.planInputs = this._initInputs('[name="selling_plan"]', i.onPlanChange)),
                            (this.quantityInputs = this._initInputs('[name="quantity"]', i.onQuantityChange)),
                            (this.propertyInputs = this._initInputs('[name^="properties"]', i.onPropertyChange));
                    }
                })(this.productForm, this.productJSON, { onOptionChange: this.onOptionChange.bind(this), onPlanChange: this.onPlanChange.bind(this) });
                let t = this.productForm.getFormState();
                if ((this.pushState(t, !0), this.subsToggleListeners(), this.swatchesContainer)) {
                    this.observeSwatch(t);
                    let e = this.swatchesContainer.closest(iE),
                        i = e.querySelector("[data-swatches-more]");
                    null == i ||
                        i.addEventListener("click", (t) => {
                            t.preventDefault(), e.classList.contains(iP) ? e.classList.remove(iP) : e.classList.add(iP);
                        });
                }
            }
            onOptionChange(t) {
                this.pushState(t.dataset), this.updateProductImage(t);
            }
            onPlanChange(t) {
                this.subPrices && this.pushState(t.dataset);
            }
            pushState(t, e = !1) {
                var i;
                (this.productState = this.setProductState(t)),
                    this.updateAddToCartState(t),
                    this.updateProductPrices(t),
                    this.updateSaleText(t),
                    this.updateSubscriptionText(t),
                    this.fireHookEvent(t),
                    this.updateRemaining(t),
                    null === (i = this.sellout) || void 0 === i || i.update(t),
                    this.enableHistoryState && !e && this.updateHistoryState(t),
                    this.storeAvailability && (t.variant ? this.storeAvailability.updateContent(t.variant.id, this.productForm.product.title) : this.storeAvailability.clearContent());
            }
            updateAddToCartState(t) {
                let e = t.variant,
                    i = this.container.querySelectorAll(iy),
                    s = this.container.querySelectorAll("[data-add-to-cart]"),
                    r = this.container.querySelectorAll("[data-add-to-cart-text]"),
                    o = this.container.querySelectorAll("[data-form-wrapper]"),
                    a = this.container.querySelector("[data-buy-it-now]"),
                    n = theme.strings.add_to_cart;
                this.productJSON.tags.includes("_preorder") && (n = theme.strings.preorder),
                    null == i ||
                        i.forEach((t) => {
                            t.classList.toggle("product__price--hidden", !e);
                        }),
                    null == s ||
                        s.forEach((t) => {
                            var i, s;
                            if (t.matches("[data-upsell-btn]") || ((t.disabled = !0), null == a || a.classList.add(iL), !e) || ((t.disabled = !1), e.available && (null == a || a.classList.remove(iL)), !t.hasAttribute(i_))) return;
                            let r = t.id.replace("AddToCart", "NotificationForm"),
                                o = this.sessionStorage.getItem("notification_form_id"),
                                n = !1,
                                l = e.id,
                                h = e.title;
                            if (o) {
                                let c = o.substring(0, o.lastIndexOf("--")),
                                    d = o.split("--").slice(-1)[0];
                                (n = r === c) &&
                                    ((this.latestVariantId = l),
                                    (this.latestVariantTitle = h),
                                    (l = Number(d)),
                                    this.productJSON.variants.forEach((t) => {
                                        t.id === l && (h = t.title);
                                    }));
                            }
                            let u = t.getAttribute(i_),
                                p = null === (i = new DOMParser().parseFromString(u, "text/html").querySelector(iS)) || void 0 === i ? void 0 : i.innerHTML;
                            if ("" != this.latestVariantId && "" != this.latestVariantTitle) {
                                u = (u = u.replaceAll(this.latestVariantId, l)).replaceAll(this.latestVariantTitle, h);
                                let m = null === (s = new DOMParser().parseFromString(u, "text/html").querySelector(iS)) || void 0 === s ? void 0 : s.innerHTML;
                                u = u.replace(m, p);
                            }
                            t.setAttribute(i_, u), n && (this.scrollToForm(this.product.closest(".shopify-section")), new ig(t)), (this.latestVariantId = l), (this.latestVariantTitle = h);
                        }),
                    null == r ||
                        r.forEach((t) => {
                            if (e) {
                                if (e.available) t.innerHTML = n;
                                else if (((t.innerHTML = theme.strings.sold_out), t.parentNode.hasAttribute(i_))) {
                                    if (t.closest("[data-quick-view-item]")) return;
                                    t.innerHTML = `${theme.strings.sold_out} - ${theme.strings.newsletter_product_availability}`;
                                }
                            } else t.innerHTML = theme.strings.unavailable;
                        }),
                    null == o ||
                        o.forEach((t) => {
                            if (!e) return t.classList.add(iw), void t.classList.remove(ik);
                            let i = t.querySelector("[data-product-select]");
                            if ((i && (i.value = e.id), !e.available)) return t.classList.add(ik), void t.classList.remove(iw);
                            t.classList.remove(ik, iw);
                        });
            }
            updateHistoryState(t) {
                let e = t.variant,
                    i = t.plan,
                    s = window.location.href;
                if (e && s.includes("/product")) {
                    let r = new window.URL(s),
                        o = r.searchParams;
                    o.set("variant", e.id), i && i.detail && i.detail.id && this.productState.hasPlan ? o.set("selling_plan", i.detail.id) : o.delete("selling_plan"), (r.search = o.toString());
                    let a = r.toString();
                    window.history.replaceState({ path: a }, "", a);
                }
            }
            updateRemaining(t) {
                let e = t.variant,
                    i = [iq, iC, iT, iA];
                if (e && this.remainingWrapper && this.remainingJSON) {
                    let s = this.remainingJSON[e.id];
                    ("out" === s || s < 1) && (this.remainingWrapper.classList.remove(...i), this.remainingWrapper.classList.add(iC)),
                        ("in" === s || s >= this.remainingMaxInt) && (this.remainingWrapper.classList.remove(...i), this.remainingWrapper.classList.add(iq)),
                        ("low" === s || (s > 0 && s < this.remainingMaxInt)) && (this.remainingWrapper.classList.remove(...i), this.remainingWrapper.classList.add(iA), this.remainingCount && (this.remainingCount.innerHTML = s));
                } else !e && this.remainingWrapper && (this.remainingWrapper.classList.remove(...i), this.remainingWrapper.classList.add(iT));
            }
            getBaseUnit(t) {
                return 1 === t.unit_price_measurement.reference_value ? t.unit_price_measurement.reference_unit : t.unit_price_measurement.reference_value + t.unit_price_measurement.reference_unit;
            }
            subsToggleListeners() {
                this.container.querySelectorAll("[data-toggles-group]").forEach((t) => {
                    t.addEventListener(
                        "change",
                        function (t) {
                            let e = t.target.value.toString(),
                                i = this.container.querySelector(`[${ib}="${e}"]`),
                                s = this.container.querySelectorAll(`[${ib}]`);
                            if (i) {
                                i.classList.remove(iL);
                                let r = i.querySelector('[name="selling_plan"]');
                                (r.checked = !0), r.dispatchEvent(new Event("change"));
                            }
                            s.forEach((t) => {
                                t !== i &&
                                    (t.classList.add(iL),
                                    t.querySelectorAll('[name="selling_plan"]').forEach((t) => {
                                        (t.checked = !1), t.dispatchEvent(new Event("change"));
                                    }));
                            });
                        }.bind(this)
                    );
                });
            }
            updateSaleText(t) {
                this.productState.planSale ? this.updateSaleTextSubscription(t) : this.productState.onSale ? this.updateSaleTextStandard(t) : this.priceOffWrap && this.priceOffWrap.classList.add(iL);
            }
            updateSaleTextStandard(t) {
                if (!this.priceOffType) return;
                this.priceOffType.innerHTML = window.theme.strings.sale_badge_text || "sale";
                let e = t.variant;
                if (window.theme.settings.savingBadgeType && "percentage" === window.theme.settings.savingBadgeType) {
                    let s = (e.compare_at_price - e.price) / e.compare_at_price;
                    this.priceOffAmount.innerHTML = `${Math.floor(100 * s)}%`;
                } else {
                    let r = e.compare_at_price - e.price;
                    this.priceOffAmount.innerHTML = i.formatMoney(r, theme.moneyFormat);
                }
                this.priceOffWrap.classList.remove(iL);
            }
            updateSaleTextSubscription(t) {
                let e = t.variant,
                    s = this.productForm.product.selling_plan_groups.find((t) => t.id === e.selling_plan_allocations[0].selling_plan_group_id),
                    r = t.plan ? t.plan.detail.price_adjustments[0] : s.selling_plans[0].price_adjustments[0],
                    o = r.value || 0,
                    a = "percentage" === r.value_type ? `${o}%` : i.formatMoney(e.price - o, theme.moneyFormat);
                (this.priceOffType.innerHTML = window.theme.strings.subscription || "subscripton"), (this.priceOffAmount.innerHTML = a), this.priceOffWrap.classList.remove(iL);
            }
            updateSubscriptionText(t) {
                t.plan && this.planDecription && null !== t.plan.detail.description
                    ? ((this.planDecription.innerHTML = t.plan.detail.description), this.planDecription.classList.remove(iL))
                    : this.planDecription && this.planDecription.classList.add(iL);
            }
            updateProductPrices(t) {
                let e = t.variant,
                    s = t.plan;
                this.container.querySelectorAll(iy).forEach((t) => {
                    let r = t.querySelector("[data-compare-price]"),
                        o = t.querySelector("[data-product-price]"),
                        a = "",
                        n = "";
                    if ((this.productState.available && ((a = e.compare_at_price), (n = e.price)), this.productState.hasPlan && (n = s ? s.allocation.price : e.selling_plan_allocations[0].per_delivery_price), this.productState.planSale)) {
                        let l = s ? s.allocation.price : e.selling_plan_allocations[0].per_delivery_price;
                        (a = s ? s.allocation.compare_at_price : e.selling_plan_allocations[0].compare_at_price), (n = l);
                    }
                    r &&
                        (this.productState.onSale || this.productState.planSale ? (r.classList.remove(iL), o.classList.add(i$)) : (r.classList.add(iL), o.classList.remove(i$)),
                        (r.innerHTML = theme.settings.currency_code_enable ? i.formatMoney(a, theme.moneyWithCurrencyFormat) : i.formatMoney(a, theme.moneyFormat))),
                        (o.innerHTML = 0 === n ? window.theme.strings.free : theme.settings.currency_code_enable ? i.formatMoney(n, theme.moneyWithCurrencyFormat) : i.formatMoney(n, theme.moneyFormat));
                }),
                    this.hasUnitPricing && this.updateProductUnits(t);
            }
            updateProductUnits(t) {
                let e = t.variant,
                    s = t.plan,
                    r = null;
                if (
                    (e && e.unit_price && (r = e.unit_price),
                    s && (null == s ? void 0 : s.allocation) && (null == s ? void 0 : s.allocation.unit_price) && (r = s.allocation.unit_price),
                    !s && e.selling_plan_allocations && e.selling_plan_allocations.length > 0 && (r = e.selling_plan_allocations[0].unit_price),
                    r)
                ) {
                    let o = this.getBaseUnit(e),
                        a = 0 === r ? window.theme.strings.free : i.formatMoney(r, theme.moneyFormat);
                    (this.container.querySelector("[data-product-unit-price]").innerHTML = a), (this.container.querySelector("[data-product-base]").innerHTML = o), io(this.container.querySelector(iv));
                } else ia(this.container.querySelector(iv));
            }
            fireHookEvent(t) {
                let e = t.variant;
                this.container.dispatchEvent(new CustomEvent("theme:variant:change", { detail: { variant: e }, bubbles: !0 }));
            }
            setProductState(t) {
                let e = t.variant,
                    i = t.plan,
                    s = { available: !0, soldOut: !1, onSale: !1, showUnitPrice: !1, requiresPlan: !1, hasPlan: !1, planPerDelivery: !1, planSale: !1 };
                if (e) {
                    let r = e.requires_selling_plan || !1;
                    e.available || (s.soldOut = !0),
                        e.compare_at_price > e.price && (s.onSale = !0),
                        e.unit_price && (s.showUnitPrice = !0),
                        this.product && this.product.requires_selling_plan && (s.requiresPlan = !0),
                        i && this.subPrices && ((s.hasPlan = !0), i.allocation.per_delivery_price !== i.allocation.price && (s.planPerDelivery = !0), e.price > i.allocation.price && (s.planSale = !0)),
                        !i && r && ((s.hasPlan = !0), e.selling_plan_allocations[0].per_delivery_price !== e.selling_plan_allocations[0].price && (s.planPerDelivery = !0), e.price > e.selling_plan_allocations[0].price && (s.planSale = !0));
                } else s.available = !1;
                return s;
            }
            updateProductImage(t) {
                let i = t.dataset.variant;
                if (!i || !(null == i ? void 0 : i.featured_media)) return;
                let s = this.container.querySelector(`[data-product-image][data-image-id="${i.featured_media.id}"]`),
                    r = null == s ? void 0 : s.closest("[data-product-slide]");
                if (r) {
                    let o = parseInt([...r.parentElement.children].indexOf(r)),
                        a = this.container.querySelector("[data-product-single-media-slider]"),
                        n = e.data(a);
                    if (n && n.isActive) {
                        let l = a.querySelector(`[data-id="${i.featured_media.id}"]`);
                        if (l) {
                            let h = parseInt([...l.parentNode.children].indexOf(l));
                            n.select(h);
                        }
                        return;
                    }
                    if (this.tallLayout) {
                        let c = s.getBoundingClientRect().top;
                        if (0 === o && c + window.scrollY > window.pageYOffset) return;
                        document.dispatchEvent(new CustomEvent("theme:tooltip:close", { bubbles: !1, detail: { hideTransition: !1 } })),
                            ((t) => {
                                let e = document.querySelector("[data-header-sticky]") && document.querySelector(il) ? document.querySelector(il).getBoundingClientRect().height : 0;
                                window.scrollTo({ top: t + window.scrollY - e, left: 0, behavior: "smooth" });
                            })(c);
                    }
                }
            }
            observeSwatch(t) {
                let e = this.swatchesContainer.querySelector(`[data-swatch-variant*="${t.variant.id}"]`);
                this.swatchesContainer.closest(iE).classList.remove(iP),
                    new IntersectionObserver(
                        (t, e) => {
                            t.forEach((t) => {
                                0 == t.intersectionRatio && this.swatchesContainer.closest(iE).classList.add(iP);
                            });
                        },
                        { root: this.container, threshold: [0.95, 1] }
                    ).observe(e);
            }
            scrollToForm(t) {
                var e;
                let i = null === (e = document.querySelector("[data-site-header]")) || void 0 === e ? void 0 : e.dataset.height;
                visibilityHelper.isElementPartiallyVisible(t) ||
                    visibilityHelper.isElementTotallyVisible(t) ||
                    setTimeout(() => {
                        let e = t.getBoundingClientRect().top - i;
                        window.scrollTo({ top: e, left: 0, behavior: "smooth" });
                    }, 400);
            }
            constructor(t) {
                if (
                    ((this.container = t),
                    (this.product = this.container.querySelector("[data-product]")),
                    (this.productForm = this.container.querySelector("[data-product-form]")),
                    (this.tallLayout = "true" === this.container.getAttribute("data-tall-layout")),
                    !this.product || !this.productForm)
                )
                    return void new td(this.container).init();
                (this.storeAvailabilityContainer = this.container.querySelector("[data-store-availability-container]")),
                    (this.enableHistoryState = "true" === this.container.getAttribute("data-enable-history-state")),
                    (this.hasUnitPricing = this.container.querySelector(iv)),
                    (this.subSelectors = this.container.querySelector("[data-subscription-selectors]")),
                    (this.subPrices = this.container.querySelector("[data-subscription-watch-price]")),
                    (this.priceOffWrap = this.container.querySelector("[data-price-off]")),
                    (this.priceOffAmount = this.container.querySelector("[data-price-off-amount]")),
                    (this.priceOffType = this.container.querySelector("[data-price-off-type]")),
                    (this.planDecription = this.container.querySelector("[data-plan-description]")),
                    (this.swatchesContainer = this.container.querySelector("[data-swatches-container]")),
                    (this.latestVariantId = ""),
                    (this.latestVariantTitle = ""),
                    (this.sellout = null),
                    (this.sessionStorage = window.sessionStorage),
                    (this.remainingWrapper = this.container.querySelector("[data-remaining-wrapper]")),
                    this.remainingWrapper &&
                        ((this.remainingMaxInt = parseInt(this.remainingWrapper.dataset.remainingMax, 10)),
                        (this.remainingCount = this.container.querySelector("[data-remaining-count]")),
                        (this.remainingJSONWrapper = this.container.querySelector("[data-product-remaining-json]")),
                        (this.remainingJSON = null),
                        this.remainingJSONWrapper && "" !== this.remainingJSONWrapper.innerHTML && (this.remainingJSON = JSON.parse(this.remainingJSONWrapper.innerHTML))),
                    this.storeAvailabilityContainer &&
                        (this.storeAvailability = new (class {
                            updateContent(t, e) {
                                this._fetchStoreAvailabilities(t, e);
                            }
                            clearContent() {
                                this.container.innerHTML = "";
                            }
                            _initModal() {
                                return new (class {
                                    init() {
                                        this.openElement.addEventListener("click", this.open.bind(this)), this.modal.querySelector(this.config.close).addEventListener("click", this.closeModal.bind(this));
                                    }
                                    open(t) {
                                        let e = !1;
                                        if ((t ? t.preventDefault() : (e = !0), this.modalIsOpen && !e)) return void this.closeModal();
                                        this.modal.classList.add(this.config.openClass),
                                            this.nodes.parents.forEach((t) => {
                                                t.classList.add(this.config.openBodyClass);
                                            }),
                                            (this.modalIsOpen = !0);
                                        let i = document.querySelector("[data-store-availability-list]");
                                        document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: i })),
                                            this.config.scrollIntoView && this.scrollIntoView(),
                                            this.bindEvents(),
                                            this.a11y.trapFocus({ container: this.modal });
                                    }
                                    closeModal() {
                                        if (this.modalIsOpen) {
                                            document.activeElement.blur(), this.modal.classList.remove(this.config.openClass);
                                            var t = this;
                                            this.nodes.parents.forEach(function (e) {
                                                e.classList.remove(t.config.openBodyClass);
                                            }),
                                                (this.modalIsOpen = !1),
                                                this.openElement.focus(),
                                                this.unbindEvents(),
                                                this.a11y.removeTrapFocus({ container: this.modal }),
                                                document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: 400 }));
                                        }
                                    }
                                    bindEvents() {
                                        (this.keyupHandler = this.keyupHandler.bind(this)),
                                            (this.clickHandler = this.clickHandler.bind(this)),
                                            document.body.addEventListener("keyup", this.keyupHandler),
                                            document.body.addEventListener("click", this.clickHandler);
                                    }
                                    unbindEvents() {
                                        document.body.removeEventListener("keyup", this.keyupHandler), document.body.removeEventListener("click", this.clickHandler);
                                    }
                                    keyupHandler(t) {
                                        t.code === theme.keyboardKeys.ESCAPE && this.closeModal();
                                    }
                                    clickHandler(t) {
                                        !this.config.closeModalOnClick || this.modal.contains(t.target) || t.target.matches(this.config.open) || this.closeModal();
                                    }
                                    scrollIntoView() {
                                        this.focusOnOpen.scrollIntoView({ behavior: "smooth" });
                                    }
                                    constructor(t, e) {
                                        if (((this.modal = document.getElementById(t)), !this.modal)) return !1;
                                        (this.nodes = { parents: [document.querySelector("html"), document.body] }),
                                            (this.config = Object.assign(ih, e)),
                                            (this.modalIsOpen = !1),
                                            (this.focusOnOpen = this.config.focusOnOpen ? document.getElementById(this.config.focusOnOpen) : this.modal),
                                            (this.openElement = document.querySelector(this.config.open)),
                                            (this.a11y = tu),
                                            this.init();
                                    }
                                })("StoreAvailabilityModal", { close: "[data-store-availability-modal-close]", open: id, closeModalOnClick: !0, openClass: "store-availabilities-modal--active", scrollIntoView: !1 });
                            }
                            _fetchStoreAvailabilities(t, e) {
                                this.clearContent();
                                let i = this;
                                fetch("/variants/" + t + "/?section_id=store-availability")
                                    .then(function (t) {
                                        return t.text();
                                    })
                                    .then(function (t) {
                                        let s = document.querySelector("body"),
                                            r = s.querySelector(ic);
                                        r && r.remove(),
                                            (i.container.innerHTML = t),
                                            (i.container.innerHTML = i.container.firstElementChild.innerHTML),
                                            "" !== i.container.firstElementChild.innerHTML.trim()
                                                ? i.container.querySelector(id) && ((i.modal = i._initModal()), i._updateProductTitle(e), (r = i.container.querySelector(ic)) && s.appendChild(r))
                                                : i.clearContent();
                                    });
                            }
                            _updateProductTitle(t) {
                                this.container.querySelector("[data-store-availability-modal-product__title]").textContent = t;
                            }
                            constructor(t) {
                                this.container = t;
                            }
                        })(this.storeAvailabilityContainer)),
                    new td(this.container).init(),
                    this.init();
            }
        },
        ix = {
            onLoad() {
                this.section = new iF(this.container);
            },
        },
        iI = "[data-popout-option]",
        iH = "[data-product-grid-item]",
        iD = "select-popout__list--visible",
        i8 = "select-popout--alt",
        iM = "--current",
        iO = "aria-current",
        iB = "aria-expanded",
        i9 = "data-value",
        iz = "data-quantity-field",
        iW = {},
        iR = class {
            unload() {
                this.popoutOptions.length &&
                    this.popoutOptions.forEach((t) => {
                        t.removeEventListener("theme:popout:click", this.popupOptionsClickEvent), t.removeEventListener("click", this._connectOptionsDispatchEvent);
                    }),
                    this.popoutToggle.removeEventListener("click", this.popupToggleClickEvent),
                    this.popoutToggle.removeEventListener("focusout", this.popupToggleFocusoutEvent),
                    this.popoutList.removeEventListener("focusout", this.popupListFocusoutEvent),
                    this.popout.removeEventListener("keyup", this.popoutKeyupEvent),
                    document.removeEventListener("theme:cart:update", this.updatePopout),
                    document.body.removeEventListener("click", this.bodyClick);
            }
            popupToggleClick(t) {
                let e = "true" === t.currentTarget.getAttribute(iB);
                if (this.popoutList.closest(iH)) {
                    let i = this.popoutList.closest(iH).querySelector("[data-product-image]");
                    i && i.classList.toggle("is-visible", !e);
                }
                t.currentTarget.setAttribute(iB, !e), this.popoutList.classList.toggle(iD);
            }
            popupToggleFocusout(t) {
                if (!t.relatedTarget) return;
                let e = this.popout.contains(t.relatedTarget),
                    i = t.relatedTarget.hasAttribute("data-quick-view-item");
                e || i || this._hideList();
            }
            popupListFocusout(t) {
                let e = t.currentTarget.contains(t.relatedTarget);
                this.popoutList.classList.contains(iD) && !e && this._hideList();
            }
            popupOptionsClick(t) {
                if ("#" === t.target.closest(iI).attributes.href.value) {
                    t.preventDefault();
                    let e = "";
                    if ((t.currentTarget.getAttribute(i9) && (e = t.currentTarget.getAttribute(i9)), (this.popoutInput.value = e), this.popoutPrevent)) {
                        this.popoutInput.dispatchEvent(new Event("change")), !t.detail.preventTrigger && this.popoutInput.hasAttribute(iz) && this.popoutInput.dispatchEvent(new Event("input"));
                        let i = this.popoutList.querySelector(`[class*="${iM}"]`),
                            s = iM;
                        if (i && i.classList.length) {
                            for (let r of i.classList)
                                if (r.includes(iM)) {
                                    s = r;
                                    break;
                                }
                        }
                        let o = this.popoutList.querySelector(`.${s}`);
                        o && (o.classList.remove(`${s}`), t.currentTarget.parentElement.classList.add(`${s}`));
                        let a = this.popoutList.querySelector("[aria-current]");
                        a && (a.removeAttribute(iO), t.currentTarget.setAttribute(iO, "true")), "" !== e && (this.popoutText.textContent = e), this.popupToggleFocusout(t), this.popupListFocusout(t);
                    } else this._submitForm(e);
                }
            }
            updatePopout() {
                let t = this.popoutList.querySelector(`[${i9}="${this.popoutInput.value}"]`);
                t ? (t.dispatchEvent(new CustomEvent("theme:popout:click", { cancelable: !0, bubbles: !0, detail: { preventTrigger: !0 } })), t.parentElement.nextSibling || this.popout.classList.add(i8)) : this.popout.classList.add(i8);
            }
            popoutKeyup(t) {
                t.code === theme.keyboardKeys.ESCAPE && (this._hideList(), this.popoutToggle.focus());
            }
            bodyClick(t) {
                let e = this.popout.contains(t.target);
                this.popoutList.classList.contains(iD) && !e && this._hideList();
            }
            _connectToggle() {
                this.popoutToggle.addEventListener("click", this.popupToggleClickEvent);
            }
            _connectOptions() {
                this.popoutOptions.length &&
                    this.popoutOptions.forEach((t) => {
                        t.addEventListener("theme:popout:click", this.popupOptionsClickEvent), t.addEventListener("click", this._connectOptionsDispatchEvent);
                    });
            }
            _connectOptionsDispatch(t) {
                let e = new CustomEvent("theme:popout:click", { cancelable: !0, bubbles: !0, detail: { preventTrigger: !1 } });
                t.target.dispatchEvent(e) || t.preventDefault();
            }
            _onFocusOut() {
                this.popoutToggle.addEventListener("focusout", this.popupToggleFocusoutEvent),
                    this.popoutList.addEventListener("focusout", this.popupListFocusoutEvent),
                    this.popout.addEventListener("keyup", this.popoutKeyupEvent),
                    document.body.addEventListener("click", this.bodyClick);
            }
            _submitForm() {
                let t = this.popout.closest("form");
                t && t.submit();
            }
            _hideList() {
                this.popoutList.classList.remove(iD), this.popoutToggle.setAttribute(iB, !1);
            }
            constructor(t) {
                (this.popout = t),
                    (this.popoutList = this.popout.querySelector("[data-popout-list]")),
                    (this.popoutToggle = this.popout.querySelector("[data-popout-toggle]")),
                    (this.popoutText = this.popout.querySelector("[data-popout-text]")),
                    (this.popoutInput = this.popout.querySelector("[data-popout-input]")),
                    (this.popoutOptions = this.popout.querySelectorAll(iI)),
                    (this.popoutPrevent = "true" === this.popout.getAttribute("data-popout-prevent")),
                    (this.popupToggleFocusoutEvent = (t) => this.popupToggleFocusout(t)),
                    (this.popupListFocusoutEvent = (t) => this.popupListFocusout(t)),
                    (this.popupToggleClickEvent = (t) => this.popupToggleClick(t)),
                    (this.popoutKeyupEvent = (t) => this.popoutKeyup(t)),
                    (this.popupOptionsClickEvent = (t) => this.popupOptionsClick(t)),
                    (this._connectOptionsDispatchEvent = (t) => this._connectOptionsDispatch(t)),
                    (this.bodyClick = this.bodyClick.bind(this)),
                    (this.updatePopout = this.updatePopout.bind(this)),
                    this._connectOptions(),
                    this._connectToggle(),
                    this._onFocusOut(),
                    this.popoutInput && this.popoutInput.hasAttribute(iz) && document.addEventListener("theme:cart:update", this.updatePopout);
            }
        },
        iV = {
            onLoad() {
                (iW[this.id] = []),
                    this.container.querySelectorAll("[data-popout]").forEach((t) => {
                        iW[this.id].push(new iR(t));
                    });
            },
            onUnload() {
                iW[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
        },
        iN = "[data-deferred-media]",
        iU = "[data-product-form]",
        ij = "[data-product-single-media-slider]",
        iK = "[data-product-single-media-wrapper]",
        iQ = "[data-model]",
        i0 = "[data-shop-the-look-thumb]",
        i3 = "has-media-active",
        iG = "is-active",
        i1 = "media--hidden",
        iX = "popup-quick-view--animate-in",
        iJ = "popup-quick-view--animate-out",
        iY = "popup-quick-view--animated",
        i2 = "js-quick-view-visible",
        i6 = "data-media-id",
        i4 = "data-section-id",
        iZ = "loaded",
        i5 = "tabindex",
        i7 = ".pswp__thumbs",
        st = "is-current",
        se = "pswp--custom-loader",
        si = "pswp--custom-opening",
        ss = "pswp__loader",
        sr = "popup-quick-view",
        so = "js-drawer-open-cart",
        sa = "data-pswp-option-classes",
        sn = `<div class="${ss}"><div class="loader loader--image"><div class="loader__image"></div></div></div>`,
        sl = class {
            init() {
                document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })),
                    this.pswpElement.classList.add(si),
                    this.initLoader(),
                    tm({ url: window.theme.assets.photoswipe })
                        .then(() => this.loadPopup())
                        .catch((t) => console.error(t));
            }
            initLoader() {
                if (this.pswpElement.classList.contains(se) && "" !== this.options && this.options.mainClass) {
                    this.pswpElement.setAttribute(sa, this.options.mainClass);
                    let t = document.createElement("div");
                    (t.innerHTML = sn), (t = t.firstChild), this.pswpElement.appendChild(t);
                } else this.pswpElement.setAttribute(sa, "");
            }
            loadPopup() {
                let t = window.themePhotoswipe.PhotoSwipe.default,
                    e = window.themePhotoswipe.PhotoSwipeUI.default;
                this.pswpElement.classList.contains(se) && this.pswpElement.classList.remove(se),
                    this.pswpElement.classList.remove(si),
                    (this.popup = new t(this.pswpElement, e, this.items, this.options)),
                    this.popup.listen("afterInit", this.dispatchPopupInitEventCallback),
                    this.popup.listen("imageLoadComplete", this.setCurrentThumbCallback),
                    this.popup.listen("beforeChange", this.setCurrentThumbCallback),
                    this.popup.listen("close", this.onCloseCallback),
                    this.popup.init(),
                    this.initPopupCallback();
            }
            initPopupCallback() {
                this.isVideo && this.hideUnusedButtons(),
                    this.initVideo(),
                    this.thumbsActions(),
                    this.a11y.trapFocus({ container: this.pswpElement }),
                    this.pswpElement.classList.contains(sr) &&
                        new (class {
                            initTooltips() {
                                (this.tooltips = this.pswpElement.querySelectorAll("[data-tooltip]")),
                                    this.tooltips.forEach((t) => {
                                        new tx(t);
                                    });
                            }
                            initPopouts() {
                                var t;
                                (this.popoutElements = this.pswpElement.querySelectorAll("[data-popout]")),
                                    (this.popouts = {}),
                                    null === (t = this.popoutElements) ||
                                        void 0 === t ||
                                        t.forEach((t, e) => {
                                            this.popouts[e] = new iR(t);
                                        });
                            }
                            handleDraggable(t, e) {
                                t && ((t.options.draggable = Boolean(e)), t.updateDraggable());
                            }
                            initItems(t, e) {
                                this.addFormSuffix(t),
                                    this.initProductSlider(t, e),
                                    this.initProductVideo(t),
                                    this.initProductModel(t),
                                    this.initShopifyXrLaunch(t),
                                    t4(t),
                                    this.pswpElement.querySelectorAll("[data-drawer-toggle]").length && new is(t),
                                    F(t);
                                let i = new iF(t.parentNode);
                                this.productForms.push(i), Shopify.PaymentButton && Shopify.PaymentButton.init(), t.classList.remove("is-loading");
                            }
                            init() {
                                document.addEventListener("submit", this.prevent3dModelSubmitEvent),
                                    this.popupCloseButtons.forEach((t) => {
                                        t.addEventListener("keyup", (t) => {
                                            (t.code !== theme.keyboardKeys.ENTER && t.code !== theme.keyboardKeys.NUMPADENTER && t.code !== theme.keyboardKeys.SPACE) || this.closePopup(t);
                                        }),
                                            t.addEventListener("click", (t) => {
                                                this.closePopup(t);
                                            });
                                    }),
                                    this.pswpElement.addEventListener("click", this.outerCloseEvent),
                                    document.dispatchEvent(new CustomEvent("theme:popup:open", { bubbles: !0 })),
                                    this.popup.listen("preventDragEvent", (t, e, i) => {
                                        i.prevent = !1;
                                    }),
                                    this.pswpElement.addEventListener("mousedown", () => {
                                        this.popup.framework.unbind(window, "pointermove pointerup pointercancel", this.popup);
                                    }),
                                    this.popup.listen("initialZoomInEnd", () => {
                                        document.body.classList.add(i2), this.a11y.trapFocus({ container: this.quickViewInner });
                                    }),
                                    this.pswpElement.addEventListener("animationend", this.closeOnAnimationEndEvent),
                                    this.popup.listen("destroy", () => {
                                        this.flkty.length > 0 &&
                                            requestAnimationFrame(() => {
                                                this.flkty.forEach((t) => t.pausePlayer());
                                            }),
                                            document.body.classList.remove(i2),
                                            document.removeEventListener("keyup", this.closeOnEscapeEvent),
                                            document.addEventListener("keyup", this.closeOnEscapeEvent),
                                            this.pswpElement.removeEventListener("click", this.outerCloseEvent),
                                            this.pswpElement.removeEventListener("animationend", this.closeOnAnimationEndEvent),
                                            document.removeEventListener("submit", this.prevent3dModelSubmitEvent),
                                            this.deferredMedias.forEach((t) => {
                                                t.removeAttribute(iZ);
                                            });
                                    }),
                                    document.addEventListener("keyup", this.closeOnEscapeEvent),
                                    document.addEventListener("theme:cart:added", () => {
                                        this.pswpElement.classList.contains("popup-quick-view") && this.pswpElement.classList.add(iJ);
                                    }),
                                    this.animateInQuickview(),
                                    this.initShopTheLookListeners();
                            }
                            initShopTheLookListeners() {
                                var t;
                                null === (t = this.buttonsShopTheLookThumb) ||
                                    void 0 === t ||
                                    t.forEach((t) => {
                                        t.addEventListener("click", (t) => {
                                            t.preventDefault();
                                            let e = t.target.matches(i0) ? t.target : t.target.closest(i0),
                                                i = this.pswpElement.querySelector(`[data-hotspot="${e.getAttribute("data-hotspot-ref")}"]`);
                                            !e.classList.contains(iG) &&
                                                i &&
                                                (this.flkty.length > 0 &&
                                                    requestAnimationFrame(() => {
                                                        this.flkty.forEach((t) => {
                                                            t.resize();
                                                            let e = this.quickViewInner.querySelectorAll(iK);
                                                            e.length &&
                                                                e.forEach((t) => {
                                                                    t.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }), t.classList.add(i1);
                                                                });
                                                        });
                                                    }),
                                                i.classList.add(iG),
                                                this.quickViewItemHolders.forEach((t) => {
                                                    t !== i && t.classList.remove(iG);
                                                }));
                                        });
                                    });
                            }
                            prevent3dModelSubmit(t) {
                                t.submitter.closest(iN) && t.submitter.closest(iU) && t.preventDefault();
                            }
                            closeQuickviewOnMobile() {
                                window.innerWidth < window.theme.sizes.large && document.body.classList.contains(i2) && this.popup.close();
                            }
                            animateInQuickview() {
                                this.pswpElement.classList.add(iX),
                                    this.quickViewFoot.addEventListener("animationend", (t) => {
                                        this.handleAnimatedState(t);
                                    }),
                                    this.pswpElement.addEventListener("animationend", (t) => {
                                        this.handleAnimatedState(t, !0);
                                    });
                            }
                            handleAnimatedState(t, e = !1) {
                                "quickViewAnimateInUp" != t.animationName ||
                                    (e && window.innerWidth >= window.theme.sizes.small) ||
                                    (this.pswpElement.classList.add(iY), this.pswpElement.classList.remove(iX), document.body.classList.remove("js-quick-view-from-cart"), H(this.pswpElement));
                            }
                            closePopup(t) {
                                null == t || t.preventDefault(),
                                    document.body.classList.contains("js-drawer-open") && document.dispatchEvent(new CustomEvent("theme:drawer:closing", { bubbles: !0 })),
                                    this.pswpElement.classList.add(iJ),
                                    this.productForms.length > 0 &&
                                        this.productForms.forEach((t) => {
                                            t.destroy();
                                        }),
                                    this.swatchesContainer.onUnload();
                            }
                            closeOnAnimationEnd(t) {
                                ("quickViewAnimateOutRight" != t.animationName && "quickViewAnimateOutDown" != t.animationName) || (this.popup.template.classList.remove(iJ, iY), this.popup.close());
                            }
                            closeOnEscape(t) {
                                let e = document.body.classList.contains(i2),
                                    i = document.body.classList.contains("notification-popup-visible");
                                t.code === theme.keyboardKeys.ESCAPE && e && !i && this.closePopup(t);
                            }
                            initProductSlider(t, i) {
                                let s = t.querySelector(ij),
                                    r = t.querySelectorAll(iK);
                                if (r.length > 1) {
                                    let o = new e(s, {
                                        wrapAround: !0,
                                        cellAlign: "left",
                                        pageDots: !1,
                                        prevNextButtons: !0,
                                        adaptiveHeight: !1,
                                        pauseAutoPlayOnHover: !1,
                                        selectedAttraction: 0.2,
                                        friction: 1,
                                        autoPlay: !1,
                                        on: {
                                            ready() {
                                                s.setAttribute(i5, "-1"),
                                                    requestAnimationFrame(() => {
                                                        o.resize();
                                                    });
                                            },
                                            settle: () => {
                                                let e = o.selectedElement,
                                                    i = e.getAttribute(i6);
                                                e.setAttribute(i5, "0"),
                                                    o.cells.forEach((t) => {
                                                        t.element !== e && t.element.setAttribute(i5, "-1");
                                                    }),
                                                    this.switchMedia(t, i);
                                            },
                                        },
                                    });
                                    this.flkty.push(o),
                                        r.length &&
                                            r.forEach((t) => {
                                                t.addEventListener("theme:media:play", () => {
                                                    this.handleDraggable(this.flkty[i], !1), t.closest(ij).classList.add(i3);
                                                }),
                                                    t.addEventListener("theme:media:pause", () => {
                                                        this.handleDraggable(this.flkty[i], !0), t.closest(ij).classList.remove(i3);
                                                    });
                                            }),
                                        tf(s);
                                }
                            }
                            switchMedia(t, e) {
                                let i = this.quickViewInner.querySelectorAll(iK),
                                    s = t.querySelector(`${iK}[${i6}="${e}"]`),
                                    r = !document.body.classList.contains("no-outline");
                                i.length &&
                                    i.forEach((t) => {
                                        t.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }), t.classList.add(i1);
                                    }),
                                    r && s.focus(),
                                    s.closest(ij).classList.remove(i3),
                                    s.classList.remove(i1),
                                    s.dispatchEvent(new CustomEvent("theme:media:visible"), { bubbles: !0 });
                                let o = s.querySelector(iN);
                                o && "true" !== o.getAttribute(iZ) && s.querySelector("[data-deferred-media-button]").dispatchEvent(new Event("click"));
                            }
                            initProductVideo(t) {
                                let e = new tk(t);
                                this.videos.push(e);
                            }
                            initProductModel(t) {
                                let e = t.getAttribute(i4),
                                    i = t.querySelectorAll(iQ);
                                i.length &&
                                    i.forEach((t) => {
                                        theme.ProductModel.init(t, e);
                                    });
                            }
                            initShopifyXrLaunch(t) {
                                document.addEventListener("shopify_xr_launch", () => {
                                    t.querySelector(`${iQ}:not(.${i1})`).dispatchEvent(new CustomEvent("xrLaunch"));
                                });
                            }
                            addFormSuffix(t) {
                                let e = `${t.getAttribute(i4)}-${JSON.parse(t.querySelector("[data-product-json]").innerHTML).handle}`,
                                    i = t.querySelector(iU),
                                    s = t.querySelector("[data-add-to-cart]");
                                i.setAttribute("id", "AddToCartForm--" + e), s.setAttribute("id", "AddToCart--" + e);
                            }
                            constructor(t, e) {
                                (this.popup = t),
                                    (this.pswpElement = e),
                                    (this.quickViewFoot = this.pswpElement.querySelector("[data-quick-view-foot-inner]")),
                                    (this.quickViewInner = this.pswpElement.querySelector("[data-quick-view-inner]")),
                                    (this.product = this.pswpElement.querySelectorAll("[data-product]")),
                                    (this.flkty = []),
                                    (this.videos = []),
                                    (this.productForms = []),
                                    (this.deferredMedias = this.pswpElement.querySelectorAll(iN)),
                                    (this.buttonsShopTheLookThumb = this.pswpElement.querySelectorAll(i0)),
                                    (this.quickViewItemHolders = this.pswpElement.querySelectorAll("[data-quick-view-item-holder]")),
                                    (this.popupCloseButtons = this.quickViewInner.querySelectorAll("[data-popup-close]")),
                                    (this.a11y = tu),
                                    (this.prevent3dModelSubmitEvent = (t) => this.prevent3dModelSubmit(t)),
                                    (this.closeOnAnimationEndEvent = (t) => this.closeOnAnimationEnd(t)),
                                    (this.closeOnEscapeEvent = (t) => this.closeOnEscape(t)),
                                    (this.outerCloseEvent = (t) => {
                                        if (!this.quickViewInner.contains(t.target)) {
                                            let e = this.quickViewInner.nextElementSibling;
                                            (e && e.contains(t.target)) || this.closePopup(t);
                                        }
                                    }),
                                    this.product.forEach((t, e) => {
                                        t.hasAttribute("data-quick-view-onboarding") || this.initItems(t, e);
                                    }),
                                    this.init(),
                                    this.initTooltips(),
                                    this.initPopouts(),
                                    (this.swatchesContainer = new t6(this.pswpElement));
                            }
                        })(this.popup, this.pswpElement),
                    this.pswpElement.classList.contains("pswp--notification") &&
                        new (class {
                            init() {
                                this.popup.listen("preventDragEvent", (t, e, i) => {
                                    i.prevent = !1;
                                });
                                let t = -1 !== window.location.search.indexOf("?customer_posted=true");
                                this.notificationForm = this.pswpElement.querySelector("[data-notification-form]");
                                let e = this.pswpElement.querySelector("[data-popup-close]");
                                document.body.classList.add(tv),
                                    this.pswpElement.addEventListener("mousedown", () => {
                                        this.popup.framework.unbind(window, "pointermove pointerup pointercancel", this.popup);
                                    }),
                                    t && this.pswpElement.classList.add("pswp--success"),
                                    this.notificationForm.addEventListener("submit", (t) => this.notificationSubmitEvent(t)),
                                    this.pswpElement.addEventListener("click", this.outerCloseEvent),
                                    e.addEventListener("click", () => {
                                        this.popup.close();
                                    }),
                                    this.popup.listen("destroy", () => {
                                        this.notificationRemoveStorage(), this.pswpElement.removeEventListener("click", this.outerCloseEvent), document.body.classList.remove(tv);
                                    });
                            }
                            notificationSubmitEvent(t) {
                                this.notificationStopSubmit && (t.preventDefault(), this.notificationRemoveStorage(), this.notificationWriteStorage(), (this.notificationStopSubmit = !1), this.notificationForm.submit());
                            }
                            notificationWriteStorage() {
                                void 0 !== this.sessionStorage && this.sessionStorage.setItem("notification_form_id", this.notificationForm.id);
                            }
                            notificationRemoveStorage() {
                                this.sessionStorage.removeItem("notification_form_id");
                            }
                            constructor(t, e) {
                                (this.popup = t), (this.pswpElement = e), (this.notificationForm = null), (this.notificationStopSubmit = !0), (this.sessionStorage = window.sessionStorage);
                                let i = this.pswpElement.querySelector("[data-notification]");
                                (this.outerCloseEvent = (t) => {
                                    i.contains(t.target) || this.popup.close();
                                }),
                                    this.init();
                            }
                        })(this.popup, this.pswpElement),
                    (this.closePopup = () => {
                        this.pswpElement.classList.contains(sr) ? this.pswpElement.classList.add("popup-quick-view--animate-out") : this.popup.close();
                    }),
                    this.closeBtn && this.closeBtn.addEventListener("click", this.closePopup),
                    document.addEventListener("theme:cart:added", this.closePopup);
            }
            dispatchPopupInitEvent() {
                this.triggerBtn && this.triggerBtn.dispatchEvent(new CustomEvent("theme:popup:init", { bubbles: !0 }));
            }
            initVideo() {
                let t = this.pswpElement.querySelector(".pswp__custom-iframe");
                if (t) {
                    let e = t.getAttribute("data-video-type");
                    (this.isVideo = !0),
                        "youtube" == e
                            ? new (class {
                                  init() {
                                      window.isYoutubeAPILoaded ? this.loadYoutubePlayer() : tm({ url: "https://www.youtube.com/iframe_api" }).then(() => this.loadYoutubePlayer());
                                  }
                                  loadYoutubePlayer() {
                                      let t = {
                                          height: "720",
                                          width: "1280",
                                          playerVars: this.videoOptionsVars,
                                          events: {
                                              onReady: (t) => {
                                                  let e = t.target.getIframe(),
                                                      i = e.id,
                                                      s = "true" === document.querySelector(`#${i}`).getAttribute("data-enable-sound");
                                                  e.setAttribute("tabindex", "-1"),
                                                      s ? t.target.unMute() : t.target.mute(),
                                                      t.target.playVideo(),
                                                      this.checkPlayerVisibilityFlag &&
                                                          (this.checkPlayerVisibility(i),
                                                          window.addEventListener(
                                                              "scroll",
                                                              Z(() => {
                                                                  this.checkPlayerVisibility(i);
                                                              }, 150)
                                                          ));
                                              },
                                              onStateChange(t) {
                                                  0 == t.data && t.target.playVideo(), 1 == t.data && t.target.getIframe().parentElement.classList.add("loaded");
                                              },
                                          },
                                      };
                                      (t.videoId = this.videoID),
                                          this.videoID.length &&
                                              YT.ready(() => {
                                                  ty[this.playerID] = new YT.Player(this.playerID, t);
                                              }),
                                          (window.isYoutubeAPILoaded = !0);
                                  }
                                  checkPlayerVisibility(t) {
                                      let e;
                                      if ("string" == typeof t) e = t;
                                      else {
                                          if (null == t.data) return;
                                          e = t.data.id;
                                      }
                                      let i = document.getElementById(e + "-container");
                                      if (!i) return;
                                      let s = ty[e],
                                          r = i.getBoundingClientRect(),
                                          o = visibilityHelper.isElementPartiallyVisible(i) || visibilityHelper.isElementTotallyVisible(i);
                                      r.top < 0 && i.clientHeight + r.top >= 0 && (o = !0), o && s && "function" == typeof s.playVideo ? s.playVideo() : !o && s && "function" == typeof s.pauseVideo && s.pauseVideo();
                                  }
                                  onUnload() {
                                      let t = "youtube-" + this.container.getAttribute("data-section-id");
                                      ty[t] && ty[t].destroy();
                                  }
                                  constructor(t) {
                                      (this.container = t),
                                          (this.player = this.container.querySelector(tg.videoIframe)),
                                          this.player &&
                                              ((this.videoOptionsVars = {}),
                                              (this.videoID = this.player.getAttribute("data-video-id")),
                                              (this.videoType = this.player.getAttribute("data-video-type")),
                                              "youtube" == this.videoType &&
                                                  ((this.checkPlayerVisibilityFlag = "true" === this.player.getAttribute("data-check-player-visibility")),
                                                  (this.playerID = this.player.querySelector(tg.youtubeWrapper) ? this.player.querySelector(tg.youtubeWrapper).id : this.player.id),
                                                  this.player.hasAttribute(tg.dataHideOptions) &&
                                                      (this.videoOptionsVars = { cc_load_policy: 0, iv_load_policy: 3, modestbranding: 1, playsinline: 1, autohide: 0, controls: 0, branding: 0, showinfo: 0, rel: 0, fs: 0, wmode: "opaque" }),
                                                  this.init(),
                                                  this.container.addEventListener(
                                                      "touchstart",
                                                      function (t) {
                                                          if (t.target.matches(tg.videoWrapper) || t.target.closest(tg.videoWrapper)) {
                                                              let e = t.target.querySelector(tg.videoIframe).id;
                                                              ty[e].playVideo();
                                                          }
                                                      },
                                                      { passive: !0 }
                                                  )));
                                  }
                              })(t.parentElement)
                            : "vimeo" == e &&
                              new (class {
                                  init() {
                                      this.loadVimeoPlayer();
                                  }
                                  loadVimeoPlayer() {
                                      let t = "https://vimeo.com/" + this.videoID,
                                          e = "",
                                          i = this.player,
                                          s = { url: t, background: this.enableBackground, muted: this.disableSound, autoplay: this.enableAutoplay, loop: this.enableLoop };
                                      for (let r in s) e += encodeURIComponent(r) + "=" + encodeURIComponent(s[r]) + "&";
                                      fetch(`https://vimeo.com/api/oembed.json?${e}`)
                                          .then((t) => t.json())
                                          .then(function (t) {
                                              (i.innerHTML = t.html),
                                                  setTimeout(function () {
                                                      i.parentElement.classList.add("loaded");
                                                  }, 1e3);
                                          })
                                          .catch(function () {
                                              console.log("error");
                                          });
                                  }
                                  constructor(t) {
                                      (this.container = t),
                                          (this.player = this.container.querySelector("[data-video-id]")),
                                          this.player &&
                                              ((this.videoID = this.player.getAttribute("data-video-id")),
                                              (this.videoType = this.player.getAttribute("data-video-type")),
                                              (this.enableBackground = "true" === this.player.getAttribute("data-enable-background")),
                                              (this.disableSound = "false" === this.player.getAttribute("data-enable-sound")),
                                              (this.enableAutoplay = "false" !== this.player.getAttribute("data-enable-autoplay")),
                                              (this.enableLoop = "false" !== this.player.getAttribute("data-enable-loop")),
                                              "vimeo" == this.videoType && this.init());
                                  }
                              })(t.parentElement);
                }
            }
            thumbsActions() {
                this.popupThumbsContainer &&
                    this.popupThumbsContainer.firstChild &&
                    (this.popupThumbsContainer.addEventListener("wheel", (t) => this.stopDisabledScroll(t)),
                    this.popupThumbsContainer.addEventListener("mousewheel", (t) => this.stopDisabledScroll(t)),
                    this.popupThumbsContainer.addEventListener("DOMMouseScroll", (t) => this.stopDisabledScroll(t)),
                    (this.popupThumbs = this.pswpElement.querySelectorAll(`${i7} > *`)),
                    this.popupThumbs.forEach((t, e) => {
                        t.addEventListener("click", (i) => {
                            i.preventDefault(), t.parentElement.querySelector(`.${st}`).classList.remove(st), t.classList.add(st), this.popup.goTo(e);
                        });
                    }));
            }
            hideUnusedButtons() {
                this.pswpElement.querySelectorAll(".pswp__button, .pswp__caption-close").forEach((t) => {
                    t.classList.contains("pswp__button--close") || (t.style.display = "none");
                });
            }
            stopDisabledScroll(t) {
                t.stopPropagation();
            }
            onClose() {
                let t = this.pswpElement.querySelector("iframe, video");
                if ((t && t.parentNode.removeChild(t), this.popupThumbsContainer && this.popupThumbsContainer.firstChild))
                    for (; this.popupThumbsContainer.firstChild; ) this.popupThumbsContainer.removeChild(this.popupThumbsContainer.firstChild);
                this.pswpElement.setAttribute(sa, "");
                let e = this.pswpElement.querySelector(`.${ss}`);
                e && this.pswpElement.removeChild(e),
                    document.body.classList.contains(so) || this.a11y.removeTrapFocus(),
                    document.removeEventListener("theme:cart:added", this.closePopup),
                    setTimeout(() => {
                        let t = this.recentlyOpenedPopupsCount(),
                            e = document.body.classList.contains(so);
                        0 !== t || e || document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                    }, 400);
            }
            recentlyOpenedPopupsCount() {
                let t = 0;
                return (
                    this.pswpElements.forEach((e) => {
                        e.classList.contains("pswp--open") && (t += 1);
                    }),
                    t
                );
            }
            setCurrentThumb() {
                if (this.popupThumbsContainer && this.popupThumbsContainer.firstChild) return;
                let t = this.pswpElement.querySelector(`${i7} > .${st}`);
                if ((t && t.classList.remove(st), !this.popupThumbs)) return;
                let e = this.popupThumbs[this.popup.getCurrentIndex()];
                e.classList.add(st), this.scrollThumbs(e);
            }
            scrollThumbs(t) {
                let e = this.popupThumbsContainer.scrollLeft + this.popupThumbsContainer.offsetWidth,
                    i = t.offsetLeft;
                if (e <= i + t.offsetWidth || e > i) {
                    let s = parseInt(window.getComputedStyle(t).marginLeft);
                    this.popupThumbsContainer.scrollTo({ top: 0, left: i - s, behavior: "smooth" });
                }
            }
            constructor(t, e = "", i = 0, s = null) {
                (this.items = t),
                    (this.triggerBtn = s),
                    (this.pswpElements = document.querySelectorAll(".pswp")),
                    (this.pswpElement = this.pswpElements[i]),
                    (this.popup = null),
                    (this.popupThumbs = null),
                    (this.popupThumbsContainer = this.pswpElement.querySelector(i7)),
                    (this.closeBtn = this.pswpElement.querySelector(".pswp__custom-close")),
                    (this.options = "" !== e ? e : { history: !1, focus: !1, mainClass: "" }),
                    (this.onCloseCallback = () => this.onClose()),
                    (this.dispatchPopupInitEventCallback = () => this.dispatchPopupInitEvent()),
                    (this.setCurrentThumbCallback = () => this.setCurrentThumb()),
                    (this.a11y = tu),
                    this.init();
            }
        },
        sh = "[data-button-quick-view]",
        sc = "is-loading",
        sd = "is-active",
        su = "popup-quick-view pswp--not-close-btn",
        sp = "data-variant-id",
        sm = "data-shop-the-look-quick-view",
        sg = "data-hotspot",
        sy = "data-initialized",
        sv = { history: !1, focus: !1, mainClass: su, showHideOpacity: !1, closeOnVerticalDrag: !1, closeOnScroll: !1, modal: !1, escKey: !1 },
        sf = class {
            popupInit(t) {
                var e, i;
                let s = this.loadPhotoswipe.pswpElement.querySelector(`[${sg}="${t.getAttribute(sg)}"]`),
                    r = this.loadPhotoswipe.pswpElement.querySelectorAll("[data-quick-view-item-holder]");
                s.classList.add(sd),
                    r.forEach((t) => {
                        t !== s && t.classList.remove(sd);
                    }),
                    this.toggleQuickViewButtonsLoadingClasses(!0),
                    this.toggleQuickViewThumbsLoadingClasses(!0);
                let o = (t) => {
                    "quickViewAnimateInUp" === t.animationName &&
                        requestAnimationFrame(() => {
                            this.toggleQuickViewThumbsLoadingClasses(!1);
                        }),
                        "quickViewAnimateOutDown" === t.animationName && this.loadPhotoswipe.pswpElement.removeEventListener("animationend", o);
                };
                this.loadPhotoswipe.pswpElement.addEventListener("animationend", o),
                    null === (e = this.loadPhotoswipe) ||
                        void 0 === e ||
                        null === (i = e.popup) ||
                        void 0 === i ||
                        i.listen("destroy", () => {
                            this.toggleQuickViewButtonsLoadingClasses(!1), this.toggleQuickViewThumbsLoadingClasses(!1);
                        });
            }
            toggleQuickViewButtonsLoadingClasses(t = !0) {
                var e, i;
                t
                    ? null === (i = this.buttonsQuickView) ||
                      void 0 === i ||
                      i.forEach((t) => {
                          t.classList.add(sc);
                      })
                    : null === (e = this.buttonsQuickView) ||
                      void 0 === e ||
                      e.forEach((t) => {
                          t.classList.remove(sc);
                      });
            }
            toggleQuickViewThumbsLoadingClasses(t = !0) {
                var e, i, s;
                ((this.buttonsShopTheLookThumb = null === (e = this.loadPhotoswipe) || void 0 === e ? void 0 : e.pswpElement.querySelectorAll("[data-shop-the-look-thumb]")), t)
                    ? null === (s = this.buttonsShopTheLookThumb) ||
                      void 0 === s ||
                      s.forEach((t) => {
                          t.classList.add(sc);
                      })
                    : null === (i = this.buttonsShopTheLookThumb) ||
                      void 0 === i ||
                      i.forEach((t) => {
                          t.classList.remove(sc);
                      });
            }
            initPhotoswipe(t) {
                t.preventDefault();
                let e = t.target.matches(sh) ? t.target : t.target.closest(sh),
                    i = window.innerWidth < theme.sizes.small,
                    s = "",
                    r = !1;
                if (e.hasAttribute(sm)) {
                    if (!i) return;
                    r = !0;
                }
                (sv.mainClass = su),
                    e.classList.add(sc),
                    e.closest("[data-cart-drawer]") && document.body.classList.add("js-quick-view-from-cart"),
                    (this.a11y.state.trigger = e),
                    e.hasAttribute(sp) && (s = `&variant=${e.getAttribute(sp)}`);
                let o = `${theme.routes.root}products/${e.getAttribute("data-handle")}?section_id=api-quickview${s}`;
                if (r) {
                    (sv.mainClass = "popup-quick-view popup-quick-view--shop-the-look pswp--not-close-btn"),
                        this.buttonsQuickView.forEach((t) => {
                            t.classList.add(sc);
                        });
                    let a = new XMLSerializer(),
                        n = this.container.querySelector("[data-quick-view-items-template]").content.firstElementChild.cloneNode(!0),
                        l = a.serializeToString(n);
                    this.loadPhotoswipeWithTemplate(l, e);
                } else this.loadPhotoswipeFromFetch(o, e);
            }
            loadPhotoswipeWithTemplate(t, e) {
                this.loadPhotoswipe = new sl([{ html: t }], sv, 0, e);
            }
            loadPhotoswipeFromFetch(t, e) {
                fetch(t)
                    .then((t) => t.text())
                    .then((t) => {
                        this.loadPhotoswipe = new sl([{ html: t }], sv, 0, e);
                    })
                    .catch((t) => console.log("error: ", t));
            }
            constructor(t) {
                var e, i;
                (this.container = t),
                    (this.a11y = tu),
                    (this.buttonsQuickView = this.container.querySelectorAll(sh)),
                    (this.buttonsShopTheLookQuickView = this.container.querySelectorAll("[data-shop-the-look-quick-view-button]")),
                    (this.popupInitCallback = (t) => this.popupInit(t)),
                    null === (e = this.buttonsQuickView) ||
                        void 0 === e ||
                        e.forEach((t) => {
                            t.hasAttribute(sy) ||
                                (t.addEventListener("click", (t) => this.initPhotoswipe(t)),
                                t.addEventListener("theme:popup:init", () => {
                                    t.classList.remove(sc), t.hasAttribute(sm) && this.popupInitCallback(t);
                                }),
                                t.setAttribute(sy, ""));
                        }),
                    null === (i = this.buttonsShopTheLookQuickView) ||
                        void 0 === i ||
                        i.forEach((t) => {
                            t.addEventListener("click", () => {
                                var t;
                                null === (t = this.buttonsQuickView[0]) || void 0 === t || t.dispatchEvent(new Event("click"));
                            });
                        });
            }
        },
        sb = { cartDrawerEnabled: "drawer" === window.theme.settings.cartType, timers: { addProductTimeout: 1e3 }, animations: { data: "data-aos", method: "fade-up" } },
        sS = {
            outerSection: "[data-section-id]",
            aos: "[data-aos]",
            additionalCheckoutButtons: "[data-additional-checkout-button]",
            apiContent: "[data-api-content]",
            apiLineItems: "[data-api-line-items]",
            apiUpsellItems: "[data-api-upsell-items]",
            apiCartPrice: "[data-api-cart-price]",
            buttonAddToCart: "[data-add-to-cart]",
            upsellButtonByHandle: "[data-handle]",
            cartCloseError: "[data-cart-error-close]",
            cartDrawer: "[data-cart-drawer]",
            cartDrawerTemplate: "[data-cart-drawer-template]",
            cartDrawerToggle: "[data-cart-drawer-toggle]",
            cartDrawerBody: "[data-cart-drawer-body]",
            cartErrors: "[data-cart-errors]",
            cartForm: "[data-cart-form]",
            cartTermsCheckbox: "[data-cart-acceptance-checkbox]",
            cartCheckoutButtonWrapper: "[data-cart-checkout-buttons]",
            cartCheckoutButton: "[data-cart-checkout-button]",
            cartItemRemove: "[data-item-remove]",
            cartItemsQty: "[data-cart-items-qty]",
            cartTotal: "[data-cart-total]",
            cartTotalPrice: "[data-cart-total-price]",
            cartMessage: "[data-cart-message]",
            cartMessageDefault: "[data-message-default]",
            cartPage: "[data-cart-page]",
            cartProgress: "[data-cart-message-progress]",
            emptyMessage: "[data-empty-message]",
            buttonHolder: "[data-foot-holder]",
            item: "[data-cart-item]",
            itemsHolder: "[data-items-holder]",
            itemsWrapper: "[data-items-wrapper]",
            formCloseError: "[data-close-error]",
            formErrorsContainer: "[data-cart-errors-container]",
            upsellHolder: "[data-upsell-holder]",
            errorMessage: "[data-error-message]",
            termsErrorMessage: "[data-terms-error-message]",
            pairProductsHolder: "[data-pair-products-holder]",
            pairProducts: "[data-pair-products]",
            priceHolder: "[data-cart-price-holder]",
            leftToSpend: "[data-left-to-spend]",
            quickBuyForm: "[data-quickbuy-form]",
            qtyInput: "[data-quantity-field]",
            productMediaContainer: "[data-product-media-container]",
            formWrapper: "[data-form-wrapper]",
            productForm: "[data-product-form]",
            popupQuickView: ".popup-quick-view",
            popupClose: "[data-popup-close]",
            error: "[data-error]",
            quickViewOnboarding: "[data-quick-view-onboarding]",
            flickityEnabled: ".flickity-enabled",
        },
        sE = "hidden",
        sL = "is-hidden",
        sk = "js-drawer-open-cart",
        sw = "is-open",
        s$ = "is-visible",
        sA = "is-expanded",
        sq = "is-loading",
        sC = "is-disabled",
        sT = "is-success",
        sP = "cart__toggle--has-items",
        s_ = "aos-animate",
        sF = "is-updated",
        sx = "no-outline",
        sI = "product-grid-item__image--error",
        sH = "cv-h",
        sD = "data-cart-message",
        s8 = "data-cart-total",
        sM = "aria-expanded",
        sO = "disabled",
        sB = "data-item-index",
        s9 = "data-item-title",
        sz = "data-recipient-errors",
        sW = {},
        sR = class {
            init() {
                var t;
                (this.cartToggleButtons = document.querySelectorAll(sS.cartDrawerToggle)),
                    (this.cartPage = document.querySelector(sS.cartPage)),
                    (this.cartDrawer = document.querySelector(sS.cartDrawer)),
                    (this.cart = this.cartDrawer || this.cartPage),
                    (this.cartCount = this.getCartItemCount()),
                    this.assignArguments(),
                    (this.recipientErrors = "true" === (null === (t = this.form) || void 0 === t ? void 0 : t.getAttribute(sz))),
                    (this.flktyUpsell = null),
                    (this.form = null),
                    (this.collapsible = null),
                    (this.a11y = tu),
                    (this.build = this.build.bind(this)),
                    (this.addToCart = this.addToCart.bind(this)),
                    (this.updateCart = this.updateCart.bind(this)),
                    (this.openCartDrawer = this.openCartDrawer.bind(this)),
                    (this.closeCartDrawer = this.closeCartDrawer.bind(this)),
                    (this.toggleCartDrawer = this.toggleCartDrawer.bind(this)),
                    (this.formSubmitHandler = Z(this.formSubmitHandler.bind(this), 50)),
                    (this.closeCartError = () => {
                        this.cartErrorHolder.classList.remove(sA);
                    }),
                    (this.cartDrawerCloseEvent = null),
                    (this.hasItemsInCart = this.hasItemsInCart.bind(this)),
                    (this.isCartPage = Boolean(this.cart && null === this.cartDrawer)),
                    (this.showAnimations = Boolean("true" === document.body.dataset.animations)),
                    (this.toggleClassesOnContainers = this.toggleClassesOnContainers.bind(this)),
                    (this.totalItems = 0),
                    (this.isCartDrawerOpen = !1),
                    (this.isCartDrawerLoaded = !1),
                    (this.cartDiscounts = 0),
                    (this.cartDrawerEnabled = sb.cartDrawerEnabled),
                    (this.cartAnimationTimer = 0),
                    (this.cartUpdateFailed = !1),
                    this.cartEvents(),
                    this.cartAddEvent(),
                    this.redirectToCheckout(),
                    this.cartDrawerToggleEvents(),
                    this.initQuantity(),
                    this.buttonHolder && (this.collapsible = new tn(this.buttonHolder)),
                    this.isCartPage && this.renderPairProducts(),
                    document.addEventListener("theme:popup:open", this.closeCartDrawer);
            }
            assignArguments() {
                (this.cartDrawerBody = document.querySelector(sS.cartDrawerBody)),
                    (this.emptyMessage = document.querySelector(sS.emptyMessage)),
                    (this.buttonHolder = document.querySelector(sS.buttonHolder)),
                    (this.itemsHolder = document.querySelector(sS.itemsHolder)),
                    (this.cartItemsQty = document.querySelector(sS.cartItemsQty)),
                    (this.itemsWrapper = document.querySelector(sS.itemsWrapper)),
                    (this.items = document.querySelectorAll(sS.item)),
                    (this.cartTotal = document.querySelector(sS.cartTotal)),
                    (this.cartTotalPrice = document.querySelectorAll(sS.cartTotalPrice)),
                    (this.cartMessage = document.querySelectorAll(sS.cartMessage)),
                    (this.cartOriginalTotal = document.querySelector(sS.cartOriginalTotal)),
                    (this.cartErrorHolder = document.querySelector(sS.cartErrors)),
                    (this.cartCloseErrorMessage = document.querySelector(sS.cartCloseError)),
                    (this.pairProductsHolder = document.querySelector(sS.pairProductsHolder)),
                    (this.pairProducts = document.querySelector(sS.pairProducts)),
                    (this.priceHolder = document.querySelector(sS.priceHolder)),
                    (this.upsellHolders = document.querySelectorAll(sS.upsellHolder)),
                    (this.cartTermsCheckbox = document.querySelector(sS.cartTermsCheckbox)),
                    (this.cartCheckoutButtonWrapper = document.querySelector(sS.cartCheckoutButtonWrapper)),
                    (this.cartCheckoutButton = document.querySelector(sS.cartCheckoutButton)),
                    (this.cartForm = document.querySelector(sS.cartForm)),
                    (this.cartItemCount = 0),
                    (this.subtotal = window.theme.subtotal),
                    (this.button = null),
                    this.cartMessage.length > 0 && (this.cartFreeLimitShipping = 100 * Number(this.cartMessage[0].getAttribute("data-limit")) * window.Shopify.currency.rate),
                    this.updateProgress();
            }
            initQuantity() {
                var t;
                (this.items = document.querySelectorAll(sS.item)),
                    null === (t = this.items) ||
                        void 0 === t ||
                        t.forEach((t) => {
                            new td(t, !0).init(), this.cartUpdateEvent(t);
                        });
            }
            cartUpdateEvent(t) {
                t.addEventListener("theme:cart:update", (e) => {
                    this.updateCart({ id: e.detail.id, quantity: e.detail.quantity }, t);
                });
            }
            cartEvents() {
                let t = document.querySelectorAll(sS.cartItemRemove);
                (this.totalItems = t.length),
                    null == t ||
                        t.forEach((t) => {
                            let e = t.closest(sS.item);
                            t.addEventListener("click", (i) => {
                                i.preventDefault(), t.classList.contains(sC) || this.updateCart({ id: e.getAttribute("data-id"), quantity: 0 }, e);
                            });
                        }),
                    this.cartCloseErrorMessage && (this.cartCloseErrorMessage.removeEventListener("click", this.closeCartError), this.cartCloseErrorMessage.addEventListener("click", this.closeCartError)),
                    this.cartTermsCheckbox &&
                        (this.cartTermsCheckbox.removeEventListener("change", this.formSubmitHandler),
                        this.cartCheckoutButtonWrapper.removeEventListener("click", this.formSubmitHandler),
                        this.cartForm.removeEventListener("submit", this.formSubmitHandler),
                        this.cartTermsCheckbox.addEventListener("change", this.formSubmitHandler),
                        this.cartCheckoutButtonWrapper.addEventListener("click", this.formSubmitHandler),
                        this.cartForm.addEventListener("submit", this.formSubmitHandler));
            }
            redirectToCheckout() {}
            cartAddEvent() {
                document.addEventListener("click", (t) => {
                    let e = t.target,
                        i = null == e ? void 0 : e.matches(sS.buttonAddToCart),
                        s = null == e ? void 0 : e.closest(sS.buttonAddToCart);
                    if (i || s) {
                        var r, o, a;
                        t.preventDefault(),
                            (this.button = i ? e : s),
                            (this.form = e.closest("form")),
                            (this.recipientErrors = "true" === (null === (r = this.form) || void 0 === r ? void 0 : r.getAttribute(sz))),
                            (this.formWrapper = this.button.closest(sS.formWrapper));
                        let n = null === (o = this.formWrapper) || void 0 === o ? void 0 : o.classList.contains("variant--soldout"),
                            l = this.button.hasAttribute(sO),
                            h = this.button.closest(sS.quickViewOnboarding),
                            c = this.button.hasAttribute("data-atc-trigger"),
                            d = this.button.hasAttribute("data-notification-popup"),
                            u = null === (a = this.form) || void 0 === a ? void 0 : a.querySelector('[type="file"]');
                        if (l || u || h) return;
                        if (n && d) return void new ig(this.button);
                        c && (this.a11y.state.trigger = this.button);
                        let p = new FormData(this.form);
                        this.addToCart(p), document.dispatchEvent(new CustomEvent("theme:cart:add", { bubbles: !0, detail: { selector: e } }));
                    }
                });
                // console.log("added to cart");
            }
            getCart() {
                this.cartDrawer && !this.isCartDrawerLoaded && this.renderCartDrawer(!1),
                    fetch(theme.routes.cart_url + "?section_id=api-cart-items")
                        .then(this.handleErrors)
                        .then((t) => t.text())
                        .then((t) => {
                            let e = document.createElement("div");
                            e.innerHTML = t;
                            let i = e.querySelector(sS.apiContent);
                            this.build(i);
                        })
                        .catch((t) => console.log(t));
            }
            addToCart(t) {
                this.cartDrawerEnabled && this.button && (this.button.classList.add(sq), this.button.setAttribute(sO, !0)),
                    fetch(theme.routes.cart_add_url, { method: "POST", headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/javascript" }, body: t })
                        .then((t) => t.json())
                        .then((t) => {
                            if (((this.button.disabled = !0), this.addLoadingClass(), t.status)) return this.addToCartError(t), void this.removeLoadingClass();
                            this.hideAddToCartErrorMessage(),
                                this.cartDrawerEnabled ? this.getCart() : (window.location = theme.routes.cart_url),
                                "undefined" != typeof gtag && gtag("event", "conversion", { send_to: "AW-11419406946/ycz3CLuXx44ZEOKkmcUq" });
                        })
                        .catch((t) => console.log(t));
            }
            updateCart(t = {}, e = null) {
                let i = t.quantity;
                null !== e && (i ? e.classList.add(sq) : e.classList.add("is-removed")), this.disableCartButtons(), this.addLoadingClass();
                let s = this.cart.querySelector(`[data-item="${t.id}"]`) || e,
                    r = (null == s ? void 0 : s.hasAttribute(sB)) ? parseInt(s.getAttribute(sB)) : 0,
                    o = (null == s ? void 0 : s.hasAttribute(s9)) ? s.getAttribute(s9) : null;
                0 !== r &&
                    fetch(theme.routes.cart_change_url, { method: "post", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ line: r, quantity: i }) })
                        .then((t) => {
                            if (400 === t.status) {
                                let e = Error(t.status);
                                throw (this.cartDrawerEnabled ? this.getCart() : (window.location = theme.routes.cart_url), e);
                            }
                            return t.text();
                        })
                        .then((t) => {
                            if (JSON.parse(t).errors) return (this.cartUpdateFailed = !0), this.updateErrorText(o), this.toggleErrorMessage(), this.resetLineItem(e), this.enableCartButtons(), void this.removeLoadingClass();
                            this.getCart();
                        })
                        .catch((t) => {
                            console.log(t), this.enableCartButtons(), this.removeLoadingClass();
                        });
            }
            resetLineItem(t) {
                let e = t.querySelector(sS.qtyInput),
                    i = e.getAttribute("value");
                (e.value = i), t.classList.remove(sq);
            }
            disableCartButtons() {
                let t = this.cart.querySelectorAll("input"),
                    e = this.cart.querySelectorAll(`button, ${sS.cartItemRemove}`);
                t.length &&
                    t.forEach((t) => {
                        t.classList.add(sC), t.blur(), (t.disabled = !0);
                    }),
                    e.length &&
                        e.forEach((t) => {
                            t.setAttribute(sO, !0);
                        });
            }
            enableCartButtons() {
                let t = this.cart.querySelectorAll("input"),
                    e = this.cart.querySelectorAll(`button, ${sS.cartItemRemove}`);
                t.length &&
                    t.forEach((t) => {
                        t.classList.remove(sC), (t.disabled = !1);
                    }),
                    e.length &&
                        e.forEach((t) => {
                            t.removeAttribute(sO);
                        });
            }
            updateErrorText(t) {
                this.cartErrorHolder.querySelector(sS.errorMessage).innerText = t;
            }
            toggleErrorMessage() {
                if (this.cartErrorHolder) {
                    if ((this.cartErrorHolder.classList.toggle(sA, this.cartUpdateFailed), this.cartUpdateFailed)) {
                        let t = this.cartErrorHolder.querySelector(sS.cartCloseError);
                        this.focusOnErrorMessage(this.cartErrorHolder, t);
                    }
                    this.cartUpdateFailed = !1;
                }
            }
            handleErrors(t) {
                return t.ok
                    ? t
                    : t.json().then(function (e) {
                          throw new tt({ status: t.statusText, headers: t.headers, json: e });
                      });
            }
            addToCartError(t) {
                let e = this.button.closest(sS.quickBuyForm),
                    i = this.button.closest(sS.upsellHolder),
                    s = !document.body.classList.contains(sx),
                    r = (this.button.closest(sS.productForm) ? this.button.closest(sS.productForm) : this.button.closest(sS.upsellHolder)).querySelector(sS.formErrorsContainer);
                i && (r = i.querySelector(sS.formErrorsContainer)),
                    this.cartDrawerEnabled && this.button && null !== this.button.closest(sS.cartDrawer) && !this.button.closest(sS.cartDrawer) && this.closeCartDrawer(),
                    this.button.classList.remove(sq),
                    this.button.removeAttribute(sO);
                let o = e
                        ? ""
                        : `
      <button type="button" class="errors__button-close" data-close-error>
        ${theme.icons.close}
      </button>
    `,
                    a = `${t.message}: ${t.description}`;
                if (
                    (this.recipientErrors &&
                        t.description &&
                        "object" == typeof t.description &&
                        (a = Object.entries(t.description)
                            .map(([t, e]) => `${e}`)
                            .join("<br>")),
                    (r.innerHTML = `
      <div class="errors" data-error autofocus>
        ${a}
        ${o}
      </div>
    `),
                    e)
                ) {
                    let n = r.closest(sS.productMediaContainer);
                    n.classList.add(sI),
                        r.querySelector(sS.error).addEventListener("animationend", () => {
                            n.classList.remove(sI), (r.innerHTML = ""), s || document.activeElement.blur();
                        });
                } else
                    r.classList.add(s$),
                        r.addEventListener("transitionend", () => {
                            this.resizeSliders(r);
                        }),
                        this.handleCloseErrorMessages(r);
            }
            handleCloseErrorMessages(t) {
                let e = t.querySelector(sS.formCloseError);
                null == e ||
                    e.addEventListener("click", (e) => {
                        let i = e.target;
                        (i.matches(sS.formCloseError) || i.closest(sS.formCloseError)) &&
                            (e.preventDefault(),
                            t.classList.remove(s$),
                            t.querySelector(sS.error).addEventListener("transitionend", () => {
                                (t.innerHTML = ""), this.resizeSliders(i);
                            }));
                    }),
                    this.focusOnErrorMessage(t, e);
            }
            focusOnErrorMessage(t, e) {
                document.body.classList.contains(sx) ||
                    t.addEventListener("transitionend", () => {
                        requestAnimationFrame(() => (null == e ? void 0 : e.focus({ focusVisible: !0 })));
                    });
            }
            hideAddToCartErrorMessage() {
                let t = this.button.closest(sS.upsellHolder) ? this.button.closest(sS.upsellHolder) : this.button.closest(sS.productForm),
                    e = null == t ? void 0 : t.querySelector(sS.formErrorsContainer);
                null == e || e.classList.remove(s$);
            }
            resizeSliders(t) {
                let i = t.closest(sS.flickityEnabled);
                if (!i) return;
                let s = e.data(i);
                requestAnimationFrame(() => s.resize());
            }
            renderCartDrawer(t = !0) {
                let e = document.querySelector(sS.cartDrawerTemplate);
                e &&
                    ((this.cartDrawer.innerHTML = e.innerHTML),
                    this.assignArguments(),
                    this.initQuantity(),
                    this.cartEvents(),
                    this.buttonHolder && (this.collapsible = new tn(this.buttonHolder)),
                    (this.cartDrawerToggle = this.cartDrawer.querySelector(sS.cartDrawerToggle)),
                    this.cartDrawerToggle.addEventListener("click", this.cartDrawerToggleClickEvent),
                    (this.isCartDrawerLoaded = !0),
                    this.renderPairProducts(),
                    document.dispatchEvent(new CustomEvent("theme:cart:loaded", { bubbles: !0 })),
                    t && this.openCartDrawer());
                    //console.log("renderingg cart drawer updationnn");
                    if (Shopify.currency.active !== 'USD'){
                      let currency_rate = Shopify.currency.rate;
                       const get_middle_value = document.querySelector(".custom-cart__shipping-value-middle");
                       const get_end_value = document.querySelector(".custom-cart__shipping-value-end");
                    //    console.log("currency_rate: ", currency_rate, "get_middle_value: ", get_middle_value.textContent, "get_end_value: ", get_end_value.textContent);
  
                       // Extract numeric values from text content (remove currency symbols)
                       const middle_numeric = parseFloat(get_middle_value.textContent.replace(/[^0-9.-]+/g, ''));
                       const end_numeric = parseFloat(get_end_value.textContent.replace(/[^0-9.-]+/g, ''));
                       
                       // Multiply by currency rate and keep 2 decimal places
                       const converted_middle_value = parseFloat((middle_numeric * currency_rate).toFixed(2));
                       const converted_end_value = parseFloat((end_numeric * currency_rate).toFixed(2));
                    //    console.log("middle_numeric: ",middle_numeric, "end_numeric: ", end_numeric, "converted_middle_value: ", converted_middle_value, "converted_end_value: ", converted_end_value);
                       
                       // Get currency symbol from data-currency-symbol attribute
                       const currency_symbol_element = document.querySelector("[data-currency-symbol]");
                       const currency_symbol = currency_symbol_element.getAttribute("data-currency-symbol");
                       
                       // Update the elements with currency symbol and rounded values
                       let currencyUtil = themeVendor.themeCurrency;
                       get_middle_value.textContent = currencyUtil.formatMoney(
                           converted_middle_value * 100, 
                           theme.moneyFormat
                       );
                       get_end_value.textContent = currencyUtil.formatMoney(
                           converted_end_value * 100, 
                           theme.moneyFormat
                       );
                    }
            }
            openCartDrawer() {
                this.isCartDrawerOpen ||
                    (this.isCartDrawerLoaded
                        ? (document.dispatchEvent(new CustomEvent("theme:cart:open", { bubbles: !0 })),
                          document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.cartDrawer })),
                          document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.cartDrawerBody })),
                          document.body.classList.add(sk),
                          this.cartDrawer.classList.add(sw),
                          this.cartDrawer.classList.remove(sH),
                          this.cartDrawer.querySelectorAll(sS.aos).forEach((t) => {
                              requestAnimationFrame(() => {
                                  t.classList.add(s_);
                              });
                          }),
                          this.cartToggleButtons.forEach((t) => {
                              t.setAttribute(sM, !0);
                          }),
                          this.a11y.trapFocus({ container: this.cartDrawer }),
                          this.observeAdditionalCheckoutButtons(),
                          (this.isCartDrawerOpen = !0))
                        : this.renderCartDrawer());
          //   console.log("drawerr open in OCD",this.subtotal ,this.cartFreeLimitShipping, (this.subtotal / this.cartFreeLimitShipping) * 100 );
            
          //   if ((this.subtotal / this.cartFreeLimitShipping) * 100 < 100){
          //     const calculate_progress = ((this.subtotal / this.cartFreeLimitShipping) * 100);
          //     const get_dot_value = transformProgress(calculate_progress);
          //     console.log("get_dot_value: ", get_dot_value, "calculate_progress: ", calculate_progress);
          //     document.querySelector(".cart__message-icon").style.left = `${get_dot_value}%`;
          //   }
          //   else {
          //     document.querySelector(".cart__message-icon").style.left = `98%`;
          //   }
            this.updateThresholdIcon((this.subtotal / this.cartFreeLimitShipping) * 100);
            }
            closeCartDrawer() {
                if (!this.isCartDrawerOpen) return;
                document.dispatchEvent(new CustomEvent("theme:cart:close", { bubbles: !0 })),
                    this.cartAnimationTimer && clearTimeout(this.cartAnimationTimer),
                    (this.cartAnimationTimer = setTimeout(() => {
                        this.cartDrawer.querySelectorAll(sS.aos).forEach((t) => {
                            t.classList.remove(s_);
                        });
                    }, 300)),
                    this.cartErrorHolder.classList.remove(sA),
                    this.a11y.removeTrapFocus(),
                    this.cartToggleButtons.forEach((t) => {
                        t.setAttribute(sM, !1);
                    }),
                    document.body.classList.remove(sk),
                    this.cartDrawer.classList.remove(sw),
                    this.itemsHolder.classList.remove(sF);
                let t = (e) => {
                    e.target === this.cartDrawer &&
                        (requestAnimationFrame(() => {
                            this.cartDrawer.classList.add(sH);
                        }),
                        this.cartDrawer.removeEventListener("transitionend", t));
                };
                this.cartDrawer.addEventListener("transitionend", t),
                    document.body.classList.contains(sx) &&
                        requestAnimationFrame(() => {
                            document.activeElement.blur();
                        }),
                    document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: 400 })),
                    (this.isCartDrawerOpen = !1);
            }
            toggleCartDrawer() {
                this.isCartDrawerOpen ? this.closeCartDrawer() : this.openCartDrawer();
            }
            cartDrawerToggleEvents() {
                this.cartDrawer &&
                    (this.cartDrawer.addEventListener("keyup", (t) => {
                        t.code === theme.keyboardKeys.ESCAPE && this.closeCartDrawer();
                    }),
                    (this.cartDrawerToggleClickEvent = (t) => {
                        t.preventDefault();
                        let e = t.target;
                        "false" === e.getAttribute(sM) && (this.a11y.state.trigger = e), this.toggleCartDrawer();
                    }),
                    (this.cartDrawerCloseEvent = (t) => {
                        let e = t.target.matches(sS.cartDrawerToggle),
                            i = document.querySelector(sS.cartDrawer).contains(t.target),
                            s = t.target.closest(sS.popupQuickView);
                        e || i || s || this.closeCartDrawer();
                    }),
                    this.cartToggleButtons.forEach((t) => {
                        t.addEventListener("click", this.cartDrawerToggleClickEvent);
                    }),
                    document.addEventListener("mousedown", this.cartDrawerCloseEvent));
            }
            toggleClassesOnContainers() {
                this.emptyMessage.classList.toggle(sE, this.hasItemsInCart()),
                    this.buttonHolder.classList.toggle(sE, !this.hasItemsInCart()),
                    this.itemsHolder.classList.toggle(sE, !this.hasItemsInCart()),
                    this.cartItemsQty.classList.toggle(sE, !this.hasItemsInCart());
            }
            build(t) {
                let e = t.querySelector(sS.apiLineItems),
                    s = t.querySelector(sS.apiUpsellItems),
                    r = Boolean(null === e && null === s),
                    o = t.querySelector(sS.apiCartPrice),
                    a = t.querySelector(sS.cartTotal);
                this.priceHolder && o && (this.priceHolder.innerHTML = o.innerHTML),
                    this.emptyMessage.querySelectorAll(sS.aos).forEach((t) => {
                        t.classList.remove(s_);
                    }),
                    r
                        ? ((this.itemsHolder.innerHTML = ""), this.pairProductsHolder && (this.pairProductsHolder.innerHTML = ""))
                        : ((this.itemsHolder.innerHTML = e.innerHTML), this.pairProductsHolder && (this.pairProductsHolder.innerHTML = s.innerHTML), this.renderPairProducts()),
                    (this.newTotalItems = e && e.querySelectorAll(sS.item).length ? e.querySelectorAll(sS.item).length : 0),
                    (this.subtotal = a && a.hasAttribute(s8) ? parseInt(a.getAttribute(s8)) : 0),
                    (this.cartCount = this.getCartItemCount()),
                    this.cartMessage.length > 0 && this.updateProgress(),
                    this.cartToggleButtons.forEach((t) => {
                        t.classList.remove(sP), this.newTotalItems > 0 && t.classList.add(sP);
                    }),
                    this.toggleErrorMessage(),
                    this.updateItemsQuantity(this.cartCount),
                    this.cartTotalPrice.forEach((t) => {
                        t.innerHTML = 0 === this.subtotal ? window.theme.strings.free : i.formatMoney(this.subtotal, theme.moneyWithCurrencyFormat);
                    }),
                    this.totalItems !== this.newTotalItems && ((this.totalItems = this.newTotalItems)),
                    // this.toggleClassesOnContainers(),
                    this.isCartDrawerOpen && this.itemsHolder.classList.add(sF),
                    this.cartEvents(),
                    this.initQuantity(),
                    this.enableCartButtons(),
                    this.resetButtonClasses(),
                    this.removeLoadingClass(),
                    document.dispatchEvent(new CustomEvent("theme:cart:added", { bubbles: !0 })),
                    this.cartDrawer && this.openCartDrawer();
  
                    let cartCountCheck = this.totalItems;
                    const complimentaryProducts = document.querySelector(".product-feature-collection");
                  //   const orderSummary = document.querySelector(".cart-drawer__summary");
                  //   const disclaimerText = document.querySelector(".cart-drawer__disclaimer-content");
                    const cartItemsHolder = document.querySelector("[data-items-holder]");
                    const cartEmptyMessage = document.querySelector("[data-empty-message]");
                    const cartFooter = document.querySelector("[data-foot-holder]");
  
                    if (cartCountCheck < 1) {
                      complimentaryProducts.classList.add("hidden");
                      // orderSummary.classList.add("hidden");
                      // disclaimerText.classList.add("hidden");
                      cartItemsHolder.classList.add("hidden");
                      cartFooter.classList.add("hidden");
                      cartEmptyMessage.classList.remove("hidden");
                    }
                    else {
                      complimentaryProducts.classList.remove("hidden");
                      // orderSummary.classList.remove("hidden");
                      // disclaimerText.classList.remove("hidden");
                      cartItemsHolder.classList.remove("hidden");
                      cartEmptyMessage.classList.add("hidden");
                      cartFooter.classList.remove("hidden");
                    }
                    // console.log("cart drawer updateddd:: ","this::", this, this.cartCount, "this.totalItems:: ", this.totalItems, "this.newTotalItems:", this.newTotalItems, complimentaryProducts);
            }
            getCartItemCount() {
                return this.cart ? Array.from(this.cart.querySelectorAll(sS.qtyInput)).reduce((t, e) => t + parseInt(e.value), 0) : 0;
            }
            hasItemsInCart() {
              return this.totalItems > 0;
  
            //   console.log("this.totalItems: ",this.totalItems);
              let cartCountCheck = this.totalItems;
              const complimentaryProducts = document.querySelector(".product-feature-collection");
              // const orderSummary = document.querySelector(".cart-drawer__summary");
              // const DisclaimerText = document.querySelector(".cart-drawer__disclaimer-content");
  
              // if (cartCountCheck < 1) {
              //   complimentaryProducts.classList.add("hidden");
              //   orderSummary.classList.add("hidden");
              //   DisclaimerText.classList.add("hidden");
              // }
              // else {
              //   complimentaryProducts.classList.remove("hidden");
              //   orderSummary.classList.remove("hidden");
              //   DisclaimerText.classList.remove("hidden");
              // }
            }
            freeShippingMessageHandle(t) {
                this.cartMessage.length > 0 &&
                    document.querySelectorAll(sS.cartMessage).forEach((e) => {
                        let i = e.hasAttribute(sD) && "true" === e.getAttribute(sD) && 0 !== t,
                            s = e.querySelector(sS.cartMessageDefault);
                        e.classList.toggle(sT, t >= this.cartFreeLimitShipping && i), e.classList.toggle(sL, 0 === t), s.classList.toggle(sL, t >= this.cartFreeLimitShipping);
                    });
            }
          transformProgress(valueCents, threshold1Cents, threshold2Cents) {
              if (valueCents <= 0) return 0;
              if (valueCents >= threshold2Cents) return 100;
  
              if (valueCents <= threshold1Cents) {
                  return (valueCents / threshold1Cents) * 50;
              } else {
                  return 50 + ((valueCents - threshold1Cents) / (threshold2Cents - threshold1Cents)) * 50;
              }
          }
  
          updateProgress() {
              let valueCents = this.subtotal;
  
              let threshold2Cents = this.cartFreeLimitShipping;
              let threshold1Cents = Math.round(this.cartFreeLimitShipping * (2 / 3));
  
              let nextThresholdCents = valueCents < threshold1Cents
                  ? threshold1Cents
                  : threshold2Cents;
  
              let leftRawCents = nextThresholdCents - valueCents;
  
              let leftFormatted = theme.settings.currency_code_enable
                  ? i.formatMoney(leftRawCents, theme.moneyWithCurrencyFormat)
                  : i.formatMoney(leftRawCents, theme.moneyFormat);
  
              let t = this.transformProgress(valueCents, threshold1Cents, threshold2Cents);
  
              if (this.cartMessage.length > 0) {
                  document.querySelectorAll(sS.cartMessage).forEach((messageEl) => {
                      let bars = messageEl.querySelectorAll(sS.cartProgress),
                          leftEl = messageEl.querySelector(sS.leftToSpend);
  
                      if (leftEl) {
                          leftEl.innerHTML = leftFormatted.replace(".00", "").replace(",00", "");
                      }
  
                      if (bars.length) {
                          bars.forEach((bar, index) => {
                              bar.classList.toggle(sL, valueCents >= threshold2Cents);
                              bar.style.setProperty("--progress-width", `${t}%`);
                              if (index === 0) bar.setAttribute("value", t);
                          });
                      }
  
                      this.freeShippingMessageHandle(valueCents);
                  });
              }
  
              this.updateThresholdIcon(t);
          }
            updateThresholdIcon(percentage) {
            //   console.log("precentage:: ", percentage);
                const thresholdIcon = document.querySelector('.cart__threshold-start-icon');
                const expressIcon = document.querySelector('.cart__threshold-last-icon');
                const thresholdMessage = document.querySelector('[data-message-threshold]');
                const middleThresholdPercent = (2/3) * 100; // 66.67% for $60 threshold
                if (thresholdIcon) {
                    // Show current icon (checkmark) when 66.67% or more, otherwise show initial icon (cart)
                    if (percentage >= middleThresholdPercent) {
                        thresholdIcon.classList.add('show-current');
                    } else {
                        thresholdIcon.classList.remove('show-current');
                    }
                }
                
                if (expressIcon) {
                    // Show current express icon (checkmark) when 100% or more, otherwise show initial express icon
                    if (percentage >= 100) {
                        expressIcon.classList.add('show-current');
                    } else {
                        expressIcon.classList.remove('show-current');
                    }
                }
                
                if (thresholdMessage) {
                    // Show threshold message when between 66.67% and 99%
                    if (percentage >= middleThresholdPercent && percentage < 100) {
                        thresholdMessage.classList.add('show');
                        // Update the left to spend amount dynamically
                        const leftToSpendElement = thresholdMessage.querySelector('[data-left-to-spend-threshold]');
                        if (leftToSpendElement) {
                            const remainingAmount = this.cartFreeLimitShipping - this.subtotal;
                            const formattedAmount = theme.settings.currency_code_enable ? 
                                i.formatMoney(remainingAmount, theme.moneyWithCurrencyFormat) : 
                                i.formatMoney(remainingAmount, theme.moneyFormat);
                            const cleanAmount = formattedAmount.replace(".00", "").replace(",00", "");
                            // console.log("cleanAmount: ", cleanAmount, "cartFreeLimitShipping: ", this.cartFreeLimitShipping);
                            leftToSpendElement.innerHTML = `<span data-left-to-spend>${cleanAmount}</span>`;
                        }
                    } else {
                        thresholdMessage.classList.remove('show');
                    }
                }
                
                // Hide default message when threshold message is shown or when 100% is reached
                const defaultMessage = document.querySelector('[data-message-default]');
                if (defaultMessage) {
                    if (percentage >= middleThresholdPercent) {
                        defaultMessage.classList.add('is-hidden');
                    } else {
                        defaultMessage.classList.remove('is-hidden');
                    }
                }
                
                // Hide success message when threshold message is shown, show it at 100%
                const successMessage = document.querySelector('.cart__message__success');
                if (successMessage) {
                    if (percentage >= middleThresholdPercent && percentage < 100) {
                        successMessage.classList.add('is-hidden');
                    } else {
                        successMessage.classList.remove('is-hidden');
                    }
                }
            }
            renderPairProducts() {
                if (
                    ((this.flktyUpsell = null),
                    (this.pairProductsHolder = document.querySelector(sS.pairProductsHolder)),
                    (this.pairProducts = document.querySelector(sS.pairProducts)),
                    (this.upsellHolders = document.querySelectorAll(sS.upsellHolder)),
                    null === this.pairProductsHolder || void 0 === this.pairProductsHolder)
                )
                    return;
                let t = this;
                this.upsellHolders.length > 1
                    ? (this.flktyUpsell = new e(this.pairProducts, {
                          wrapAround: !0,
                          pageDots: !0,
                          adaptiveHeight: !0,
                          prevNextButtons: !1,
                          on: {
                              ready: function () {
                                  new sf(t.cart), this.reloadCells(), requestAnimationFrame(() => this.resize());
                              },
                          },
                      }))
                    : new sf(this.cart);
            }
            updateItemsQuantity(t) {
                let e = theme.strings.cart_items_one,
                    i = theme.strings.cart_items_many;
                (e = e.split("}}")[1]), (i = i.split("}}")[1]), this.cartItemsQty && (this.cartItemsQty.textContent = 1 === t ? `${t} ${e}` : `${t} ${i}`);
            }
            observeAdditionalCheckoutButtons() {
                let t = this.cart.querySelector(sS.additionalCheckoutButtons);
                if (t) {
                    let e = new MutationObserver(() => {
                        this.a11y.removeTrapFocus(), this.a11y.trapFocus({ container: this.cart }), e.disconnect();
                    });
                    e.observe(t, { subtree: !0, childList: !0 });
                }
            }
            formSubmitHandler() {
                let t = document.querySelector(sS.cartTermsCheckbox).checked,
                    e = document.querySelector(sS.termsErrorMessage);
                if (t) e.classList.remove(sA), this.cartCheckoutButton.removeAttribute(sO);
                else {
                    if (document.querySelector(sS.termsErrorMessage).length > 0) return;
                    (e.innerText = theme.strings.cart_acceptance_error), this.cartCheckoutButton.setAttribute(sO, !0), e.classList.add(sA);
                }
            }
            resetButtonClasses() {
                let t = document.querySelectorAll(sS.buttonAddToCart);
                t &&
                    t.forEach((t) => {
                        t.classList.contains(sq) &&
                            (t.classList.remove(sq),
                            t.classList.add(sT),
                            setTimeout(() => {
                                t.removeAttribute(sO), t.classList.remove(sT);
                            }, sb.timers.addProductTimeout));
                    });
            }
            addLoadingClass() {
                this.cartDrawer ? this.cartDrawer.classList.add(sq) : this.itemsWrapper && this.itemsWrapper.classList.add(sq);
            }
            removeLoadingClass() {
                this.cartDrawer ? this.cartDrawer.classList.remove(sq) : this.itemsWrapper && this.itemsWrapper.classList.remove(sq);
            }
            unload() {
                this.cartDrawerToggle && this.cartDrawerToggle.removeEventListener("click", this.cartDrawerToggleClickEvent),
                    this.cartToggleButtons.forEach((t) => {
                        t.removeEventListener("click", this.cartDrawerToggleClickEvent);
                    }),
                    document.removeEventListener("mousedown", this.cartDrawerCloseEvent),
                    null !== this.collapsible && this.collapsible.onUnload();
            }
            constructor() {
                "/password" !== window.location.pathname && this.init();
            }
        };
    K("cart-template", {
        onLoad() {
            sW[this.id] = new sR();
        },
        onUnload() {
            "function" == typeof sW[this.id].unload && sW[this.id].unload();
        },
    });
    let sV = document.querySelector("[data-scroll-top-button]");
    sV &&
        (sV.addEventListener("click", () => {
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }),
        document.addEventListener(
            "scroll",
            Z(() => {
                sV.classList.toggle("is-visible", window.pageYOffset > window.innerHeight);
            }, 150)
        ));
    let sN = "details",
        sU = "[data-popdown-toggle]",
        sj = "predictive-search",
        sK = "search-form",
        sQ = "search-opened",
        s0 = class extends HTMLElement {
            connectedCallback() {
                this.isPopdownInHeader &&
                    (this.details.addEventListener("keyup", (t) => "ESCAPE" === t.code.toUpperCase() && this.close()),
                    this.popdownClose.addEventListener("click", () => this.close()),
                    this.popdownToggle.addEventListener("click", (t) => this.onPopdownToggleClick(t)),
                    this.popdownToggle.setAttribute("role", "button")),
                    this.isPopdownInPage &&
                        (this.popdownClose.addEventListener("click", () => this.triggerPopdownClose()),
                        this.searchFormWrapper.addEventListener("focusout", () => this.onFocusOut()),
                        this.searchFormWrapper.input.addEventListener("click", (t) => this.triggerPopdownOpen(t))),
                    this.searchFormInner.addEventListener("transitionend", (t) => {
                        t.target === this.searchFormInner && this.details.hasAttribute("open") && "false" == this.details.getAttribute("open") && this.onClose();
                    }),
                    this.popularSearchesLink.forEach((t) => {
                        t.addEventListener("click", (t) => {
                            t.preventDefault();
                            let e = t.target.textContent;
                            (this.searchFormWrapper.input.value = e), this.searchFormWrapper.submit();
                        });
                    });
            }
            onPopdownToggleClick(t) {
                t.preventDefault(), t.target.closest(sN).hasAttribute("open") ? this.close() : this.open(t);
            }
            onBodyClick(t) {
                var e;
                let i = this.contains(t.target);
                (null === (e = this.header) || void 0 === e ? void 0 : e.classList.contains("site-header--menu-opened")) || i || i || this.close();
            }
            onFocusOut() {
                this.predictiveSearch &&
                    requestAnimationFrame(() => {
                        this.searchFormWrapper.contains(document.activeElement) || this.searchFormWrapper.close();
                    });
            }
            triggerPopdownOpen(t) {
                let e = this.closest('[data-search-performed="false"]'),
                    i = matchMedia("(pointer:coarse)").matches,
                    s = window.innerWidth < theme.sizes.small;
                if (this.nav && this.mobileMenu && (i || s || null != e)) {
                    t.preventDefault();
                    let r = this.nav.classList.contains("nav--compress"),
                        o = this.mobileMenu.querySelector(sU);
                    i || (o = r ? this.nav.querySelector(`[data-nav-items-compress] ${sU}`) : this.nav.querySelector(`[data-nav-icons] ${sU}`)),
                        setTimeout(() => {
                            null == o || o.dispatchEvent(new Event("click", { bubbles: !0 }));
                        }, 300);
                }
            }
            open(t) {
                (this.onBodyClickEvent = (t) => this.onBodyClick(t)),
                    t.target.closest(sN).setAttribute("open", ""),
                    this.searchFormWrapper.input.setAttribute("aria-expanded", !0),
                    document.body.classList.add(sQ),
                    document.body.addEventListener("click", this.onBodyClickEvent),
                    document.addEventListener("theme:resize", this.ensureClosingOnResizeEvent),
                    document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })),
                    (this.a11y.state.trigger = t.target),
                    requestAnimationFrame(() => {
                        requestAnimationFrame(() => {
                            t.target.closest(sN).setAttribute("open", "true"), this.a11y.trapFocus({ container: this.searchFormInner });
                        });
                    });
            }
            close() {
                this.a11y.removeTrapFocus(), this.details.setAttribute("open", "false"), this.predictiveSearch && this.searchFormWrapper.close(), this.searchFormWrapper.handleFocusableDescendants(!0);
            }
            triggerPopdownClose() {
                this.predictiveSearch && this.searchFormWrapper.close(), this.searchFormWrapper.popularSearches && requestAnimationFrame(() => document.activeElement.blur());
            }
            onClose() {
                this.details.removeAttribute("open"),
                    document.dispatchEvent(new CustomEvent("theme:search:close", { bubbles: !0 })),
                    document.body.classList.remove(sQ),
                    document.body.removeEventListener("click", this.onBodyClickEvent),
                    document.removeEventListener("theme:resize", this.ensureClosingOnResizeEvent),
                    document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
            }
            ensureClosingOnResize() {
                null === this.offsetParent && this.onClose();
            }
            constructor() {
                var t, e, i;
                super(),
                    (this.isPopdownInHeader = this.hasAttribute("data-popdown-in-header")),
                    (this.isPopdownInPage = this.hasAttribute("data-popdown-in-page")),
                    (this.popdownBody = this.querySelector("[data-popdown-body]")),
                    (this.popdownClose = this.querySelector("[data-popdown-close]")),
                    (this.searchFormInner = this.querySelector("[data-search-form-inner]")),
                    (this.popularSearchesLink = this.querySelectorAll("[data-popular-searches-link]")),
                    (this.searchFormWrapper = this.querySelector(sK) ? this.querySelector(sK) : this.querySelector(sj)),
                    (this.predictiveSearch = this.searchFormWrapper.matches(sj)),
                    (this.header = document.querySelector("[data-site-header]")),
                    (this.headerSection = null === (t = this.header) || void 0 === t ? void 0 : t.parentNode),
                    (this.nav = null === (e = this.header) || void 0 === e ? void 0 : e.querySelector("[data-nav]")),
                    (this.mobileMenu = null === (i = this.headerSection) || void 0 === i ? void 0 : i.querySelector("[data-mobile-menu]")),
                    (this.a11y = tu),
                    (this.ensureClosingOnResizeEvent = () => this.ensureClosingOnResize()),
                    this.isPopdownInHeader && ((this.details = this.querySelector(sN)), (this.popdownToggle = this.querySelector(sU)));
            }
        };
    customElements.define("search-popdown", s0),
        (theme.ProductModel = (function () {
            let t = {},
                e = {},
                i = {},
                s = {
                    productMediaWrapper: "[data-product-single-media-wrapper]",
                    mediaGroup: "[data-product-single-media-group]",
                    productXr: "[data-shopify-xr]",
                    mediaId: "data-media-id",
                    model3d: "data-shopify-model3d-id",
                    modelViewer: "model-viewer",
                    modelJson: "#ModelJson-",
                    deferredMedia: "[data-deferred-media]",
                    deferredMediaButton: "[data-deferred-media-button]",
                },
                r = { isLoading: "is-loading", mediaHidden: "media--hidden" };
            function o(o, n) {
                if (o.querySelector(s.deferredMedia).getAttribute("loaded")) return;
                o.classList.add(r.isLoading);
                let l = document.createElement("div");
                l.appendChild(o.querySelector("template").content.firstElementChild.cloneNode(!0));
                let h = l.querySelector("model-viewer"),
                    c = o.querySelector(s.deferredMedia);
                c.appendChild(h), c.setAttribute("loaded", !0);
                let d = o.dataset.mediaId,
                    u = h.dataset.modelId,
                    p = o.closest(s.mediaGroup).parentElement.querySelector(s.productXr);
                (i[n] = { element: p, defaultId: u }),
                    (e[d] = { modelId: u, mediaId: d, sectionId: n, container: o, element: h }),
                    window.ShopifyXR
                        ? a()
                        : window.Shopify.loadFeatures([
                              {
                                  name: "shopify-xr",
                                  version: "1.0",
                                  onLoad: function e(i) {
                                      if (i) console.warn(i);
                                      else if (window.ShopifyXR) {
                                          for (let r in t)
                                              if (t.hasOwnProperty(r)) {
                                                  let o = t[r];
                                                  if (o.loaded) continue;
                                                  let a = document.querySelector(`${s.modelJson}${r}`);
                                                  a && (window.ShopifyXR.addModels(JSON.parse(a.innerHTML)), (o.loaded = !0));
                                              }
                                          window.ShopifyXR.setupXRElements();
                                      } else
                                          document.addEventListener("shopify_xr_initialized", function () {
                                              e();
                                          });
                                  },
                              },
                              { name: "model-viewer-ui", version: "1.0", onLoad: a },
                          ]);
            }
            function a(t) {
                if (t) console.warn(t);
                else
                    for (let i in e)
                        if (e.hasOwnProperty(i)) {
                            let s = e[i];
                            s.modelViewerUi || ((s.modelViewerUi = new Shopify.ModelViewerUI(s.element)), n(s));
                        }
            }
            function n(t) {
                let e = i[t.sectionId];
                t.container.addEventListener("theme:media:visible", function () {
                    e.element.setAttribute(s.model3d, t.modelId), window.theme.touch || (t.modelViewerUi.play(), t.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 }));
                }),
                    t.container.addEventListener("theme:media:hidden", function () {
                        t.modelViewerUi.pause();
                    }),
                    t.container.addEventListener("xrLaunch", function () {
                        t.modelViewerUi.pause();
                    }),
                    t.element.addEventListener("load", () => {
                        e.element.setAttribute(s.model3d, t.modelId), t.container.classList.remove(r.isLoading), t.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 });
                    }),
                    t.element.addEventListener("shopify_model_viewer_ui_toggle_play", function () {
                        l(t.mediaId),
                            setTimeout(() => {
                                t.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 });
                            }, 50);
                    }),
                    t.element.addEventListener("shopify_model_viewer_ui_toggle_pause", function () {
                        t.container.dispatchEvent(new CustomEvent("theme:media:pause"), { bubbles: !0 });
                    }),
                    l(t.mediaId);
            }
            function l(t) {
                let e = `[${s.mediaId}="${t}"]`,
                    i = document.querySelectorAll(`${s.productMediaWrapper}:not(${e})`);
                i.length &&
                    i.forEach((t) => {
                        t.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }), t.classList.add(r.mediaHidden);
                    });
            }
            return {
                init: function (e, i) {
                    t[i] = { loaded: !1 };
                    let r = e.querySelector(s.deferredMediaButton);
                    r && r.addEventListener("click", o.bind(this, e, i));
                },
                loadContent: o,
                removeSectionModels: function (i) {
                    for (let s in e) e.hasOwnProperty(s) && e[s].sectionId === i && delete e[s];
                    delete t[i], delete theme.mediaInstances[i];
                },
            };
        })()),
        K("collection-template", ez);
    let s3 = "[data-form]",
        sG = "[data-button-new]",
        s1 = "data-form-id",
        sX = "is-hidden",
        sJ = "validation--showup",
        sY = document.querySelector(".template-customers-addresses");
    sY &&
        new (class {
            init() {
                if (this.addressNewForm) {
                    let t = this.section,
                        e = this.addressNewForm;
                    this.customerAddresses();
                    let i = t.querySelectorAll(sG);
                    i.length &&
                        i.forEach((t) => {
                            t.addEventListener("click", function (i) {
                                i.preventDefault(), t.classList.add(sX), e.classList.remove(sX);
                            });
                        });
                    let s = t.querySelectorAll("[data-button-edit]");
                    s.length &&
                        s.forEach((e) => {
                            e.addEventListener("click", function (e) {
                                e.preventDefault();
                                let i = this.getAttribute(s1);
                                t.querySelector(`[data-form-edit="${i}"]`).classList.toggle(sX);
                            });
                        });
                    let r = t.querySelectorAll("[data-button-delete]");
                    r.length &&
                        r.forEach((t) => {
                            t.addEventListener("click", function (t) {
                                t.preventDefault();
                                let e = this.getAttribute(s1);
                                confirm(theme.strings.delete_confirm) && Shopify.postLink("/account/addresses/" + e, { parameters: { _method: "delete" } });
                            });
                        });
                    let o = t.querySelectorAll("[data-button-cancel]");
                    o.length &&
                        o.forEach((t) => {
                            t.addEventListener("click", function (t) {
                                t.preventDefault(), this.closest(s3).classList.add(sX), document.querySelector(sG).classList.remove(sX);
                            });
                        });
                }
            }
            customerAddresses() {
                Shopify.CountryProvinceSelector && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", { hideElement: "AddressProvinceContainerNew" }),
                    this.section.querySelectorAll("[data-country-option]").forEach((t) => {
                        let e = t.getAttribute(s1),
                            i = `AddressCountry_${e}`,
                            s = `AddressProvince_${e}`,
                            r = `AddressProvinceContainer_${e}`;
                        new Shopify.CountryProvinceSelector(i, s, { hideElement: r });
                    });
            }
            validate() {
                this.accountForms.forEach((t) => {
                    let e = t.querySelector("form"),
                        i = e.querySelectorAll('input[type="text"]:not(.optional)');
                    e.addEventListener("submit", (t) => {
                        let e = !1;
                        i.forEach((t) => {
                            t.value ? t.nextElementSibling.classList.remove(sJ) : (t.nextElementSibling.classList.add(sJ), (e = !0));
                        }),
                            e && t.preventDefault();
                    });
                });
            }
            constructor(t) {
                (this.section = t), (this.addressNewForm = this.section.querySelector("[data-form-new]")), (this.accountForms = this.section.querySelectorAll(s3)), this.init(), this.validate();
            }
        })(sY);
    let s2 = "#recover",
        s6 = "is-hidden",
        s4 = document.querySelector("[data-account-form]");
    s4 &&
        new (class {
            init() {
                window.location.hash == s2 ? this.showRecoverPasswordForm() : this.hideRecoverPasswordForm(),
                    this.success && this.successText.classList.remove(s6),
                    this.showButton.addEventListener(
                        "click",
                        (t) => {
                            t.preventDefault(), this.showRecoverPasswordForm();
                        },
                        !1
                    ),
                    this.hideButton.addEventListener(
                        "click",
                        (t) => {
                            t.preventDefault(), this.hideRecoverPasswordForm();
                        },
                        !1
                    );
            }
            showRecoverPasswordForm() {
                return this.recover.classList.remove(s6), this.login.classList.add(s6), (window.location.hash = s2), !1;
            }
            hideRecoverPasswordForm() {
                return this.login.classList.remove(s6), this.recover.classList.add(s6), (window.location.hash = ""), !1;
            }
            constructor(t) {
                (this.form = t),
                    (this.showButton = t.querySelector("[data-show-reset]")),
                    (this.hideButton = t.querySelector("[data-hide-reset]")),
                    (this.recover = t.querySelector("[data-recover-password]")),
                    (this.login = t.querySelector("[data-login-form]")),
                    (this.success = t.querySelector("[data-recover-success]")),
                    (this.successText = t.querySelector("[data-recover-success-text]")),
                    this.init();
            }
        })(s4),
        K("search-template", [ez, e2]);
    let sZ = "data-clone",
        s5 = "data-marquee-speed",
        s7 = "ticker--animated",
        rt = "[data-slide]",
        re = "[data-ticker-text]",
        ri = "data-stop",
        rs = "data-target-referrer",
        rr = "desktop",
        ro = "mobile",
        ra = "ticker--animated",
        rn = {},
        rl = {
            onLoad() {
                rn[this.id] = [];
                let t = this.container.querySelector("[data-bar]");
                t &&
                    rn[this.id].push(
                        new (class {
                            init() {
                                this.removeAnnouncement(), this.slider && (this.initSlider(), document.addEventListener("theme:resize:width", this.initSlider.bind(this))), this.slider || (this.initTickers(!0), this.tickerAnimationPause());
                            }
                            removeAnnouncement() {
                                for (let t = 0; t < this.slides.length; t++) {
                                    let e = this.slides[t];
                                    e.hasAttribute(rs) && (-1 !== this.locationPath.indexOf(e.getAttribute(rs)) || window.Shopify.designMode || e.parentNode.removeChild(e));
                                }
                            }
                            initSlider() {
                                if (this.slider.querySelectorAll(rt)) {
                                    let t = `${rt}`;
                                    (t = window.innerWidth < theme.sizes.small ? `${rt}:not(.${rr})` : `${rt}:not(.${ro})`),
                                        null != this.flkty && this.flkty.destroy(),
                                        (this.flkty = new e(this.slider, {
                                            cellSelector: t,
                                            pageDots: !1,
                                            prevNextButtons: !1,
                                            wrapAround: !0,
                                            autoPlay: parseInt(this.slider.getAttribute("data-slider-speed"), 10),
                                            on: {
                                                ready: () => {
                                                    setTimeout(() => {
                                                        this.slider.dispatchEvent(new CustomEvent("slider-is-loaded", { bubbles: !0, detail: { slider: this } }));
                                                    }, 10);
                                                },
                                            },
                                        })),
                                        this.flkty.reposition();
                                }
                                this.slider.addEventListener("slider-is-loaded", () => {
                                    this.initTickers();
                                });
                            }
                            initTickers(t = !1) {
                                this.barHolder.querySelectorAll("[data-ticker-frame]").forEach((e) => {
                                    let i = new (class {
                                        listen() {
                                            document.addEventListener("theme:resize:width", this.resizeEvent), this.checkWidth();
                                        }
                                        checkWidth() {
                                            let t = 2 * window.getComputedStyle(this.frame).paddingLeft.replace("px", "");
                                            if (this.frame.clientWidth - t < this.comparitor.clientWidth || this.stopClone) {
                                                if (1 === this.scale.childElementCount) {
                                                    if ((this.text.classList.add(s7), (this.clone = this.text.cloneNode(!0)), this.clone.setAttribute(sZ, ""), this.scale.appendChild(this.clone), this.stopClone))
                                                        for (let e = 0; e < 10; e++) {
                                                            let i = this.text.cloneNode(!0);
                                                            i.setAttribute(sZ, ""), this.scale.appendChild(i);
                                                        }
                                                    let s = this.frame.getAttribute(s5);
                                                    null === s && (s = 100);
                                                    let r = 1.63 * (100 / parseInt(s, 10)),
                                                        o = (this.text.clientWidth / 100) * r;
                                                    this.scale.style.setProperty("--animation-time", `${o}s`);
                                                }
                                            } else {
                                                this.text.classList.add(s7);
                                                let a = this.scale.querySelector(`[${sZ}]`);
                                                a && this.scale.removeChild(a), this.text.classList.remove(s7);
                                            }
                                        }
                                        unload() {
                                            document.removeEventListener("theme:resize:width", this.resizeEvent);
                                        }
                                        constructor(t, e = !1) {
                                            (this.frame = t),
                                                (this.stopClone = e),
                                                (this.scale = this.frame.querySelector("[data-ticker-scale]")),
                                                (this.text = this.frame.querySelector("[data-ticker-text]")),
                                                (this.comparitor = this.text.cloneNode(!0)),
                                                this.comparitor.classList.add("ticker__comparitor"),
                                                this.frame.appendChild(this.comparitor),
                                                this.scale.classList.remove("ticker--unloaded"),
                                                (this.resizeEvent = o(() => this.checkWidth(), 100)),
                                                this.listen();
                                        }
                                    })(e, t);
                                    this.tickers.push(i);
                                    let s = e.querySelectorAll(rt);
                                    if (0 !== s.length) {
                                        let r = e.querySelectorAll(`${rt}.${ro}`),
                                            a = e.querySelectorAll(`${rt}.${rr}`);
                                        s.length === r.length ? e.parentNode.classList.add(ro) : s.length === a.length && e.parentNode.classList.add(rr);
                                    }
                                });
                            }
                            toggleTicker(t, e) {
                                let i = t.target.closest("[data-ticker-scale]"),
                                    s = document.querySelector(`[data-slide="${t.detail.blockId}"]`);
                                e &&
                                    s &&
                                    (i.setAttribute(ri, ""),
                                    i.querySelectorAll(re).forEach((t) => {
                                        t.classList.remove(ra), (t.style.transform = `translate3d(${-(s.offsetLeft - parseInt(getComputedStyle(s).marginLeft, 10))}px, 0, 0)`);
                                    })),
                                    !e &&
                                        s &&
                                        (i.querySelectorAll(re).forEach((t) => {
                                            t.classList.add(ra), t.removeAttribute("style");
                                        }),
                                        i.removeAttribute(ri));
                            }
                            tickerAnimationPause() {
                                let t = 0,
                                    e = !1,
                                    i = this.barHolder.querySelector("[data-top-bar-slide]");
                                i.addEventListener("mouseenter", () => {
                                    (e = !0),
                                        (t = setTimeout(() => {
                                            e &&
                                                i.querySelectorAll(re).forEach((t) => {
                                                    t.style.animationPlayState = "paused";
                                                }),
                                                clearTimeout(t);
                                        }, 500));
                                }),
                                    i.addEventListener("mouseleave", () => {
                                        (e = !1),
                                            i.querySelectorAll(re).forEach((t) => {
                                                t.style.animationPlayState = "running";
                                            });
                                    });
                            }
                            onBlockSelect(t) {
                                let e = parseInt([...t.target.parentNode.children].indexOf(t.target));
                                this.slider && null !== this.flkty && (this.flkty.select(e), this.flkty.pausePlayer()), this.slider || this.toggleTicker(t, !0);
                            }
                            onBlockDeselect(t) {
                                this.slider && null !== this.flkty && this.flkty.unpausePlayer(), this.slider || this.toggleTicker(t, !1);
                            }
                            onUnload() {
                                document.removeEventListener("theme:resize:width", this.initSlider.bind(this)),
                                    this.tickers.length > 0 &&
                                        this.tickers.forEach((t) => {
                                            t.unload();
                                        });
                            }
                            constructor(t) {
                                (this.barHolder = t),
                                    (this.locationPath = location.href),
                                    (this.slides = this.barHolder.querySelectorAll(rt)),
                                    (this.slider = this.barHolder.querySelector("[data-slider]")),
                                    (this.tickers = []),
                                    (this.flkty = null),
                                    this.init();
                            }
                        })(t)
                    );
            },
            onBlockSelect(t) {
                rn[this.id].length &&
                    rn[this.id].forEach((e) => {
                        "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                    });
            },
            onBlockDeselect(t) {
                rn[this.id].length &&
                    rn[this.id].forEach((e) => {
                        "function" == typeof e.onBlockSelect && e.onBlockDeselect(t);
                    });
            },
            onUnload() {
                rn[this.id].forEach((t) => {
                    "function" == typeof t.onUnload && t.onUnload();
                });
            },
        };
    K("announcement-bar", rl),
        K("marquee", rl),
        K("accordions", [
            {
                onBlockSelect(t) {
                    let e = t.target.querySelector("[data-collapsible-trigger]");
                    requestAnimationFrame(() => {
                        e.classList.contains("is-expanded") || e.dispatchEvent(new Event("click"));
                    });
                },
            },
            tl,
        ]);
    let rh = "is-visible",
        rc = "is-hiding",
        rd = {},
        ru = {
            onLoad() {
                rd[this.id] = new (class {
                    init() {
                        this.button &&
                            this.button.addEventListener("click", () => {
                                let t = window.location.href;
                                this.button.dataset.shareLink && (t = this.button.dataset.shareLink),
                                    this.tooltip.classList.contains(rh) ||
                                        navigator.clipboard.writeText(t).then(() => {
                                            this.tooltip.classList.add(rh),
                                                setTimeout(() => {
                                                    this.tooltip.classList.add(rc),
                                                        this.tooltip.classList.remove(rh),
                                                        this.hideTransitionTimeout && clearTimeout(this.hideTransitionTimeout),
                                                        (this.hideTransitionTimeout = setTimeout(() => {
                                                            this.tooltip.classList.remove(rc);
                                                        }, this.transitionSpeed));
                                                }, 1500);
                                        });
                            });
                    }
                    constructor(t) {
                        (this.container = t),
                            (this.button = this.container.querySelector("[data-share-button]")),
                            (this.tooltip = this.container.querySelector("[data-share-button-tooltip]")),
                            (this.transitionSpeed = 200),
                            (this.hideTransitionTimeout = 0),
                            this.init();
                    }
                })(this.container);
            },
        };
    K("article", [ru]);
    let rp = "data-video-play",
        rm = {
            onLoad() {
                new (class {
                    init() {
                        this.videoPlay.length &&
                            this.videoPlay.forEach((t) => {
                                t.addEventListener("click", (e) => {
                                    if (t.hasAttribute(rp) && "" !== t.getAttribute(rp).trim()) {
                                        e.preventDefault();
                                        let i = [{ html: t.getAttribute(rp) }];
                                        (this.a11y.state.trigger = t), new sl(i);
                                    }
                                });
                            });
                    }
                    constructor(t) {
                        (this.container = t), (this.videoPlay = this.container.querySelectorAll("[data-video-play]")), (this.a11y = tu), this.init();
                    }
                })(this.container);
            },
        },
        rg = {},
        ry = {
            onLoad() {
                rg[this.id] = new (class {
                    init() {
                        var t;
                        if ("true" !== this.container.dataset.zoomAnimation) return;
                        let e = this.container,
                            i = document.body.querySelector("[data-main]").children[0],
                            s = this.container.parentNode === i,
                            r = "true" == (null === (t = this.header) || void 0 === t ? void 0 : t.dataset.transparent),
                            o = () => {
                                var t, i;
                                let o = s & r ? 0 : parseInt((null === (t = this.header) || void 0 === t ? void 0 : t.dataset.height) || (null === (i = this.header) || void 0 === i ? void 0 : i.offsetHeight)),
                                    a = e.getBoundingClientRect(),
                                    n = e.offsetHeight,
                                    l = s ? o - a.top : o - a.top + window.innerHeight,
                                    h = 0.1;
                                s && (h *= 1.5);
                                let c = 1 + (l / n) * h;
                                (c = c > 1 ? c : 1), e.style.setProperty("--scale", c);
                            };
                        o(),
                            (this.zoomOnScrollEvent = Z(o, 5)),
                            new IntersectionObserver(
                                (t) => {
                                    t[0].isIntersecting ? window.addEventListener("scroll", this.zoomOnScrollEvent) : window.removeEventListener("scroll", this.zoomOnScrollEvent);
                                },
                                { root: null, rootMargin: "0px", threshold: 0 }
                            ).observe(e);
                    }
                    onUnload() {
                        null !== this.zoomOnScrollEvent && window.removeEventListener("scroll", this.zoomOnScrollEvent);
                    }
                    constructor(t) {
                        (this.container = t), (this.header = document.querySelector("[data-site-header]")), this.init();
                    }
                })(this.container);
            },
            onUnload() {
                rg[this.id].onUnload();
            },
        };
    K("banner-image", [ry, rm]);
    let rv = "[data-banner]",
        rf = "data-index",
        rb = {};
    K("banner-with-text-columns", {
        onLoad() {
            rb[this.id] = new (class {
                initSliders() {
                    if (this.slider.children.length <= 1) return;
                    let t = window.innerWidth < window.theme.sizes.small;
                    this.sliderMedia.children.length > 1 &&
                        ((this.flktyMedia = new e(this.sliderMedia, { draggable: !1, wrapAround: !1, fade: !0, prevNextButtons: !1, adaptiveHeight: !1, pageDots: !1, setGallerySize: !1 })), tf(this.sliderMedia)),
                        (this.flkty = new e(this.slider, {
                            draggable: t,
                            prevNextButtons: !1,
                            pageDots: !0,
                            cellAlign: "left",
                            adaptiveHeight: !1,
                            imagesLoaded: !0,
                            lazyLoad: !0,
                            on: {
                                ready: () => {
                                    this.links.forEach((t) => {
                                        t.addEventListener("focus", () => {
                                            let e = Number(t.closest(rv).getAttribute(rf));
                                            window.innerWidth >= theme.sizes.small && this.syncContent(e);
                                        });
                                    }),
                                        this.banners.forEach((t) => {
                                            t.addEventListener("mouseenter", () => {
                                                let e = Number(t.getAttribute(rf));
                                                window.innerWidth >= theme.sizes.small && !window.theme.touch && this.syncContent(e);
                                            }),
                                                t.addEventListener("pointerup", () => {
                                                    let e = Number(t.getAttribute(rf));
                                                    window.innerWidth >= theme.sizes.small && window.theme.touch && this.syncContent(e);
                                                });
                                        });
                                },
                                change: (t) => {
                                    window.innerWidth < theme.sizes.small && !this.singleImageEnabled && this.flktyMedia.select(t);
                                },
                            },
                        })),
                        tf(this.slider);
                }
                syncContent(t = 0) {
                    this.flkty.selectCell(t), this.flktyMedia && this.flktyMedia.selectCell(t);
                }
                resizeSlider() {
                    this.flkty && (this.flkty.resize(), this.toggleDraggable()), this.flktyMedia && this.flktyMedia.resize();
                }
                toggleDraggable() {
                    (this.flkty.options.draggable = window.innerWidth < window.theme.sizes.small), this.flkty.updateDraggable();
                }
                onBlockSelect(t) {
                    let e = parseInt([...t.target.parentNode.children].indexOf(t.target));
                    this.flktyMedia && this.flktyMedia.selectCell(e);
                }
                onUnload() {
                    document.removeEventListener("theme:resize:width", this.sliderResizeEvent);
                }
                constructor(t) {
                    var e;
                    (this.container = t.container),
                        (this.slider = this.container.querySelector("[data-slider]")),
                        (this.singleImageEnabled = null === (e = this.slider) || void 0 === e ? void 0 : e.hasAttribute("data-slider-single-image")),
                        (this.banners = this.container.querySelectorAll(rv)),
                        (this.links = this.container.querySelectorAll("a")),
                        (this.sliderMedia = this.container.querySelector("[data-banners-media]")),
                        (this.flkty = null),
                        (this.flktyMedia = null),
                        (this.sliderResizeEvent = () => this.resizeSlider()),
                        this.slider && (this.initSliders(), document.addEventListener("theme:resize:width", this.sliderResizeEvent));
                }
            })(this);
        },
        onBlockSelect(t) {
            rb[this.id].onBlockSelect(t);
        },
    }),
        K("blog-posts", {
            onLoad() {
                ec = new ed(this.container);
            },
            onUnload: function () {
                "function" == typeof ec.unload && ec.unload();
            },
        });
    let rS = "[data-slider-item]",
        rE = "carousel--inactive",
        rL = {};
    K("columns-with-image", [
        {
            onLoad() {
                rL[this.id] = new (class {
                    initSlider() {
                        this.slider.classList.remove(rE),
                            (this.flkty = new e(this.slider, {
                                pageDots: !1,
                                cellAlign: "left",
                                groupCells: !0,
                                contain: !0,
                                on: {
                                    ready: () => {
                                        this.setSliderArrowsPosition(this.slider),
                                            setTimeout(() => {
                                                this.changeTabIndex();
                                            }, 0);
                                    },
                                    change: () => {
                                        this.changeTabIndex();
                                    },
                                },
                            }));
                    }
                    destroySlider() {
                        this.slider.classList.add(rE), null !== this.flkty && (this.flkty.destroy(), (this.flkty = null));
                    }
                    checkSlidesSize() {
                        let t = this.container.querySelector(rS).currentStyle || window.getComputedStyle(this.container.querySelector(rS));
                        this.gutter = parseInt(t.marginRight);
                        let e = this.slider.offsetWidth < this.getItemsWidth();
                        window.innerWidth >= theme.sizes.small && e ? this.initSlider() : this.destroySlider();
                    }
                    changeTabIndex() {
                        let t = this.flkty.selectedIndex;
                        this.flkty.slides.forEach((e, i) => {
                            e.cells.forEach((e) => {
                                e.element.querySelectorAll("a, button").forEach((e) => {
                                    e.setAttribute("tabindex", t === i ? "0" : "-1");
                                });
                            });
                        });
                    }
                    getItemsWidth() {
                        let t = 0,
                            e = this.slider.querySelectorAll(rS);
                        return (
                            e.length &&
                                e.forEach((e) => {
                                    t += e.offsetWidth + this.gutter;
                                }),
                            t
                        );
                    }
                    listen() {
                        this.slider && (this.checkSlidesSize(), document.addEventListener("theme:resize:width", this.checkSlidesSizeOnResize));
                    }
                    setSliderArrowsPosition(t) {
                        let e = t.querySelectorAll(".flickity-button"),
                            i = t.querySelector("[data-media-container]");
                        e.length &&
                            i &&
                            e.forEach((t) => {
                                t.style.top = i.offsetHeight / 2 + "px";
                            });
                    }
                    onBlockSelect(t) {
                        if (null !== this.flkty) {
                            let e = parseInt([...t.target.parentNode.children].indexOf(t.target)),
                                i = parseInt(this.flkty.slides[0].cells.length);
                            this.flkty.select(Math.floor(e / i));
                        } else {
                            let s = this.slider.currentStyle || window.getComputedStyle(this.slider),
                                r = parseInt(s.paddingLeft),
                                o = t.target.offsetLeft - r;
                            this.slider.scrollTo({ top: 0, left: o, behavior: "smooth" });
                        }
                    }
                    onUnload() {
                        document.removeEventListener("theme:resize:width", this.checkSlidesSizeOnResize);
                    }
                    constructor(t) {
                        (this.container = t.container), (this.slider = this.container.querySelector("[data-slider]")), (this.flkty = null), (this.gutter = 0), (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()), this.listen();
                    }
                })(this);
            },
            onUnload(t) {
                rL[this.id].onUnload(t);
            },
            onBlockSelect(t) {
                rL[this.id].onBlockSelect(t);
            },
        },
        rm,
    ]);
    let rk = "hide-down",
        rw = "notification-visible",
        r$ = {};
    K("contact-form", {
        onLoad() {
            r$[this.id] = new (class {
                hidePopups() {
                    document.body.classList.add(rw);
                }
                showPopups() {
                    document.body.classList.remove(rw);
                }
                closeFormMessage() {
                    this.closeButton.addEventListener("click", this.closeMessage.bind(this));
                }
                closeMessage(t) {
                    t.preventDefault(), this.messageWrapper.classList.add(rk), this.showPopups();
                }
                autoHideMessage() {
                    setTimeout(() => {
                        this.messageWrapper.classList.add(rk), this.showPopups();
                    }, 1e4);
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.closeButton = this.container.querySelector("[data-form-message-close]")),
                        (this.messageWrapper = this.container.querySelector("[data-form-message]")),
                        this.messageWrapper && (this.hidePopups(), this.closeFormMessage(), this.autoHideMessage());
                }
            })(this);
        },
    });
    let rA = "is-paused",
        rq = {},
        rC = {
            onLoad() {
                (rq[this.id] = []),
                    this.container.querySelectorAll("[data-video-wrapper]").forEach((t) => {
                        rq[this.id].push(
                            new (class {
                                init() {
                                    this.videoId &&
                                        (new IntersectionObserver(
                                            (t, e) => {
                                                t.forEach((t) => {
                                                    if (t.isIntersecting) {
                                                        let i = this.videoTemplate.innerHTML;
                                                        (this.videoPlayer.innerHTML = i),
                                                            (this.video = this.container.querySelector("[data-video-autoplay]")),
                                                            this.videoPlayer.classList.remove("is-loading"),
                                                            this.container.classList.add(rA),
                                                            this.listen(),
                                                            e.unobserve(t.target);
                                                    }
                                                });
                                            },
                                            { root: null, rootMargin: "300px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
                                        ).observe(this.videoPlayer),
                                        this.videoPlayButton.addEventListener("click", (t) => {
                                            var e;
                                            t.preventDefault(), null === (e = this.video) || void 0 === e || e.play();
                                        }));
                                }
                                listen() {
                                    this.video.addEventListener("play", () => {
                                        this.container.classList.remove(rA);
                                    }),
                                        this.container.addEventListener(
                                            "touchstart",
                                            () => {
                                                this.video.play();
                                            },
                                            { passive: !0 }
                                        );
                                }
                                constructor(t) {
                                    (this.container = t),
                                        (this.videoId = this.container.querySelector("[data-video-id]")),
                                        (this.videoPlayer = this.container.querySelector("[data-video-player]")),
                                        (this.videoTemplate = this.container.querySelector("[data-video-template]")),
                                        (this.videoPlayButton = this.container.querySelector("[data-video-bg-play]")),
                                        this.init();
                                }
                            })(t)
                        );
                    });
            },
        },
        rT = class {
            write() {
                ((-1 === document.cookie.indexOf("; ") || document.cookie.split("; ").find((t) => t.startsWith(this.name))) && -1 !== document.cookie.indexOf("; ")) ||
                    (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
            }
            read() {
                return (
                    !!(-1 !== document.cookie.indexOf("; ") && document.cookie.split("; ").find((t) => t.startsWith(this.name))) &&
                    document.cookie
                        .split("; ")
                        .find((t) => t.startsWith(this.name))
                        .split("=")[1]
                );
            }
            destroy() {
                document.cookie.split("; ").find((t) => t.startsWith(this.name)) &&
                    (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
            }
            constructor(t, e) {
                (this.configuration = { expires: null, path: "/", domain: window.location.hostname, sameSite: "none", secure: !0 }), (this.name = t), (this.value = e);
            }
        },
        rP = "has-success",
        r_ = "has-error",
        rF = "newsletter_form_id",
        rx = {},
        rI = {
            onLoad() {
                (rx[this.id] = []),
                    this.container.querySelectorAll("[data-newsletter-form]").forEach((t) => {
                        rx[this.id].push(
                            new (class {
                                init() {
                                    this.newsletter.addEventListener("submit", this.newsletterSubmit), this.showMessage();
                                }
                                newsletterSubmitEvent(t) {
                                    this.stopSubmit && (t.preventDefault(), this.removeStorage(), this.writeStorage(), (this.stopSubmit = !1), this.newsletter.submit());
                                }
                                checkForChallengePage() {
                                    this.isChallengePage = window.location.pathname === theme.routes.root + "challenge";
                                }
                                writeStorage() {
                                    void 0 !== this.sessionStorage && this.sessionStorage.setItem(rF, this.newsletter.id);
                                }
                                readStorage() {
                                    this.formID = this.sessionStorage.getItem(rF);
                                }
                                removeStorage() {
                                    this.sessionStorage.removeItem(rF);
                                }
                                showMessage() {
                                    if ((this.readStorage(), this.newsletter.id === this.formID)) {
                                        let t = document.getElementById(this.formID),
                                            e = -1 !== window.location.search.indexOf("?customer_posted=true"),
                                            i = -1 !== window.location.search.indexOf("accepts_marketing");
                                        e
                                            ? (t.classList.remove(r_), t.classList.add(rP), this.popup && ((this.cookie = new rT(this.popup.dataset.cookieName, "user_has_closed")), this.cookie.write()))
                                            : i && (t.classList.remove(rP), t.classList.add(r_)),
                                            (e || i) && this.scrollToForm(t);
                                    }
                                }
                                scrollToForm(t) {
                                    let e = t.getBoundingClientRect();
                                    visibilityHelper.isElementPartiallyVisible(t) ||
                                        visibilityHelper.isElementTotallyVisible(t) ||
                                        setTimeout(() => {
                                            window.scrollTo({ top: e.top, left: 0, behavior: "smooth" });
                                        }, 400);
                                }
                                onUnload() {
                                    this.newsletter.removeEventListener("submit", this.newsletterSubmit);
                                }
                                constructor(t) {
                                    (this.newsletter = t),
                                        (this.sessionStorage = window.sessionStorage),
                                        (this.popup = this.newsletter.closest("[data-popup]")),
                                        (this.stopSubmit = !0),
                                        (this.isChallengePage = !1),
                                        (this.formID = null),
                                        (this.formIdSuccess = null),
                                        this.checkForChallengePage(),
                                        (this.newsletterSubmit = (t) => this.newsletterSubmitEvent(t)),
                                        this.isChallengePage || this.init();
                                }
                            })(t)
                        );
                    });
            },
            onUnload() {
                rx[this.id].forEach((t) => {
                    "function" == typeof t.onUnload && t.onUnload();
                });
            },
        },
        rH = {};
    K("custom-content", [
        {
            onLoad() {
                rH[this.id] = new (class {
                    checkSlider() {
                        window.innerWidth >= theme.sizes.small
                            ? this.productSlider.forEach((t) => {
                                  this.initProductSlider(t);
                              })
                            : this.productSlider.forEach((t) => {
                                  this.destroyProductSlider(t);
                              });
                    }
                    initProductSlider(t) {
                        let i = t.querySelectorAll("[data-slide]").length,
                            s = t.dataset.slider;
                        i > 1 &&
                            (void 0 !== this.flkty[s] && this.flkty[s].isActive
                                ? this.setSliderArrowsPosition(t)
                                : (this.flkty[s] = new e(t, {
                                      prevNextButtons: !0,
                                      pageDots: !0,
                                      wrapAround: !0,
                                      on: {
                                          ready: () => {
                                              this.setSliderArrowsPosition(t);
                                          },
                                          change: (t) => {
                                              this.flkty[s].cells.forEach((e, i) => {
                                                  e.element.querySelectorAll("a, button").forEach((e) => {
                                                      e.setAttribute("tabindex", i === t ? "0" : "-1");
                                                  });
                                              });
                                          },
                                      },
                                  })));
                    }
                    destroyProductSlider(t) {
                        let e = t.dataset.slider;
                        "object" == typeof this.flkty[e] && this.flkty[e].destroy();
                    }
                    setSliderArrowsPosition(t) {
                        let e = t.querySelectorAll(".flickity-button"),
                            i = t.querySelector("[data-product-media-container]");
                        e.length &&
                            i &&
                            e.forEach((t) => {
                                t.style.top = i.offsetHeight / 2 + "px";
                            });
                    }
                    listen() {
                        this.checkSlider(), document.addEventListener("theme:resize:width", this.checkSliderOnResize);
                    }
                    onUnload() {
                        if (this.flkty) for (let t in this.flkty) this.flkty.hasOwnProperty(t) && this.flkty[t].destroy();
                        document.removeEventListener("theme:resize:width", this.checkSliderOnResize);
                    }
                    constructor(t) {
                        (this.container = t),
                            (this.product = this.container.querySelectorAll("[data-product]")),
                            (this.productSlider = this.container.querySelectorAll("[data-slider]")),
                            (this.checkSliderOnResize = () => this.checkSlider()),
                            (this.flkty = []),
                            (this.videoObj = []),
                            (this.quickViewObj = []),
                            this.listen();
                    }
                })(this.container);
            },
            onUnload(t) {
                rH[this.id].onUnload(t);
            },
        },
        rI,
        rm,
        rC,
        eo,
    ]);
    let rD = "[data-slider]",
        r8 = "[data-slide]",
        rM = "carousel--inactive",
        rO = "is-last-slide-visible",
        rB = "data-slider-id",
        r9 = {},
        rz = class {
            initSlider(t) {
                let i = t.getAttribute(rB);
                t.classList.remove(rM),
                    void 0 !== this.flkty[i] && this.flkty[i].isActive
                        ? this.setSliderArrowsPosition(t)
                        : ((this.flkty[i] = new e(t, {
                              pageDots: !1,
                              cellSelector: r8,
                              cellAlign: "left",
                              groupCells: !0,
                              contain: !0,
                              wrapAround: !1,
                              adaptiveHeight: !1,
                              on: {
                                  ready: () => {
                                      this.setSliderArrowsPosition(t),
                                          setTimeout(() => {
                                              this.changeTabIndex(t);
                                          }, 0);
                                  },
                                  change: () => {
                                      this.changeTabIndex(t);
                                  },
                              },
                          })),
                          this.handleLastSlideOverlayOnTablet(t));
            }
            destroySlider(t) {
                let e = t.getAttribute(rB);
                t.classList.contains("carousel") && t.classList.add(rM), "object" == typeof this.flkty[e] && this.flkty[e].destroy();
            }
            resetSlider(t) {
                let e = t.target,
                    i = e.getAttribute(rB);
                "object" == typeof this.flkty[i] ? this.flkty[i].select(0, !1, !0) : e.scrollTo({ left: 0, behavior: "instant" });
            }
            checkSlidesSize() {
                this.sliders.length &&
                    this.sliders.forEach((t) => {
                        let e = this.columns,
                            i = window.innerWidth >= theme.sizes.large,
                            s = window.innerWidth >= theme.sizes.small && window.innerWidth < theme.sizes.large,
                            r = t.querySelectorAll(r8),
                            o = r.length,
                            a = t.querySelectorAll("[data-promo]"),
                            n = !1;
                        if (
                            (a.length &&
                                i &&
                                a.forEach((t) => {
                                    t.classList.contains("collection-promo--full") ? (o += e - 1) : t.classList.contains("collection-promo--two-columns") && (o += 1);
                                }),
                            t.hasAttribute("data-slider-show-image") && (o += 1),
                            e)
                        )
                            n = o > e;
                        else {
                            let l = window.getComputedStyle(t, null),
                                h = t.clientWidth;
                            (h -= parseFloat(l.paddingLeft) + parseFloat(l.paddingRight)), (n = this.getSlidesWidth(r) > h);
                        }
                        (i && n) || (s && o > 2) ? this.initSlider(t) : this.destroySlider(t);
                    });
            }
            changeTabIndex(t) {
                let e = t.getAttribute(rB),
                    i = this.flkty[e].selectedIndex;
                this.flkty[e].slides.forEach((t, e) => {
                    t.cells.forEach((t) => {
                        t.element.querySelectorAll("a, button").forEach((t) => {
                            t.setAttribute("tabindex", i === e ? "0" : "-1");
                        });
                    });
                });
            }
            getSlidesWidth(t) {
                let e = 0;
                return (
                    t.length &&
                        t.forEach((t) => {
                            e += t.offsetWidth;
                        }),
                    e
                );
            }
            setSliderArrowsPosition(t) {
                let e = t.querySelectorAll(".flickity-button"),
                    i = t.querySelector("[data-product-media-container]");
                e.length &&
                    i &&
                    e.forEach((t) => {
                        t.style.top = i.offsetHeight / 2 + "px";
                    });
            }
            handleLastSlideOverlayOnTablet(t) {
                let e = t.getAttribute(rB);
                this.flkty[e].on("select", () => {
                    if (!(window.innerWidth >= theme.sizes.small && window.innerWidth < theme.sizes.large)) return;
                    let i = this.flkty[e].selectedIndex,
                        s = this.flkty[e].slides.length - 1 === i;
                    t.parentNode.classList.toggle(rO, s);
                });
            }
            handleLastSlideOverlayOnMobile() {
                this.sliders.forEach((t) => {
                    t.addEventListener("scroll", (e) => {
                        if (!(window.innerWidth < theme.sizes.small)) return;
                        let i = e.target.offsetWidth,
                            s = Array.from(t.children).pop().getBoundingClientRect().left + 80 < i;
                        t.parentNode.classList.toggle(rO, s);
                    });
                });
            }
            listen() {
                this.sliders.length &&
                    (this.checkSlidesSize(),
                    document.addEventListener("theme:resize:width", this.checkSlidesSizeOnResize),
                    this.sliders.forEach((t) => {
                        t.addEventListener("theme:tab:change", this.resetSliderEvent);
                    }));
            }
            onBlockSelect(t) {
                let i = t.target.closest(rD),
                    s = e.data(i) || null;
                if (!i) return;
                let r = t.target.parentNode,
                    o = t.target;
                if ((this.container.classList.contains("featured-collection") && ((r = r.parentNode), (o = o.parentNode)), null !== s && s.isActive)) {
                    let a = parseInt([...r.children].indexOf(o)),
                        n = parseInt(s.slides[0].cells.length);
                    s.select(Math.floor(a / n));
                } else {
                    let l = i.currentStyle || window.getComputedStyle(i),
                        h = parseInt(l.paddingLeft),
                        c = o.offsetLeft - h;
                    i.scrollTo({ top: 0, left: c, behavior: "smooth" });
                }
            }
            onUnload() {
                if (this.flkty) for (let t in this.flkty) this.flkty.hasOwnProperty(t) && this.flkty[t].destroy();
                document.removeEventListener("theme:resize:width", this.checkSlidesSizeOnResize),
                    this.sliders.length &&
                        this.sliders.forEach((t) => {
                            t.removeEventListener("theme:tab:change", this.resetSliderEvent);
                        });
            }
            constructor(t) {
                (this.container = t),
                    (this.columns = parseInt(this.container.dataset.columns)),
                    (this.sliders = this.container.querySelectorAll(rD)),
                    (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
                    (this.resetSliderEvent = (t) => this.resetSlider(t)),
                    (this.flkty = []),
                    this.listen(),
                    this.handleLastSlideOverlayOnMobile();
            }
        },
        rW = {
            onLoad() {
                (r9[this.id] = []),
                    this.container.querySelectorAll(rD).forEach((t) => {
                        r9[this.id].push(new rz(this.container));
                    });
            },
            onUnload() {
                r9[this.id].forEach((t) => {
                    "function" == typeof t.onUnload && t.onUnload();
                });
            },
            onBlockSelect(t) {
                r9[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                });
            },
        };
    K("featured-collection", [eo, tI, rW]), K("featured-video", [rm, rC]);
    let rR = "[data-collapsible-trigger-mobile]",
        rV = "is-expanded";
    K("footer", [
        iV,
        rI,
        tl,
        {
            onBlockSelect(t) {
                let e = t.target.querySelector(rR);
                requestAnimationFrame(() => {
                    e && !e.classList.contains(rV) && e.dispatchEvent(new Event("click"));
                });
            },
            onBlockDeselect(t) {
                let e = t.target.querySelector(rR);
                requestAnimationFrame(() => {
                    e && e.classList.contains(rV) && e.dispatchEvent(new Event("click"));
                });
            },
        },
    ]);
    let rN = "[data-hover-disclosure]",
        rU = "is-visible",
        rj = "site-header--menu-opened",
        rK = "site-header--hovered",
        rQ = "aria-expanded",
        r0 = {},
        r3 = "[data-popdown-toggle]",
        rG = "[data-nav-item]",
        r1 = {
            jsDrawerOpenAll: ["js-drawer-open", "js-drawer-open-cart", "js-quick-view-visible"],
            headerTransparent: "site-header--transparent",
            headerLoading: "site-header--loading",
            headerHovered: "site-header--hovered",
            headerMenuOpened: "site-header--menu-opened",
            hasScrolled: "has-scrolled",
            hideHeader: "hide-header",
            navCompress: "nav--compress",
            logoCompress: "logo--compress",
            isVisible: "is-visible",
            isOpen: "is-open",
            searchOpened: "search-opened",
            noOutline: "no-outline",
            cloneClass: "js__header__clone",
        },
        rX = {};
    K("header", [
        {
            onLoad() {
                rX[this.id] = new (class {
                    updateHeaderHover() {
                        requestAnimationFrame(() => {
                            let t = this.header.matches(":hover"),
                                e = this.header.classList.contains(r1.headerHovered);
                            t && !e && this.header.classList.add(r1.headerHovered);
                        });
                    }
                    handleTouchstart(t) {
                        let e = this.header.contains(t.target),
                            i = this.header.querySelector(`.${r1.isVisible}${rG}`);
                        !e && i && i.dispatchEvent(new Event("mouseleave", { bubbles: !0 }));
                    }
                    handleTextLinkLogos() {
                        if (null === this.logoTextLink) return;
                        let t = this.header.offsetHeight;
                        document.documentElement.style.setProperty("--header-height", `${t}px`), document.documentElement.style.setProperty("--header-sticky-height", `${t}px`);
                    }
                    initStickyHeader() {
                        if (
                            ((this.hasScrolled = !1),
                            (this.hasCollectionFilters = document.querySelector("[data-collection-filters]")),
                            (this.position = this.header.dataset.position),
                            "fixed" === this.position && !this.hasCollectionFilters)
                        )
                            return this.header.classList.remove(r1.headerLoading), this.headerState(), void document.addEventListener("theme:scroll", this.headerStateEvent);
                        document.body.classList.remove(r1.hasScrolled), window.isHeaderTransparent && this.header.classList.add(r1.headerTransparent), this.header.classList.remove(r1.headerLoading);
                    }
                    headerState(t) {
                        let e = parseInt(this.header.dataset.height || this.header.offsetHeight),
                            i = document.querySelector("[data-announcement-wrapper]"),
                            s = e + (i ? i.offsetHeight : 0),
                            r = window.pageYOffset || document.documentElement.scrollTop,
                            o = t && t.detail && t.detail.up;
                        (this.hasScrolled = r > s), document.body.classList.toggle(r1.hasScrolled, this.hasScrolled);
                        let a = r < s + window.stickyHeaderHeight && o;
                        if ((document.body.classList.toggle(r1.hideHeader, a), window.isHeaderTransparent)) {
                            let n = !this.hasScrolled || a;
                            this.header.classList.toggle(r1.headerTransparent, n);
                        }
                        if (this.header.classList.contains(r1.headerHovered)) {
                            let l = this.hasScrolled ? window.stickyHeaderHeight : e;
                            this.background.style.setProperty("--header-background-height", `${l}px`);
                            let h = this.header.querySelector(`.${r1.isVisible}${rG}`);
                            h && h.dispatchEvent(new Event("mouseenter", { bubbles: !0 }));
                        }
                    }
                    handleBackgroundEvents() {
                        this.headerWrapper.addEventListener("mouseenter", this.updateBackgroundHeightEvent),
                            this.headerWrapper.addEventListener("mouseleave", this.updateBackgroundHeightEvent),
                            this.header.addEventListener("focusout", this.updateBackgroundHeightEvent),
                            document.addEventListener("theme:cart:close", this.updateBackgroundHeightEvent),
                            document.addEventListener("theme:search:close", this.updateBackgroundHeightEvent);
                    }
                    updateBackgroundHeight(t) {
                        let e = matchMedia("(pointer:fine)").matches,
                            i = !document.body.classList.contains(r1.noOutline);
                        if (t) {
                            if ("mouseenter" === t.type) {
                                let s = !1;
                                if (
                                    (r1.jsDrawerOpenAll.forEach((t) => {
                                        document.body.classList.contains(t) && (s = !0);
                                    }),
                                    s)
                                )
                                    return;
                                return (
                                    (this.headerHeight = this.hasScrolled ? window.stickyHeaderHeight : this.header.offsetHeight),
                                    this.header.classList.add(r1.headerHovered),
                                    void (this.header.classList.contains(r1.headerMenuOpened) || (this.background.style.setProperty("--header-background-height", `${this.headerHeight}px`), this.background.style.setProperty("opacity", "1")))
                                );
                            }
                            ("focusout" !== t.type || e) &&
                                ("theme:search:close" !== t.type || (e && !i)) &&
                                (this.hasScrolled ||
                                    requestAnimationFrame(() => {
                                        let e = null === document.activeElement.closest("[data-site-header]");
                                        document.body.classList.contains(r1.searchOpened) ||
                                            (("focusout" !== t.type || e) &&
                                                (this.header.classList.remove(r1.headerHovered),
                                                this.background.style.setProperty("--header-background-height", "0px"),
                                                this.background.style.setProperty("opacity", "0"),
                                                i || document.activeElement.blur()));
                                    }));
                        }
                    }
                    listenWidth() {
                        document.addEventListener("theme:resize", this.checkWidthEvent), this.checkWidth();
                    }
                    checkWidth() {
                        window.innerWidth < this.minWidth ? (this.nav.classList.add(r1.navCompress), this.logo.classList.add(r1.logoCompress)) : (this.nav.classList.remove(r1.navCompress), this.logo.classList.remove(r1.logoCompress));
                    }
                    getMinWidth() {
                        let t = this.headerWrapper.currentStyle || window.getComputedStyle(this.headerWrapper),
                            e = 2 * parseInt(t.paddingLeft),
                            i = this.header.cloneNode(!0);
                        i.classList.add(r1.cloneClass), document.body.appendChild(i);
                        let s = i.querySelectorAll("[data-takes-space]"),
                            r = (function (t, e) {
                                let i = [];
                                t.forEach((t) => {
                                    i.push(t.clientWidth);
                                });
                                let [s, r, o, a] = i;
                                if ("left" === e) {
                                    let n = s;
                                    (s = r), (r = n);
                                }
                                return "right" !== e && (s > o ? (o = s) : (s = o)), s + r + o + a;
                            })(s, this.header.getAttribute("data-nav-alignment"));
                        return document.body.removeChild(i), r + 20 * s.length + e;
                    }
                    initMobileNav() {
                        var t;
                        if (
                            ((this.mobileMenu = this.headerSection.querySelector("[data-mobile-menu]")),
                            (this.navDrawer = this.headerSection.querySelector("#nav-drawer")),
                            (this.drawerToggle = this.navDrawer.querySelector("[data-drawer-toggle]")),
                            (this.navSearchOpen = this.navDrawer.querySelectorAll("[data-nav-search-open]")),
                            null === (t = this.navSearchOpen) ||
                                void 0 === t ||
                                t.forEach((t) => {
                                    t.addEventListener("click", (t) => {
                                        t.preventDefault();
                                        let e = this.drawerToggle.closest(`[data-drawer].${r1.isOpen}`),
                                            i = matchMedia("(pointer:coarse)").matches ? this.mobileMenu.querySelector(r3) : this.nav.querySelector(r3);
                                        this.drawerToggle.dispatchEvent(new Event("click", { bubbles: !0 }));
                                        let s = (t) => {
                                            t.target === e && (requestAnimationFrame(() => i.dispatchEvent(new Event("click", { bubbles: !0 }))), e.removeEventListener("transitionend", s));
                                        };
                                        e.addEventListener("transitionend", s);
                                    });
                                }),
                            "link" === theme.settings.mobileMenuBehaviour)
                        )
                            return;
                        let e = this.headerSection.querySelectorAll("[data-nav-link-mobile]");
                        e.length &&
                            e.forEach((t) => {
                                t.addEventListener("click", (e) => {
                                    let i = t.parentNode.querySelectorAll("[data-collapsible-trigger]").length,
                                        s = t.nextElementSibling;
                                    i && (e.preventDefault(), s.dispatchEvent(new Event("click"), { bubbles: !0 }));
                                });
                            });
                    }
                    onUnload() {
                        document.documentElement.style.removeProperty("--header-height"),
                            document.documentElement.style.removeProperty("--header-sticky-height"),
                            this.initStickyHeader(),
                            document.body.classList.remove(...r1.jsDrawerOpenAll),
                            document.removeEventListener("theme:scroll", this.headerStateEvent),
                            document.removeEventListener("theme:resize", this.checkWidthEvent),
                            document.removeEventListener("theme:cart:close", this.updateBackgroundHeightEvent),
                            document.removeEventListener("theme:search:close", this.updateBackgroundHeightEvent),
                            document.body.removeEventListener("touchstart", this.handleTouchstartEvent),
                            document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })),
                            "function" == typeof window.cart.unload && window.cart.unload();
                    }
                    constructor(t) {
                        (this.container = t),
                            (this.background = document.querySelector("[data-header-background]")),
                            (this.header = t),
                            (this.headerSection = t.parentNode),
                            (this.headerWrapper = t.querySelector("[data-wrapper]")),
                            (this.logo = t.querySelector("[data-logo]")),
                            (this.logoTextLink = t.querySelector("[data-logo-text-link]")),
                            (this.nav = t.querySelector("[data-nav]")),
                            (this.navIcons = t.querySelector("[data-nav-icons]")),
                            (this.headerStateEvent = (t) => this.headerState(t)),
                            (this.handleTouchstartEvent = (t) => this.handleTouchstart(t)),
                            (this.updateBackgroundHeightEvent = (t) => this.updateBackgroundHeight(t)),
                            a(),
                            (this.minWidth = this.getMinWidth()),
                            (this.checkWidthEvent = () => this.checkWidth()),
                            this.listenWidth(),
                            this.initMobileNav(),
                            this.handleTextLinkLogos(),
                            this.initStickyHeader(),
                            this.handleBackgroundEvents(),
                            document.querySelector("[data-cart-page]") || (window.cart = new sR()),
                            document.body.addEventListener("touchstart", this.handleTouchstartEvent, { passive: !0 }),
                            this.updateHeaderHover();
                    }
                })(this.container);
            },
            onUnload() {
                rX[this.id].onUnload();
            },
        },
        {
            onLoad() {
                (r0[this.id] = []),
                    this.container.querySelectorAll(rN).forEach((t) => {
                        r0[this.id].push(
                            new (class {
                                showDisclosure() {
                                    (this.hasScrolled = document.body.classList.contains("has-scrolled")),
                                        (this.headerHeight = this.hasScrolled ? window.stickyHeaderHeight : this.header.offsetHeight),
                                        this.grandparent ? ((this.dropdown.style.height = "auto"), (this.dropdownHeight = this.dropdown.offsetHeight)) : (this.dropdownHeight = this.headerHeight),
                                        this.background.style.setProperty("--header-background-height", `${this.dropdownHeight}px`),
                                        this.trigger.setAttribute(rQ, !0),
                                        this.trigger.classList.add(rU),
                                        this.header.classList.add(rj),
                                        this.updateHeaderHover();
                                }
                                hideDisclosure() {
                                    this.background.style.removeProperty("--header-background-height"), this.trigger.classList.remove(rU), this.trigger.setAttribute(rQ, !1), this.header.classList.remove(rj);
                                }
                                updateHeaderHover() {
                                    requestAnimationFrame(() => {
                                        let t = this.header.matches(":hover"),
                                            e = this.header.classList.contains(rK);
                                        t && !e && this.header.classList.add(rK);
                                    });
                                }
                                handleTablets() {
                                    this.trigger.addEventListener("touchstart", (t) => {
                                        if (!this.trigger.classList.contains(rU)) {
                                            t.preventDefault();
                                            let e = this.header.querySelectorAll(`.${rU}[data-nav-item]`);
                                            if (e.length > 0)
                                                return void e.forEach((t) => {
                                                    if (t !== this.trigger) {
                                                        t.dispatchEvent(new Event("mouseleave", { bubbles: !0 }));
                                                        let e = () => {
                                                            requestAnimationFrame(() => {
                                                                this.showDisclosure();
                                                            }),
                                                                t.removeEventListener("transitionend", e);
                                                        };
                                                        t.addEventListener("transitionend", e);
                                                    }
                                                });
                                            this.showDisclosure();
                                        }
                                    });
                                }
                                connectHoverToggle() {
                                    this.trigger.addEventListener("mouseenter", () => this.showDisclosure()),
                                        this.link.addEventListener("focus", () => this.showDisclosure()),
                                        this.trigger.addEventListener("mouseleave", () => this.hideDisclosure()),
                                        this.trigger.addEventListener("focusout", (t) => {
                                            this.trigger.contains(t.relatedTarget) || this.hideDisclosure();
                                        }),
                                        this.disclosure.addEventListener("keyup", (t) => {
                                            t.code === theme.keyboardKeys.ESCAPE && this.hideDisclosure();
                                        });
                                }
                                onBlockSelect(t) {
                                    this.disclosure.contains(t.target) && this.showDisclosure(t);
                                }
                                onBlockDeselect(t) {
                                    this.disclosure.contains(t.target) && this.hideDisclosure();
                                }
                                constructor(t) {
                                    (this.disclosure = t),
                                        (this.header = t.closest("[data-site-header]")),
                                        (this.key = this.disclosure.id),
                                        (this.trigger = document.querySelector(`[data-hover-disclosure-toggle='${this.key}']`)),
                                        (this.link = this.trigger.querySelector("[data-top-link]")),
                                        (this.grandparent = this.trigger.classList.contains("grandparent")),
                                        (this.background = document.querySelector("[data-header-background]")),
                                        this.trigger.setAttribute("aria-haspopup", !0),
                                        this.trigger.setAttribute(rQ, !1),
                                        this.trigger.setAttribute("aria-controls", this.key),
                                        (this.dropdown = this.trigger.querySelector(rN)),
                                        this.connectHoverToggle(),
                                        this.handleTablets();
                                }
                            })(t)
                        );
                    });
            },
            onBlockSelect(t) {
                r0[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                });
            },
            onBlockDeselect(t) {
                r0[this.id].forEach((e) => {
                    "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
                });
            },
        },
        ir,
    ]);
    let rJ = {};
    K("icons-row", {
        onLoad() {
            rJ[this.id] = new (class {
                onBlockSelect(t) {
                    let e = this.slider.currentStyle || window.getComputedStyle(this.slider),
                        i = parseInt(e.paddingLeft),
                        s = t.target.offsetLeft - i;
                    this.slider.scrollTo({ top: 0, left: s, behavior: "smooth" });
                }
                constructor(t) {
                    (this.container = t.container), (this.slider = this.container.querySelector("[data-slider]"));
                }
            })(this);
        },
        onBlockSelect(t) {
            rJ[this.id].onBlockSelect(t);
        },
    });
    let rY = "[data-accordion-item]",
        r2 = "is-expanded",
        r6 = {};
    K("image-accordions", {
        onLoad() {
            r6[this.id] = new (class {
                init() {
                    this.imageAccordionsItems.forEach((t) => {
                        t.addEventListener("mouseenter", this.accordionExpandEvent.bind(this, t));
                    }),
                        this.buttons.forEach((t) => {
                            t.addEventListener("focusin", this.accordionFocusEvent.bind(this, t));
                        });
                }
                accordionExpand(t) {
                    t.classList.contains(r2) ||
                        (this.imageAccordionsItems.forEach((t) => {
                            t.classList.remove(r2);
                        }),
                        t.classList.add(r2));
                }
                accordionFocus(t) {
                    t.closest(rY).dispatchEvent(new Event("mouseenter"));
                }
                onBlockSelect(t) {
                    let e = t.target;
                    e && e.dispatchEvent(new Event("mouseenter"));
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.imageAccordionsItems = this.container.querySelectorAll(rY)),
                        (this.buttons = this.container.querySelectorAll("[data-accordion-button]")),
                        (this.accordionExpandEvent = (t) => this.accordionExpand(t)),
                        (this.accordionFocusEvent = (t) => this.accordionFocus(t)),
                        this.init();
                }
            })(this);
        },
        onBlockSelect(t) {
            r6[this.id].onBlockSelect(t);
        },
    }),
        K("image-with-text", rm),
        K("list-collections", rW);
    let r4 = {};
    K("locations", {
        onLoad() {
            r4[this.id] = new (class {
                initSlider() {
                    let t = this.container.querySelectorAll("[data-slide-item]").length,
                        i = e.data(this.slider) || null,
                        s = e.data(this.sliderNav) || null;
                    t <= 1 ||
                        ((i = new e(this.slider, { fade: !0, wrapAround: !0, adaptiveHeight: !0, prevNextButtons: !1, pageDots: !1 })),
                        tf(this.slider),
                        (s = new e(this.sliderNav, { fade: !0, wrapAround: !0, imagesLoaded: !0, lazyLoad: !0, asNavFor: this.slider, prevNextButtons: !0, pageDots: !1 })).on("change", () => {
                            i.selectCell(s.selectedIndex);
                        }),
                        i.on("change", () => {
                            s.selectCell(i.selectedIndex);
                        }));
                }
                onBlockSelect(t) {
                    let i = e.data(this.slider) || null,
                        s = e.data(this.sliderNav) || null,
                        r = parseInt([...t.target.parentNode.children].indexOf(t.target));
                    null !== i && i.select(r), null !== s && s.select(r);
                }
                constructor(t) {
                    (this.container = t.container), (this.slider = this.container.querySelector("[data-slider-gallery]")), (this.sliderNav = this.container.querySelector("[data-slider-info]")), this.initSlider();
                }
            })(this);
        },
        onBlockSelect(t) {
            r4[this.id].onBlockSelect(t);
        },
    });
    let rZ = {},
        r5 = "[data-product-media-container]",
        r7 = "a, button",
        ot = "data-pointer",
        oe = "data-hotspot",
        oi = "tabindex",
        os = "product-grid-item__image--hovered",
        or = "pointer--selected",
        oo = "is-active",
        oa = "pswp--open";
    K("look", [
        {
            onLoad() {
                rZ[this.id] = new (class {
                    listen() {
                        this.slider && (this.checkSlidesSize(), document.addEventListener("theme:resize:width", this.checkSlidesSizeOnResize)),
                            this.pointers.length > 0 &&
                                this.pointers.forEach((t) => {
                                    t.addEventListener("click", this.pointersInit), t.addEventListener("mouseover", this.pointersOver), t.addEventListener("mouseleave", this.pointersOut);
                                });
                    }
                    checkSlidesSize() {
                        let t = window.innerWidth >= theme.sizes.small;
                        this.initTooltips(), t ? (this.slides.length > 2 ? this.initSlider() : (this.destroySlider(), this.slidesTabIndex())) : !t && this.slides.length > 1 ? this.initSlider() : this.destroySlider();
                    }
                    initTooltips() {
                        (this.tooltips = this.container.querySelectorAll("[data-tooltip]")),
                            this.tooltips.forEach((t) => {
                                new tx(t);
                            });
                    }
                    initSlider() {
                        null !== this.flkty
                            ? this.setSliderArrowsPosition()
                            : (this.flkty = new e(this.slider, {
                                  prevNextButtons: !0,
                                  wrapAround: !0,
                                  adaptiveHeight: !1,
                                  cellAlign: "left",
                                  groupCells: !1,
                                  contain: !0,
                                  on: {
                                      ready: () => {
                                          this.slidesTabIndex(), this.setSliderArrowsPosition(), this.dotPointers();
                                      },
                                      change: () => {
                                          this.slidesTabIndex(), this.dotPointers();
                                      },
                                  },
                              }));
                    }
                    setSliderArrowsPosition() {
                        if (!(window.innerWidth >= theme.sizes.small)) return;
                        let t = this.slider.querySelectorAll(".flickity-button"),
                            e = this.slider.querySelector(r5);
                        t.length &&
                            e &&
                            t.forEach((t) => {
                                t.style.top = e.offsetHeight / 2 + "px";
                            });
                    }
                    slidesTabIndex() {
                        if (this.slides.length < 3)
                            return void this.slider.querySelectorAll(r7).forEach((t) => {
                                t.setAttribute(oi, "0");
                            });
                        let t = e.data(this.slider);
                        t.cells.forEach((t) => {
                            t.element.querySelectorAll(r7).forEach((t) => {
                                t.setAttribute(oi, "-1");
                            });
                        }),
                            t.cells.forEach((t) => {
                                t.element.classList.contains("is-selected") &&
                                    (t.element.querySelectorAll(r7).forEach((t) => {
                                        t.setAttribute(oi, "0");
                                    }),
                                    (t.element.nextSibling ? t.element.nextSibling : t.element.parentNode.firstChild).querySelectorAll(r7).forEach((t) => {
                                        t.setAttribute(oi, "0");
                                    }));
                            });
                    }
                    destroySlider() {
                        "object" == typeof this.flkty && null !== this.flkty && (this.flkty.destroy(), (this.flkty = null));
                    }
                    dotPointers(t) {
                        if (0 === this.pointers.length) return;
                        if (
                            (this.pointers.forEach((t) => {
                                t.classList.remove(or);
                            }),
                            t)
                        ) {
                            var e;
                            let i = t.target.getAttribute(ot);
                            return void (null === (e = this.flkty) || void 0 === e || e.select(i));
                        }
                        let s = null == this.flkty ? 0 : this.flkty.selectedIndex;
                        s >= 0 && this.pointers[s].classList.add(or);
                    }
                    dotPointerIn(t) {
                        let e = t.target.getAttribute(ot),
                            i = this.slides[e].querySelector(r5),
                            s = matchMedia("(pointer:coarse)").matches;
                        window.innerWidth < theme.sizes.small || s || this.observeImage(i),
                            this.pointers.forEach((t) => {
                                t.style.setProperty("--look-animation", "none");
                            });
                    }
                    dotPointerOut(t) {
                        let e = t.target.getAttribute(ot),
                            i = this.slides[e].querySelector(r5);
                        i.classList.remove(os),
                            i.dispatchEvent(new Event("mouseleave")),
                            this.observer && this.observer.disconnect(),
                            this.pointers.forEach((t) => {
                                t.style.removeProperty("--look-animation");
                            });
                    }
                    observeImage(t) {
                        (this.observer = new IntersectionObserver(
                            (t, e) => {
                                t.forEach((t) => {
                                    let e = t.target;
                                    0 == t.intersectionRatio || (e.dispatchEvent(new Event("mouseenter")), e.classList.add(os));
                                });
                            },
                            { root: this.slider, threshold: [0.95, 1] }
                        )),
                            this.observer.observe(t);
                    }
                    triggerClick(t) {
                        requestAnimationFrame(() => t.dispatchEvent(new Event("click")));
                    }
                    destroyQuickViewPopup() {
                        var t, e;
                        let i = null === (t = this.quickViewPopup) || void 0 === t || null === (e = t.loadPhotoswipe) || void 0 === e ? void 0 : e.pswpElement;
                        i && i.classList.contains(oa) && this.quickViewPopup.loadPhotoswipe.popup.close();
                    }
                    onBlockSelect(t) {
                        this.debouncedBlockSelectCallback(t);
                    }
                    debouncedBlockSelect(t) {
                        var e, i;
                        let s = null === (e = this.quickViewPopup) || void 0 === e || null === (i = e.loadPhotoswipe) || void 0 === i ? void 0 : i.pswpElement;
                        s
                            ? setTimeout(() => {
                                  if (s.classList.contains(oa)) {
                                      let e = this.quickViewPopup.loadPhotoswipe.pswpElement.querySelector(`[${oe}="${t.target.getAttribute(oe)}"]`),
                                          i = this.quickViewPopup.loadPhotoswipe.pswpElement.querySelectorAll("[data-quick-view-item-holder]");
                                      e.classList.add(oo),
                                          i.forEach((t) => {
                                              t !== e && t.classList.remove(oo);
                                          });
                                  } else this.triggerClick(t.target);
                              })
                            : setTimeout(() => this.triggerClick(t.target), 400);
                    }
                    onUnload() {
                        this.destroyQuickViewPopup(), document.removeEventListener("theme:resize:width", this.checkSlidesSizeOnResize);
                    }
                    onDeselect() {
                        this.destroyQuickViewPopup();
                    }
                    constructor(t) {
                        (this.container = t),
                            (this.slider = this.container.querySelector("[data-slider]")),
                            (this.slides = this.container.querySelectorAll("[data-slide-item]")),
                            (this.pointers = this.container.querySelectorAll("[data-pointer]")),
                            (this.flkty = null),
                            (this.observer = null),
                            (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
                            (this.pointersInit = (t) => this.dotPointers(t)),
                            (this.pointersOver = (t) => this.dotPointerIn(t)),
                            (this.pointersOut = (t) => this.dotPointerOut(t)),
                            (this.debouncedBlockSelectCallback = o((t) => this.debouncedBlockSelect(t), 500)),
                            (this.quickViewPopup = new sf(this.container)),
                            this.listen();
                    }
                })(this.container);
            },
            onUnload() {
                rZ[this.id].onUnload();
            },
            onBlockSelect(t) {
                rZ[this.id].onBlockSelect(t);
            },
            onDeselect() {
                rZ[this.id].onDeselect();
            },
        },
    ]),
        K("mosaic", {
            onBlockSelect(t) {
                let e = t.target.closest("[data-grid]"),
                    i = e.currentStyle || window.getComputedStyle(e),
                    s = parseInt(i.paddingLeft),
                    r = t.target.offsetLeft - s;
                e.scrollTo({ top: 0, left: r, behavior: "smooth" });
            },
        }),
        K("newsletter", rI),
        K("overlapping-images", rm);
    let on = {};
    K("password-template", {
        onLoad() {
            on[this.id] = new (class {
                init() {
                    this.toggleAdmin.addEventListener("click", (t) => {
                        t.preventDefault(), this.showPasswordForm();
                    }),
                        this.toggleNewsletter.addEventListener("click", (t) => {
                            t.preventDefault(), this.hidePasswordForm();
                        }),
                        "#login" == window.location.hash || this.adminErrors ? this.showPasswordForm() : this.hidePasswordForm();
                }
                showPasswordForm() {
                    io(this.adminForm), ia(this.newsletterForm), (window.location.hash = "#login");
                }
                hidePasswordForm() {
                    io(this.newsletterForm), ia(this.adminForm), (window.location.hash = "");
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.toggleAdmin = this.container.querySelector("[data-toggle-admin]")),
                        (this.toggleNewsletter = this.container.querySelector("[data-toggle-newsletter]")),
                        (this.adminForm = this.container.querySelector("[data-form-admin]")),
                        (this.newsletterForm = this.container.querySelector("[data-form-newsletter]")),
                        (this.adminErrors = this.adminForm.querySelector(".errors")),
                        (this.newsletterErrors = this.newsletterForm.querySelector(".errors")),
                        this.init();
                }
            })(this);
        },
    });
    let ol = "[data-popup-body]",
        oh = "[data-popup-close]",
        oc = "[data-popup-underlay]",
        od = "[data-newsletter-form]",
        ou = "data-target-referrer",
        op = "has-success",
        om = "selected",
        og = "has-block-selected",
        oy = "popup--expanded",
        ov = "popup--visible",
        of = "mobile",
        ob = "desktop",
        oS = "popup-bar-is-visible",
        oE = {},
        oL = 0,
        ok = 0,
        ow = [],
        o$ = class {
            always() {
                this.showPopup();
            }
            delayed(t = 10) {
                setTimeout(() => {
                    this.showPopup();
                }, 1e3 * t);
            }
            bottom() {
                document.addEventListener("theme:scroll", this.showPopupOnScrollEvent);
            }
            idle() {
                if (!0 !== this.checkPopupTarget()) return;
                let t = 0,
                    e = ["mousemove", "mousedown", "click", "touchmove", "touchstart", "touchend", "keydown", "keypress"],
                    i = ["load", "resize", "scroll"],
                    s = () => {
                        (t = setTimeout(() => {
                            (t = 0), this.showPopup();
                        }, 6e4)),
                            e.forEach((t) => {
                                document.addEventListener(t, r);
                            }),
                            i.forEach((t) => {
                                window.addEventListener(t, r);
                            });
                    },
                    r = () => {
                        t && clearTimeout(t),
                            e.forEach((t) => {
                                document.removeEventListener(t, r);
                            }),
                            i.forEach((t) => {
                                window.removeEventListener(t, r);
                            }),
                            s();
                    };
                s();
            }
            showPopup() {
                let t = { id: this.popup.id, body: this.popupBody };
                if ((ow.push(t), !0 === this.checkPopupTarget())) {
                    if (
                        ((ok += 1),
                        this.popup.classList.add(ov),
                        this.popup.classList.contains("popup--bar") && document.body.classList.add(oS),
                        this.a11y.trapFocus({ container: this.popupBody }),
                        this.popup.hasAttribute("data-prevent-scroll-lock"))
                    )
                        return !1;
                    this.scrollLock();
                }
            }
            checkPopupTarget() {
                let t = this.popup.parentNode.classList.contains(of),
                    e = this.popup.parentNode.classList.contains(ob);
                return !((t && window.innerWidth >= theme.sizes.small) || (e && window.innerWidth < theme.sizes.small));
            }
            scrollLock() {
                document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.popupBody }));
            }
            showPopupOnScroll() {
                window.scrollY + window.innerHeight >= document.body.clientHeight && (this.showPopup(), document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent));
            }
            onUnload() {
                document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent);
            }
            constructor(t, e) {
                if (
                    ((this.popupContainer = t),
                    (this.popup = e),
                    (this.popupBody = e.querySelector(ol)),
                    (this.delay = t.dataset.popupDelay),
                    (this.isSubmitted = -1 !== window.location.href.indexOf("accepts_marketing") || -1 !== window.location.href.indexOf("customer_posted=true")),
                    (this.a11y = tu),
                    (this.showPopupOnScrollEvent = () => this.showPopupOnScroll()),
                    ("always" === this.delay || this.isSubmitted) && this.always(),
                    this.delay && this.delay.includes("delayed") && !this.isSubmitted)
                ) {
                    let i = this.delay.includes("_") ? parseInt(this.delay.split("_")[1]) : 10;
                    this.delayed(i);
                }
                "bottom" !== this.delay || this.isSubmitted || this.bottom(), "idle" !== this.delay || this.isSubmitted || this.idle();
            }
        },
        oA = class {
            constructor(t) {
                if (((this.popupContainer = t), (this.locationPath = location.href), !this.popupContainer.hasAttribute(ou))) return !1;
                -1 !== this.locationPath.indexOf(this.popupContainer.getAttribute(ou)) || window.Shopify.designMode || this.popupContainer.parentNode.removeChild(this.popupContainer);
            }
        };
    K("popups", [
        {
            onLoad() {
                (oE[this.id] = []), window.Shopify.designMode && (ok = 0);
                let t = this.container.querySelectorAll("[data-large-promo]");
                t.length &&
                    t.forEach((t) => {
                        oE[this.id].push(
                            new (class {
                                init() {
                                    (!1 === this.cookie.read() || window.Shopify.designMode) &&
                                        (window.Shopify.designMode ? this.showPopup() : new o$(this.popupContainer, this.popup),
                                        this.form &&
                                            setTimeout(() => {
                                                this.form.classList.contains(op) && (this.showPopupIfNoCookie(), (ok -= 1));
                                            }),
                                        this.initClosers());
                                }
                                checkPopupTarget() {
                                    let t = this.popup.parentNode.classList.contains(of),
                                        e = this.popup.parentNode.classList.contains(ob);
                                    return !((t && window.innerWidth >= theme.sizes.small) || (e && window.innerWidth < theme.sizes.small));
                                }
                                showPopupIfNoCookie() {
                                    this.showPopup();
                                }
                                initClosers() {
                                    this.close.addEventListener("click", this.closePopup.bind(this)),
                                        this.underlay.addEventListener("click", this.closePopup.bind(this)),
                                        this.popupContainer.addEventListener("keyup", (t) => {
                                            t.code === theme.keyboardKeys.ESCAPE && this.closePopup(t);
                                        });
                                }
                                closePopup(t) {
                                    t.preventDefault(), this.hidePopup(), this.cookie.write();
                                }
                                scrollLock() {
                                    this.resetScrollUnlock(), this.a11y.trapFocus({ container: this.popupBody }), document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.popupBody }));
                                }
                                scrollUnlock() {
                                    this.resetScrollUnlock(),
                                        (oL = setTimeout(() => {
                                            document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                                        }, 300));
                                }
                                resetScrollUnlock() {
                                    oL && clearTimeout(oL);
                                }
                                showPopup() {
                                    let t = !0 === this.checkPopupTarget(),
                                        e = { id: this.popupId, body: this.popup };
                                    ow.push(e), t && ((ok += 1), this.popup.classList.add(ov), this.scrollLock());
                                }
                                hidePopup() {
                                    this.popup.classList.remove(ov);
                                    let t = ow.findIndex((t) => t.id === this.popupId);
                                    if (((ok -= 1), ow.splice(t, 1), 1 == ok && document.body.classList.contains(oS))) this.scrollUnlock();
                                    else if (ok < 1) this.scrollUnlock(), this.a11y.removeTrapFocus();
                                    else if (ow.length > 0) {
                                        let e = ow[ow.length - 1].body;
                                        this.a11y.trapFocus({ container: e });
                                    }
                                }
                                onBlockSelect(t) {
                                    this.popupContainer.contains(t.target) && !this.popup.classList.contains(ov) && (this.popup.classList.add(om), this.popupContainer.classList.add(og), this.showPopup());
                                }
                                onBlockDeselect(t) {
                                    this.popupContainer.contains(t.target) && (this.popup.classList.remove(om), this.popupContainer.classList.remove(og), this.hidePopup());
                                }
                                onUnload() {
                                    this.scrollUnlock();
                                }
                                onDeselect() {
                                    this.popup.classList.remove(om), this.popupContainer.classList.remove(og), this.hidePopup();
                                }
                                constructor(t) {
                                    (this.popupContainer = t),
                                        (this.popup = this.popupContainer.querySelector("[data-large-promo-inner]")),
                                        (this.popupBody = this.popup.querySelector(ol)),
                                        (this.popupId = this.popup.id),
                                        (this.close = this.popup.querySelector(oh)),
                                        (this.underlay = this.popup.querySelector(oc)),
                                        (this.form = this.popup.querySelector(od)),
                                        (this.cookie = new rT(this.popupContainer.dataset.cookieName, "user_has_closed")),
                                        (this.isTargeted = new oA(this.popupContainer)),
                                        (this.a11y = tu),
                                        this.init();
                                }
                            })(t)
                        );
                    });
                let e = this.container.querySelectorAll("[data-popup-bar]");
                e.length &&
                    e.forEach((t) => {
                        oE[this.id].push(
                            new (class {
                                init() {
                                    (!1 !== this.cookie.read() && !window.Shopify.designMode) ||
                                        (window.Shopify.designMode ? this.showPopup() : new o$(this.popupContainer, this.popup),
                                        this.initPopupToggleButton(),
                                        this.initClosers(),
                                        this.form &&
                                            setTimeout(() => {
                                                this.form.classList.contains(op) && this.showPopupIfNoCookie(), this.form.classList.contains("has-error") && this.toggle.dispatchEvent(new Event("click"));
                                            }));
                                }
                                checkPopupTarget() {
                                    let t = this.popup.parentNode.classList.contains(of),
                                        e = this.popup.parentNode.classList.contains(ob);
                                    return !((t && window.innerWidth >= theme.sizes.small) || (e && window.innerWidth < theme.sizes.small));
                                }
                                showPopupIfNoCookie() {
                                    this.showPopup(), this.toggle.dispatchEvent(new Event("click"));
                                }
                                initPopupToggleButton() {
                                    this.toggle.addEventListener("click", (t) => {
                                        t.preventDefault(), this.popup.classList.toggle(oy), this.popup.classList.contains(oy) ? this.scrollLock() : this.scrollUnlock();
                                    });
                                }
                                showPopup() {
                                    let t = { id: this.popupId, body: this.popup };
                                    ow.push(t), this.a11y.trapFocus({ container: this.popupBody }), !0 === this.checkPopupTarget() && ((ok += 1), document.body.classList.add(oS), this.popup.classList.add(ov));
                                }
                                hidePopup() {
                                    this.popup.classList.remove(ov), document.body.classList.remove(oS);
                                    let t = ow.findIndex((t) => t.id === this.popupId);
                                    if ((ow.splice(t, 1), ok >= 1 && (ok -= 1), ok < 1)) this.scrollUnlock(), this.a11y.removeTrapFocus();
                                    else if (ow.length > 0) {
                                        let e = ow[ow.length - 1].body;
                                        this.a11y.trapFocus({ container: e });
                                    }
                                }
                                initClosers() {
                                    this.close.addEventListener("click", this.closePopup.bind(this)),
                                        this.underlay.addEventListener("click", () => this.toggle.dispatchEvent(new Event("click"))),
                                        this.popupContainer.addEventListener("keyup", (t) => {
                                            t.code === theme.keyboardKeys.ESCAPE && (this.popup.classList.remove(oy), this.scrollUnlock());
                                        });
                                }
                                closePopup(t) {
                                    t.preventDefault(), this.cookie.write(), this.hidePopup();
                                }
                                scrollLock() {
                                    document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.popupBody }));
                                }
                                scrollUnlock() {
                                    this.resetScrollUnlock(),
                                        (oL = setTimeout(() => {
                                            document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                                        }, 300));
                                }
                                resetScrollUnlock() {
                                    oL && clearTimeout(oL);
                                }
                                onBlockSelect(t) {
                                    this.popupContainer.contains(t.target) &&
                                        !this.popup.classList.contains(ov) &&
                                        (this.showPopup(), this.popup.classList.add(oy), this.popup.classList.add(om), this.popup.parentNode.classList.add(og), this.resetScrollUnlock(), this.scrollLock());
                                }
                                onBlockDeselect(t) {
                                    this.popupContainer.contains(t.target) && (this.popup.classList.remove(oy), this.popup.classList.remove(om), this.popup.parentNode.classList.remove(og), this.hidePopup());
                                }
                                onUnload() {
                                    this.scrollUnlock();
                                }
                                onDeselect() {
                                    this.popup.classList.remove(oy), this.popup.classList.remove(om), this.popup.parentNode.classList.remove(og), this.hidePopup();
                                }
                                constructor(t) {
                                    (this.popupContainer = t),
                                        (this.popup = this.popupContainer.querySelector("[data-popup-bar-holder]")),
                                        (this.popupBody = this.popup.querySelector(ol)),
                                        (this.popupId = this.popup.id),
                                        (this.close = this.popup.querySelector(oh)),
                                        (this.underlay = this.popup.querySelector(oc)),
                                        (this.toggle = this.popup.querySelector("[data-popup-bar-toggle]")),
                                        (this.cookie = new rT(this.popupContainer.dataset.cookieName, "user_has_closed")),
                                        (this.form = this.popup.querySelector(od)),
                                        (this.isTargeted = new oA(this.popupContainer)),
                                        (this.a11y = tu),
                                        this.init();
                                }
                            })(t)
                        );
                    });
                let i = this.container.querySelectorAll("[data-tracking-consent]");
                i.length &&
                    i.forEach((t) => {
                        oE[this.id].push(
                            new (class {
                                init() {
                                    this.enableTracking && this.showPopup(), this.clickEvents();
                                }
                                clickEvents() {
                                    this.close.addEventListener("click", (t) => {
                                        t.preventDefault(), window.Shopify.customerPrivacy.setTrackingConsent(!1, () => this.hidePopup());
                                    }),
                                        this.acceptButton.addEventListener("click", (t) => {
                                            t.preventDefault(), window.Shopify.customerPrivacy.setTrackingConsent(!0, () => this.hidePopup());
                                        }),
                                        document.addEventListener("trackingConsentAccepted", () => {
                                            console.log("trackingConsentAccepted event fired");
                                        });
                                }
                                showPopup() {
                                    let t = { id: this.popupId, body: this.popup };
                                    ow.push(t), this.popup.classList.add(ov), this.a11y.trapFocus({ container: this.popup });
                                }
                                hidePopup() {
                                    this.popup.classList.remove(ov);
                                    let t = ow.findIndex((t) => t.id === this.popupId);
                                    if ((ow.splice(t, 1), ok < 1)) this.a11y.removeTrapFocus();
                                    else if (ow.length > 0) {
                                        let e = ow[ow.length - 1].body;
                                        this.a11y.trapFocus({ container: e });
                                    }
                                }
                                onBlockSelect(t) {
                                    this.popupContainer.contains(t.target) && this.enableTracking && !this.popup.classList.contains(ov) && (this.showPopup(), this.popup.classList.add(om), this.popup.parentNode.classList.add(og));
                                }
                                onBlockDeselect(t) {
                                    this.popupContainer.contains(t.target) && (this.popup.classList.remove(om), this.popupContainer.classList.remove(og), this.hidePopup());
                                }
                                onDeselect() {
                                    this.popup.classList.remove(om), this.popupContainer.classList.remove(og), this.hidePopup();
                                }
                                constructor(t) {
                                    (this.popupContainer = t),
                                        (this.popup = this.popupContainer.querySelector("[data-tracking-consent-inner]")),
                                        (this.popupId = this.popup.id),
                                        (this.close = this.popup.querySelector(oh)),
                                        (this.acceptButton = this.popup.querySelector("[data-confirm-cookies]")),
                                        (this.enable = "true" === this.popupContainer.dataset.enable),
                                        (this.a11y = tu),
                                        window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], (t) => {
                                            if (t) throw t;
                                            let e = window.Shopify.customerPrivacy.userCanBeTracked(),
                                                i = window.Shopify.customerPrivacy.getTrackingConsent();
                                            (this.enableTracking = !e && "no_interaction" === i && this.enable), window.Shopify.designMode && (this.enableTracking = !0), this.init();
                                        });
                                }
                            })(t)
                        );
                    });
            },
            onDeselect() {
                oE[this.id].forEach((t) => {
                    "function" == typeof t.onDeselect && t.onDeselect();
                });
            },
            onBlockSelect(t) {
                oE[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                });
            },
            onBlockDeselect(t) {
                oE[this.id].forEach((e) => {
                    "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
                });
            },
            onUnload(t) {
                oE[this.id].forEach((e) => {
                    "function" == typeof e.onUnload && e.onUnload(t);
                });
            },
        },
        rI,
    ]);
    let oq = "[data-logo-slide]",
        oC = {};
    K("press", {
        onLoad() {
            oC[this.id] = new (class {
                checkSlides() {
                    let t = this.container.offsetWidth,
                        i = this.container.querySelectorAll(oq),
                        s = e.data(this.sliderNav) || null;
                    null !== s &&
                        ((s.options.draggable = !1),
                        (s.options.wrapAround = !1),
                        (s.options.contain = !0),
                        this.getSlidesWidth() > t && i.length > 2 && ((s.options.draggable = !0), (s.options.wrapAround = !0), (s.options.contain = !1)),
                        s.resize(),
                        s.updateDraggable());
                }
                getSlidesWidth() {
                    let t = this.container.querySelectorAll(oq),
                        e = 0;
                    return (
                        t.length &&
                            t.forEach((t) => {
                                e += t.offsetWidth;
                            }),
                        e
                    );
                }
                initSlider() {
                    let t = e.data(this.slider) || null,
                        i = e.data(this.sliderNav) || null,
                        s = parseInt(this.container.dataset.duration),
                        r = "true" === this.container.dataset.autoplay && s;
                    (t = new e(this.slider, { fade: !0, wrapAround: !0, adaptiveHeight: !0, prevNextButtons: !1, pageDots: !1, autoPlay: r })),
                        (i = new e(this.sliderNav, {
                            draggable: !1,
                            wrapAround: !1,
                            contain: !0,
                            imagesLoaded: !0,
                            lazyLoad: !0,
                            asNavFor: this.slider,
                            prevNextButtons: !1,
                            adaptiveHeight: !1,
                            pageDots: !1,
                            on: {
                                ready: () => {
                                    this.container.querySelectorAll(oq).forEach((e) => {
                                        e.addEventListener("keyup", (i) => {
                                            if (i.code === theme.keyboardKeys.ENTER || i.code === theme.keyboardKeys.NUMPADENTER || i.code === theme.keyboardKeys.SPACE) {
                                                let s = Number(e.getAttribute("data-logo-index"));
                                                t.selectCell(s);
                                            }
                                        });
                                    });
                                },
                            },
                        })),
                        tf(this.slider),
                        tf(this.sliderNav),
                        i.on("change", (e) => {
                            t.selectCell(e);
                        }),
                        t.on("change", (e) => {
                            i.selectCell(e),
                                t.cells.forEach((t, i) => {
                                    t.element.querySelectorAll("a, button").forEach((t) => {
                                        t.setAttribute("tabindex", i === e ? "0" : "-1");
                                    });
                                });
                        });
                }
                resizeSlider() {
                    let t = e.data(this.slider);
                    t && t.resize();
                }
                onBlockSelect(t) {
                    let i = e.data(this.slider) || null,
                        s = e.data(this.sliderNav) || null,
                        r = parseInt([...t.target.parentNode.children].indexOf(t.target));
                    null !== i && (i.select(r), i.pausePlayer()), null !== s && s.select(r);
                }
                onBlockDeselect() {
                    let t = e.data(this.slider) || null;
                    "true" === this.container.dataset.autoplay && null !== t && t.playPlayer();
                }
                onUnload() {
                    document.removeEventListener("theme:resize:width", this.sliderResizeEvent);
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.slider = this.container.querySelector("[data-press-items]")),
                        (this.sliderNav = this.container.querySelector("[data-logo-slider]")),
                        (this.sliderResizeEvent = () => this.checkSlides()),
                        this.initSlider(),
                        this.checkSlides(),
                        window.addEventListener("load", this.resizeSlider.bind(this)),
                        document.addEventListener("theme:resize:width", this.sliderResizeEvent);
                }
            })(this);
        },
        onUnload(t) {
            oC[this.id].onUnload(t);
        },
        onBlockSelect(t) {
            oC[this.id].onBlockSelect(t);
        },
        onBlockDeselect() {
            oC[this.id].onBlockDeselect();
        },
    });
    let oT = "[data-product-info]",
        oP = "[data-header-height]",
        o_ = "is-sticky";
    window.theme.variables = { productPageSticky: !1 };
    let oF = {},
        ox = {
            onLoad() {
                oF[this.id] = new (class {
                    init() {
                        this.stickyEnabled && (this.stickyScrollCheck(), document.addEventListener("theme:resize", this.resizeEvent)), this.initSticky();
                    }
                    initSticky() {
                        theme.variables.productPageSticky &&
                            ((this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition())),
                            this.productInfo.addEventListener("theme:form:sticky", (t) => {
                                this.removeAnimationFrame(), (this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition(t)));
                            }),
                            document.addEventListener("theme:scroll", this.scrollEvent));
                    }
                    scrollEvents(t) {
                        null !== t.detail && ((this.scrollTop = t.detail.position), (this.scrollDirectionDown = t.detail.down)),
                            this.requestAnimationSticky || (this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition()));
                    }
                    resizeEvents() {
                        this.stickyScrollCheck(), document.removeEventListener("theme:scroll", this.scrollEvent), this.initSticky();
                    }
                    stickyScrollCheck() {
                        let t = (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) >= window.theme.sizes.large,
                            e = this.container.querySelector(oT);
                        if (e) {
                            if (t) {
                                let i = this.container.querySelector(oT),
                                    s = this.container.querySelector("[data-product-single-media-slider]");
                                if (!i || !s) return;
                                i.offsetHeight < s.offsetHeight ? ((theme.variables.productPageSticky = !0), e.classList.add(o_)) : ((theme.variables.productPageSticky = !1), e.classList.remove(o_));
                            } else (theme.variables.productPageSticky = !1), e.classList.remove(o_);
                        }
                    }
                    calculateStickyPosition(t = null) {
                        let e = Boolean(t && t.detail),
                            i = Boolean(e && t.detail.element && "accordion" === t.detail.element),
                            s = this.productInfo.offsetHeight,
                            r = window.innerHeight - s - this.defaultTopBottomSpacings,
                            o = Math.abs(this.scrollTop - this.scrollLastPosition);
                        this.scrollDirectionDown ? (this.stickyScrollTop -= o) : (this.stickyScrollTop += o),
                            this.stickyFormLoad &&
                                (document.querySelector("[data-header-sticky]") && document.querySelector(oP)
                                    ? (this.stickyDefaultTop = parseInt(document.querySelector(oP).getBoundingClientRect().height))
                                    : (this.stickyDefaultTop = this.defaultTopBottomSpacings),
                                (this.stickyScrollTop = this.stickyDefaultTop)),
                            (this.stickyScrollTop = Math.min(Math.max(this.stickyScrollTop, r), this.stickyDefaultTop));
                        let a = this.stickyScrollTop - this.currentPoint;
                        (this.currentPoint = this.stickyFormLoad ? this.stickyScrollTop : this.currentPoint + 0.5 * a),
                            this.productInfo.style.setProperty("--sticky-top", `${this.currentPoint}px`),
                            (this.scrollLastPosition = this.scrollTop),
                            (this.stickyFormLoad = !1),
                            (i && this.onChangeCounter <= 10) || (i && this.stickyFormLastHeight !== s) || (this.stickyScrollTop !== this.currentPoint && this.requestAnimationSticky)
                                ? (i && (this.onChangeCounter += 1), i && this.stickyFormLastHeight !== s && (this.onChangeCounter = 11), (this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition(t))))
                                : this.requestAnimationSticky && this.removeAnimationFrame(),
                            (this.stickyFormLastHeight = s);
                    }
                    removeAnimationFrame() {
                        this.requestAnimationSticky && (cancelAnimationFrame(this.requestAnimationSticky), (this.requestAnimationSticky = null), (this.onChangeCounter = 0));
                    }
                    onUnload() {
                        this.stickyEnabled && document.removeEventListener("theme:resize", this.resizeEvent), theme.variables.productPageSticky && document.removeEventListener("theme:scroll", this.scrollEvent);
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.stickyEnabled = "true" === this.container.getAttribute("data-sticky-enabled")),
                            (this.productInfo = this.container.querySelector(oT)),
                            (this.stickyScrollTop = 0),
                            (this.scrollLastPosition = 0),
                            (this.stickyDefaultTop = 0),
                            (this.currentPoint = 0),
                            (this.defaultTopBottomSpacings = 30),
                            (this.scrollTop = window.scrollY),
                            (this.scrollDirectionDown = !0),
                            (this.requestAnimationSticky = null),
                            (this.stickyFormLoad = !0),
                            (this.stickyFormLastHeight = null),
                            (this.onChangeCounter = 0),
                            (this.scrollEvent = (t) => this.scrollEvents(t)),
                            (this.resizeEvent = (t) => this.resizeEvents(t)),
                            this.init();
                    }
                })(this);
            },
            onUnload() {
                oF[this.id].onUnload();
            },
        },
        oI = "pswp-zoom-gallery",
        oH = "data-url",
        oD = class extends HTMLElement {
            connectedCallback() {
                new IntersectionObserver(
                    ((t, e) => {
                        t[0].isIntersecting &&
                            (e.unobserve(this),
                            this.hasAttribute(oH) &&
                                "" !== this.getAttribute(oH) &&
                                fetch(this.getAttribute(oH))
                                    .then((t) => t.text())
                                    .then((t) => {
                                        let e = document.createElement("div");
                                        e.innerHTML = t;
                                        let i = e.querySelector("[data-complementary-products]");
                                        i && i.innerHTML.trim().length && (this.innerHTML = i.innerHTML), e.querySelector("[data-button-quick-view]") && new sf(this);
                                    })
                                    .catch((t) => {
                                        console.error(t);
                                    }));
                    }).bind(this),
                    { rootMargin: "0px 0px 400px 0px" }
                ).observe(this);
            }
            constructor() {
                super();
            }
        },
        o8 = class extends HTMLElement {
            connectedCallback() {
                this.recipientCheckbox && (this.disableInputFields(), this.recipientCheckbox.addEventListener("change", this.onChangeEvent), document.addEventListener("theme:cart:added", this.onCartAddedEvent));
            }
            onChange(t) {
                if (!t.target.checked) return this.clearInputFields(), void this.disableInputFields();
                this.enableInputFields();
            }
            onCartAdded() {
                let t = this.closest("[data-product-form]").offsetTop,
                    e = document.body.classList.contains("js-quick-view-visible");
                if (!0 !== this.recipientCheckbox.checked) return;
                e || window.scrollTo({ top: t, left: 0, behavior: "smooth" });
                let i = (t) => {
                    t.target === this.cartDrawer &&
                        (requestAnimationFrame(() => {
                            (this.recipientCheckbox.checked = !1), this.recipientCheckbox.dispatchEvent(new Event("change"));
                        }),
                        this.cartDrawer.removeEventListener("transitionend", i));
                };
                this.cartDrawer.addEventListener("transitionend", i);
            }
            inputFields() {
                return [this.recipientEmail, this.recipientName, this.recipientMessage, this.recipientSendOn];
            }
            disableableFields() {
                return [...this.inputFields(), this.recipientOffset];
            }
            clearInputFields() {
                this.inputFields().forEach((t) => (t.value = ""));
            }
            enableInputFields() {
                this.disableableFields().forEach((t) => (t.disabled = !1));
            }
            disableInputFields() {
                this.disableableFields().forEach((t) => (t.disabled = !0));
            }
            disconnectedCallback() {
                this.recipientCheckbox.removeEventListener("change", this.onChangeEvent), document.removeEventListener("theme:cart:added", this.onCartAddedEvent);
            }
            constructor() {
                super(),
                    (this.recipientCheckbox = this.querySelector("[data-recipient-checkbox]")),
                    (this.recipientControl = this.querySelector("[data-recipient-control]")),
                    (this.recipientControl.disabled = !0),
                    (this.recipientEmail = this.querySelector("[data-recipient-email]")),
                    (this.recipientName = this.querySelector("[data-recipient-name]")),
                    (this.recipientMessage = this.querySelector("[data-recipient-message]")),
                    (this.recipientSendOn = this.querySelector("[data-recipient-send-on]")),
                    (this.recipientOffset = this.querySelector("[data-recipient-offset]")),
                    this.recipientOffset && (this.recipientOffset.value = new Date().getTimezoneOffset()),
                    (this.cartDrawer = document.querySelector("[data-cart-drawer]")),
                    (this.onChangeEvent = (t) => this.onChange(t)),
                    (this.onCartAddedEvent = () => this.onCartAdded());
            }
        },
        oM = "[data-product-single-media-slider]",
        oO = "[data-product-single-media-thumbs]",
        oB = "[data-product-single-media-wrapper]",
        o9 = "[data-model]",
        oz = "a, button",
        oW = "[data-slider]",
        oR = "has-media-active",
        oV = "media--hidden",
        oN = "is-moving",
        oU = "data-media-id",
        oj = "tabindex",
        oK = {},
        oQ = {
            onLoad() {
                oK[this.id] = new (class {
                    productSlider() {
                        this.checkSlider(), document.addEventListener("theme:resize:width", this.checkSliderOnResize);
                    }
                    checkSlider() {
                        !this.tallLayout || window.innerWidth < theme.sizes.large ? this.initProductSlider() : this.destroyProductSlider();
                    }
                    resizeFlickityNav() {
                        null !== this.flktyNav && this.flktyNav.resize();
                    }
                    initProductSlider() {
                        let t = this.container.querySelector(oM),
                            i = this.container.querySelector(oO),
                            s = this.container.querySelectorAll(oB);
                        if (
                            s.length > 1 &&
                            ((this.flkty = new e(t, {
                                wrapAround: !0,
                                pageDots: !1,
                                adaptiveHeight: !0,
                                on: {
                                    ready() {
                                        t.setAttribute(oj, "-1"),
                                            s.forEach((t) => {
                                                if (!t.classList.contains("is-selected")) {
                                                    let e = t.querySelectorAll(oz);
                                                    e.length &&
                                                        e.forEach((t) => {
                                                            t.setAttribute(oj, "-1");
                                                        });
                                                }
                                            });
                                    },
                                    dragStart() {
                                        t.classList.add(oN);
                                    },
                                    dragMove: () => {
                                        this.isFlickityDragging = !0;
                                    },
                                    staticClick: () => {
                                        this.isFlickityDragging = !1;
                                    },
                                    settle: (e) => {
                                        let i = this.flkty.selectedElement.getAttribute(oU);
                                        this.flkty.cells.forEach((t, i) => {
                                            let s = t.element.querySelectorAll(oz);
                                            s.length &&
                                                s.forEach((t) => {
                                                    t.setAttribute(oj, i === e ? "0" : "-1");
                                                });
                                        }),
                                            this.switchMedia(i),
                                            t.classList.remove(oN);
                                    },
                                },
                            })),
                            s.length &&
                                s.forEach((t) => {
                                    t.addEventListener("theme:media:play", () => {
                                        (this.flkty.options.draggable = !1), this.flkty.updateDraggable(), t.closest(oM).classList.add(oR);
                                    }),
                                        t.addEventListener("theme:media:pause", () => {
                                            (this.flkty.options.draggable = !0), this.flkty.updateDraggable(), t.closest(oM).classList.remove(oR);
                                        });
                                }),
                            tf(t),
                            null !== i)
                        ) {
                            (this.flktyNav = new e(i, {
                                asNavFor: t,
                                contain: !0,
                                pageDots: !1,
                                prevNextButtons: !1,
                                resize: !0,
                                on: {
                                    ready() {
                                        i.setAttribute(oj, "-1");
                                    },
                                },
                            })),
                                null !== this.flktyNav && document.addEventListener("theme:resize:width", this.flktyNavOnResize),
                                tf(i);
                            let r = this.container.querySelectorAll(".product-single__thumbnail-link");
                            r.length &&
                                r.forEach((t) => {
                                    t.addEventListener("click", (t) => {
                                        t.preventDefault();
                                    });
                                });
                        }
                    }
                    destroyProductSlider() {
                        null !== this.flkty && (this.flkty.destroy(), this.flktyNav.destroy(), (this.flkty = null), (this.flktyNav = null));
                    }
                    initUpsellSlider() {
                        let t = this.container.querySelector("[data-upsell-slider]");
                        if (this.container.querySelectorAll("[data-upsell-holder]").length > 1) {
                            let i = new e(t, { wrapAround: !0, pageDots: !0, adaptiveHeight: !0, prevNextButtons: !1 });
                            i.on("change", (t) => {
                                i.cells.forEach((e, i) => {
                                    let s = e.element.querySelectorAll(oz);
                                    s.length &&
                                        s.forEach((e) => {
                                            e.setAttribute(oj, i === t ? "0" : "-1");
                                        });
                                });
                            });
                        }
                    }
                    initFeatureSlider() {
                        this.featureSliders.forEach((t) => {
                            Array.from(t.children).length > 1 && (this.flktyFeature = new e(t, { wrapAround: !0, pageDots: !0, adaptiveHeight: !0, prevNextButtons: !1 }));
                        });
                    }
                    handleMediaFocus(t) {
                        if (t.code !== theme.keyboardKeys.ENTER && t.code !== theme.keyboardKeys.TAB) return;
                        let i = t.currentTarget.getAttribute("data-thumbnail-id"),
                            s = this.container.querySelector(`[${oU}="${i}"]`),
                            r = parseInt([...s.parentNode.children].indexOf(s)),
                            o = this.container.querySelector(oM),
                            a = this.container.querySelector(oO),
                            n = e.data(o) || null,
                            l = e.data(a) || null;
                        n && n.isActive && r > -1 && (t.code === theme.keyboardKeys.ENTER || t.code === theme.keyboardKeys.NUMPADENTER) && n.select(r), l && l.isActive && r > -1 && l.select(r);
                    }
                    switchMedia(t) {
                        let e = document.querySelectorAll(`${oB}`),
                            i = this.container.querySelector(`${oB}[${oU}="${t}"]`),
                            s = !document.body.classList.contains("no-outline");
                        e.length &&
                            e.forEach((t) => {
                                t.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }), t.classList.add(oV);
                            }),
                            s && i.focus(),
                            i.closest(oM).classList.remove(oR),
                            i.classList.remove(oV),
                            i.dispatchEvent(new CustomEvent("theme:media:visible"), { bubbles: !0 });
                        let r = i.querySelector("[data-deferred-media]");
                        r && "true" !== r.getAttribute("loaded") && i.querySelector("[data-deferred-media-button]").dispatchEvent(new Event("click"));
                    }
                    initMediaSwitch() {
                        let t = this.container.querySelectorAll("[data-thumbnail-id]");
                        t.length &&
                            t.forEach((t) => {
                                t.addEventListener("keyup", this.handleMediaFocus.bind(this)),
                                    t.addEventListener("click", (t) => {
                                        t.preventDefault();
                                    });
                            });
                    }
                    initProductVideo() {
                        this.videos = new tk(this.container);
                    }
                    initProductModel() {
                        let t = this.container.querySelectorAll(o9);
                        t.length &&
                            t.forEach((t) => {
                                theme.ProductModel.init(t, this.sectionId);
                            });
                    }
                    initShopifyXrLaunch() {
                        document.addEventListener("shopify_xr_launch", () => {
                            this.container.querySelector(`${o9}:not(.${oV})`).dispatchEvent(new CustomEvent("xrLaunch"));
                        });
                    }
                    onUnload() {
                        null !== this.flktyNav && document.removeEventListener("theme:resize:width", this.flktyNavOnResize), document.removeEventListener("theme:resize:width", this.checkSliderOnResize);
                    }
                    scrollToReviews() {
                        let t = this.container.querySelector("[data-product-rating]");
                        t &&
                            ["click", "keydown"].forEach((e) => {
                                t.addEventListener(e, (t) => {
                                    if ((t.code !== theme.keyboardKeys.ENTER && t.code !== theme.keyboardKeys.NUMPADENTER) || "click" != t.type) {
                                        let e = document.querySelector("#shopify-product-reviews");
                                        e && e.scrollIntoView({ behavior: "smooth" });
                                    }
                                });
                            });
                    }
                    onBlockSelect(t) {
                        let i = e.data(t.target.closest(oW)),
                            s = parseInt([...t.target.parentNode.children].indexOf(t.target));
                        i && i.select(s);
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.sectionId = this.container.getAttribute("data-section-id")),
                            (this.tallLayout = "true" === this.container.getAttribute("data-tall-layout")),
                            (this.featureSliders = this.container.querySelectorAll(oW)),
                            (this.flkty = null),
                            (this.flktyNav = null),
                            (this.isFlickityDragging = !1),
                            (this.enableHistoryState = !this.container.classList.contains("featured-product")),
                            (this.checkSliderOnResize = () => this.checkSlider()),
                            (this.flktyNavOnResize = () => this.resizeFlickityNav()),
                            this.scrollToReviews(),
                            this.initUpsellSlider(),
                            this.initFeatureSlider(),
                            new sf(this.container),
                            this.container.classList.contains("featured-product--onboarding") ||
                                (new (class {
                                    init() {
                                        this.zoomWrappers.length &&
                                            this.zoomWrappers.forEach((t, e) => {
                                                t.addEventListener("click", (i) => {
                                                    i.preventDefault(), (this.slider && this.slider.classList.contains("is-moving")) || ((this.a11y.state.trigger = t), this.createZoom(e));
                                                });
                                            });
                                    }
                                    createZoom(t) {
                                        let e = this,
                                            i = [],
                                            s = 0;
                                        this.zoomWrappers.forEach((r) => {
                                            let o = r.getAttribute("href"),
                                                a = parseInt(r.getAttribute("data-image-width")),
                                                n = parseInt(r.getAttribute("data-image-height"));
                                            if ((i.push({ src: o, w: a, h: n, msrc: o }), (s += 1), e.zoomWrappers.length === s)) {
                                                let l = `${oI}`;
                                                1 === s && (l = `${oI} pswp-zoom-gallery--single`),
                                                    new sl(i, {
                                                        barsSize: { top: 60, bottom: 60 },
                                                        history: !1,
                                                        focus: !1,
                                                        index: t,
                                                        mainClass: l,
                                                        showHideOpacity: !0,
                                                        showAnimationDuration: 250,
                                                        hideAnimationDuration: 250,
                                                        closeOnScroll: !1,
                                                        closeOnVerticalDrag: !1,
                                                        captionEl: !1,
                                                        closeEl: !0,
                                                        closeElClasses: ["caption-close"],
                                                        tapToClose: !1,
                                                        clickToCloseNonZoomable: !1,
                                                        maxSpreadZoom: 2,
                                                        loop: !0,
                                                        spacing: 0,
                                                        allowPanToNext: !0,
                                                        pinchToClose: !1,
                                                    });
                                            }
                                        });
                                    }
                                    constructor(t) {
                                        (this.container = t),
                                            (this.mediaContainer = this.container.querySelector("[data-product-single-media-group]")),
                                            (this.slider = this.container.querySelector("[data-product-single-media-slider]")),
                                            (this.zoomWrappers = this.container.querySelectorAll("[data-zoom-wrapper]")),
                                            (this.zoomEnable = "true" === this.mediaContainer.dataset.gallery),
                                            (this.a11y = tu),
                                            this.zoomEnable && this.init();
                                    }
                                })(this.container),
                                this.productSlider(),
                                this.initMediaSwitch(),
                                this.initProductVideo(),
                                this.initProductModel(),
                                this.initShopifyXrLaunch());
                    }
                })(this);
            },
            onUnload: function () {
                oK[this.id].onUnload();
            },
            onBlockSelect(t) {
                oK[this.id].onBlockSelect(t);
            },
        };
    K("product-template", [ix, oQ, tZ, t5, ru, tl, tI, iV, ir, ox]),
        K("featured-product", [ix, oQ, tZ, t5, ru, tl, tI, iV, ir, ox]),
        customElements.get("complementary-products") || customElements.define("complementary-products", oD),
        customElements.get("recipient-form") || customElements.define("recipient-form", o8);
    let o0 = "data-deferred-media-loaded",
        o3 = "[data-product-single-media-wrapper]",
        oG = "[data-model]",
        o1 = "[data-product-link]",
        oX = "[data-product-single-media-image]",
        oJ = "[data-slider-contents]",
        oY = "[data-tab-item]",
        o2 = "[data-circle-text]",
        o6 = { aosAnimate: "aos-animate", tabButtonActive: "products-list__nav__button--active", tabItemActive: "products-list__item--active", mediaHidden: "media--hidden", isDisabled: "is-disabled" },
        o4 = {};
    K("products-list", {
        onLoad() {
            o4[this.id] = new (class {
                listen() {
                    (this.slidersImages.length > 0 || this.slidersContents.length > 0) && document.addEventListener("theme:resize", this.sliderResizeEvent);
                }
                resizeSlider() {
                    this.flktyImages.length > 0 &&
                        requestAnimationFrame(() => {
                            this.flktyImages.forEach((t) => t.resize());
                        }),
                        this.flktyContent.length > 0 &&
                            requestAnimationFrame(() => {
                                this.flktyContent.forEach((t) => t.resize());
                            });
                }
                initButtons() {
                    this.tabButtons.length &&
                        this.tabButtons.forEach((t) => {
                            t.addEventListener("click", (e) => {
                                if (t.classList.contains(o6.tabButtonActive)) return;
                                let i = t.getAttribute("href"),
                                    s = this.container.querySelector(i),
                                    r = s.querySelector(o3),
                                    o = r ? r.dataset.mediaId : null,
                                    a = s.querySelector(o2);
                                this.tabButtons.forEach((t) => {
                                    t.classList.remove(o6.tabButtonActive);
                                }),
                                    this.tabItems.forEach((t) => {
                                        let e = t.querySelector(o2);
                                        t.classList.remove(o6.tabItemActive),
                                            null == e || e.classList.add(o6.isDisabled),
                                            theme.settings.animations &&
                                                t.querySelectorAll(`.${o6.aosAnimate}`).forEach((t) => {
                                                    t.classList.remove(o6.aosAnimate),
                                                        setTimeout(() => {
                                                            t.classList.add(o6.aosAnimate);
                                                        });
                                                });
                                    }),
                                    t.classList.add(o6.tabButtonActive),
                                    s.classList.add(o6.tabItemActive),
                                    document.dispatchEvent(new Event("theme:resize")),
                                    a && (a.classList.remove(o6.isDisabled), document.dispatchEvent(new Event("theme:scroll"))),
                                    this.handleProductVideos(s, o),
                                    e.preventDefault();
                            });
                        });
                }
                initSliders() {
                    this.slidersImages.forEach((t, i) => {
                        let s = t.closest(oY).querySelector(oJ),
                            r = new e(t, {
                                fade: !0,
                                pageDots: !1,
                                prevNextButtons: !0,
                                wrapAround: !0,
                                adaptiveHeight: !0,
                                asNavFor: s,
                                on: {
                                    change: (t) => {
                                        this.flktyContent.length > 0 && this.flktyContent[i].select(t);
                                    },
                                },
                            });
                        r.on("settle", (e) => {
                            let i = t.querySelectorAll(o3);
                            for (let s = 0; s < i.length; s++) s === e ? i[s].querySelector(oX).removeAttribute("tabindex") : i[s].querySelector(oX).setAttribute("tabindex", "-1");
                        }),
                            this.flktyImages.push(r);
                    }),
                        this.slidersContents.forEach((t) => {
                            let i = new e(t, { fade: !0, pageDots: !1, prevNextButtons: !1, wrapAround: !0, adaptiveHeight: !0 });
                            i.on("settle", (e) => {
                                let i = t.querySelectorAll("[data-product-content-wrapper]");
                                for (let s = 0; s < i.length; s++)
                                    s === e
                                        ? i[s].querySelectorAll(o1).forEach((t) => {
                                              t.removeAttribute("tabindex");
                                          })
                                        : i[s].querySelectorAll(o1).forEach((t) => {
                                              t.setAttribute("tabindex", "-1");
                                          });
                            }),
                                this.flktyContent.push(i);
                        });
                }
                initProductVideos() {
                    this.tabItems.forEach((t) => {
                        t.classList.contains(o6.tabItemActive) && this.handleProductVideos(t);
                    });
                }
                loadVideos(t, e = null) {
                    new IntersectionObserver(
                        (i, s) => {
                            i.forEach((i) => {
                                if (i.isIntersecting) {
                                    let r = new tk(t);
                                    this.videos.push(r), t.setAttribute(o0, ""), this.playToggle(e), s.unobserve(i.target);
                                }
                            });
                        },
                        { root: null, rootMargin: "300px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
                    ).observe(t);
                }
                handleProductVideos(t, e = null) {
                    t.hasAttribute(o0) ? this.playToggle(e) : this.loadVideos(t, e);
                }
                playToggle(t) {
                    this.videos.forEach((e) => {
                        "function" == typeof e.pauseContainerMedia && t && (e.pauseContainerMedia(t, this.container), this.switchMedia(t)), t || 0 !== Object.keys(e.players).length || this.pauseContainerMedia(this.container);
                    });
                }
                switchMedia(t) {
                    let e = this.container.querySelector(`${o3}[data-media-id="${t}"]`);
                    document.body.classList.contains(o6.noOutline) || e.focus(), e.classList.remove(o6.mediaHidden), e.dispatchEvent(new CustomEvent("theme:media:visible"), { bubbles: !0 });
                }
                pauseContainerMedia(t) {
                    let e = t.querySelectorAll(o3);
                    0 !== e.length &&
                        e.forEach((t) => {
                            t.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }), t.classList.add(o6.mediaHidden);
                        });
                }
                initProductModel() {
                    let t = this.container.querySelectorAll(oG);
                    t.length &&
                        t.forEach((t) => {
                            theme.ProductModel.init(t, this.sectionId);
                        });
                }
                initShopifyXrLaunch() {
                    document.addEventListener("shopify_xr_launch", () => {
                        this.container.querySelector(`${oG}:not(.${o6.mediaHidden})`).dispatchEvent(new CustomEvent("xrLaunch"));
                    });
                }
                initCircleText() {
                    this.container.querySelectorAll(o2).forEach((t) => {
                        new (class {
                            init() {
                                this.circleText.hasAttribute("data-circle-text-parallax") && document.addEventListener("theme:scroll", this.scrollEvent);
                            }
                            updateParallax() {
                                if (this.circleText.classList.contains("is-disabled")) return;
                                let t = Math.round(window.innerHeight),
                                    e = Math.round(window.scrollY),
                                    i = e + t,
                                    s = Math.round(this.circleText.getBoundingClientRect().top + e),
                                    r = this.circleText.offsetHeight;
                                if (s < i && !(s + r < e)) {
                                    let o = (100 * (i - s - r / 2)) / t,
                                        a = -(((this.rotateDegree * o) / 100) * 1);
                                    o > 0 && (this.circleText.style.transform = `rotate(${this.adjustRotateDegree + a}deg)`);
                                }
                            }
                            unload() {
                                document.removeEventListener("theme:scroll", this.scrollEvent);
                            }
                            constructor(t) {
                                (this.circleText = t), (this.rotateDegree = 70), (this.adjustRotateDegree = this.rotateDegree / 2), (this.scrollEvent = () => this.updateParallax()), this.init();
                            }
                        })(t);
                    });
                }
                onBlockSelect(t) {
                    t.target.dispatchEvent(new Event("click"));
                }
                onUnload() {
                    (this.slidersImages.length > 0 || this.slidersContents.length > 0) && document.removeEventListener("theme:resize", this.sliderResizeEvent);
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.sectionId = this.container.dataset.sectionId),
                        (this.tabButtons = this.container.querySelectorAll("[data-tab-button]")),
                        (this.tabItems = this.container.querySelectorAll(oY)),
                        (this.slidersImages = this.container.querySelectorAll("[data-slider-images]")),
                        (this.slidersContents = this.container.querySelectorAll(oJ)),
                        (this.videos = []),
                        (this.flktyImages = []),
                        (this.flktyContent = []),
                        (this.sliderResizeEvent = () => this.resizeSlider()),
                        this.initButtons(),
                        this.initSliders(),
                        this.initProductVideos(),
                        this.initProductModel(),
                        this.initShopifyXrLaunch(),
                        this.initCircleText(),
                        this.listen();
                }
            })(this);
        },
        onUnload() {
            o4[this.id].onUnload();
        },
        onBlockSelect(t) {
            o4[this.id].onBlockSelect(t);
        },
    });
    let oZ = "[data-related-products]",
        o5 = {};
    K("related-products", {
        onLoad() {
            o5[this.id] = new (class {
                init() {
                    let t = this.container.getAttribute("data-section-id"),
                        e = this.container.getAttribute("data-product-id"),
                        i = this.container.getAttribute("data-limit"),
                        s = `${theme.routes.product_recommendations_url}?section_id=${t}&limit=${i}&product_id=${e}`;
                    fetch(s)
                        .then((t) => t.text())
                        .then((t) => {
                            let e = document.createElement("div");
                            e.innerHTML = t;
                            let i = e.querySelector(oZ);
                            i.querySelectorAll("[data-product-block]").length && ((this.relatedProducts.innerHTML = i.innerHTML), (this.productGrid = new er(this.container)), (this.gridSlider = new rz(this.container)));
                        });
                }
                onDeselect() {
                    this.productGrid && this.productGrid.onDeselect();
                }
                onUnload() {
                    this.productGrid && this.productGrid.onUnload(), this.gridSlider && this.gridSlider.onUnload();
                }
                constructor(t) {
                    (this.container = t), (this.relatedProducts = this.container.querySelector(oZ)), this.init();
                }
            })(this.container);
        },
        onDeselect() {
            o5[this.id].onDeselect();
        },
        onUnload() {
            o5[this.id].onUnload();
        },
    });
    let o7 = {},
        at = "[data-slider]",
        ae = "[data-item]",
        ai = "[data-item-products]",
        as = "[data-item-products-slider]",
        ar = "[data-item-product]",
        ao = "a, button",
        aa = "blog-item--active",
        an = "blog-item__products--visible",
        al = "is-selected",
        ah = { slider: "data-slider", slidePosition: "data-slide-position", sectionId: "data-section-id", tabIndex: "tabindex" };
    K("shoppable-blog", {
        onLoad() {
            o7[this.id] = new (class {
                initSlider() {
                    (this.flkty = new e(this.slider, {
                        prevNextButtons: !0,
                        pageDots: !1,
                        cellAlign: "left",
                        wrapAround: !1,
                        groupCells: !0,
                        contain: !0,
                        on: {
                            ready: () => {
                                this.handleFocus();
                            },
                        },
                    })),
                        this.flkty.on("change", () => {
                            let t = this.container.querySelectorAll(ae);
                            this.handleFocus(),
                                t.length &&
                                    t.forEach((t) => {
                                        let e = t.querySelector(ai);
                                        t.classList.remove(aa), e && t.querySelector(ai).classList.remove(an);
                                    }),
                                this.flkty && !this.flkty.options.draggable && ((this.flkty.options.draggable = !0), this.flkty.updateDraggable());
                        });
                }
                destroySlider() {
                    null !== this.flkty && (this.flkty.destroy(), (this.flkty = null));
                }
                checkSlidesSize() {
                    let t = this.container.querySelector(ae).currentStyle || window.getComputedStyle(this.container.querySelector(ae));
                    this.gutter = parseInt(t.marginRight);
                    let e = this.slider.offsetWidth + this.gutter < this.getItemsWidth();
                    window.innerWidth >= theme.sizes.small && e ? this.initSlider() : this.destroySlider();
                }
                getItemsWidth() {
                    let t = 0,
                        e = this.slider.querySelectorAll(ae);
                    return (
                        e.length &&
                            e.forEach((e) => {
                                t += e.offsetWidth + this.gutter;
                            }),
                        t
                    );
                }
                bindButtons() {
                    let t = this.container.querySelectorAll(as),
                        i = this.container.querySelectorAll("[data-button-show]"),
                        s = this.container.querySelectorAll("[data-button-hide]");
                    i.length &&
                        i.forEach((t) => {
                            t.addEventListener("click", (e) => {
                                e.preventDefault(),
                                    this.container.querySelectorAll(ae).forEach((t) => {
                                        let e = t.querySelector(ai);
                                        t.classList.remove(aa), e && (e.classList.remove(an), this.changeTabIndex(e));
                                    });
                                let i = t.closest(ae),
                                    s = i.querySelector(ai);
                                if ((i.classList.add(aa), s)) {
                                    s.classList.add(an), this.changeTabIndex(s, "enable");
                                    let r = s.querySelector(as),
                                        o = r.querySelectorAll(ar);
                                    if (r.classList.contains("flickity-enabled")) {
                                        let a = r.querySelector(`.${al}`).getAttribute(ah.slidePosition);
                                        o.forEach((t, e) => {
                                            t.setAttribute(ah.tabIndex, e === a ? "0" : "-1");
                                        });
                                    }
                                }
                                null !== this.flkty && ((this.flkty.options.draggable = !1), this.flkty.updateDraggable()), (this.a11y.state.trigger = t);
                            });
                        }),
                        s.length &&
                            s.forEach((t) => {
                                t.addEventListener("click", (e) => {
                                    e.preventDefault();
                                    let i = t.closest(ae),
                                        s = i.querySelector(ai);
                                    i.classList.remove(aa), s && (s.classList.remove(an), this.changeTabIndex(s)), null !== this.flkty && ((this.flkty.options.draggable = !0), this.flkty.updateDraggable()), this.a11y.state.trigger.focus();
                                });
                            }),
                        t.length &&
                            t.forEach((t) => {
                                if (t.querySelectorAll(ar).length > 1) {
                                    let i = new e(t, {
                                        prevNextButtons: !0,
                                        contain: !0,
                                        pageDots: !1,
                                        wrapAround: !0,
                                        on: {
                                            change(t) {
                                                i.cells.forEach((e, i) => {
                                                    e.element.querySelectorAll(ao).forEach((e) => {
                                                        e.setAttribute(ah.tabIndex, i === t ? "0" : "-1");
                                                    });
                                                });
                                            },
                                        },
                                    });
                                }
                            }),
                        this.slider.addEventListener("keyup", (t) => {
                            if (t.code === theme.keyboardKeys.ESCAPE) {
                                let e = t.target.hasAttribute(ah.slider) ? t.target.querySelectorAll(ae) : t.target.closest(at).querySelectorAll(ae);
                                e.length &&
                                    (e.forEach((t) => {
                                        let e = t.querySelector(ai);
                                        t.classList.remove(aa), e && (e.classList.remove(an), this.changeTabIndex(e));
                                    }),
                                    this.flkty && ((this.flkty.options.draggable = !0), this.flkty.updateDraggable())),
                                    this.a11y.state.trigger.focus();
                            }
                        });
                }
                handleFocus() {
                    let t = this.container.querySelectorAll(ae);
                    t.length &&
                        t.forEach((t) => {
                            let e = t.classList.contains(al),
                                i = t.querySelector(ai);
                            e ? (this.changeTabIndex(t, "enable"), i && this.changeTabIndex(i)) : (this.changeTabIndex(t), i && i.classList.remove(an));
                        });
                }
                listen() {
                    this.slider && (this.checkSlidesSize(), document.addEventListener("theme:resize:width", this.checkSlidesSizeOnResize)), document.addEventListener("mousedown", this.clickOutsideItemEvent);
                }
                changeTabIndex(t, e = "") {
                    let i = "enable" === e ? "0" : "-1";
                    t.querySelectorAll(ao).forEach((t) => {
                        t.setAttribute(ah.tabIndex, i);
                    });
                }
                onBlockSelect(t) {
                    if (null !== this.flkty) {
                        let e = parseInt([...t.target.parentNode.children].indexOf(t.target)),
                            i = parseInt(this.flkty.slides[0].cells.length);
                        this.flkty.select(Math.floor(e / i));
                    } else {
                        let s = this.slider.currentStyle || window.getComputedStyle(this.slider),
                            r = parseInt(s.paddingLeft),
                            o = t.target.offsetLeft - r;
                        this.slider.scrollTo({ top: 0, left: o, behavior: "smooth" });
                    }
                }
                onUnload() {
                    document.removeEventListener("theme:resize:width", this.checkSlidesSizeOnResize), document.removeEventListener("mousedown", this.clickOutsideItemEvent);
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.flkty = null),
                        (this.slider = this.container.querySelector(at)),
                        (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
                        (this.isFullWidth = this.container.hasAttribute(ah.fullWidth)),
                        (this.gutter = 0),
                        (this.a11y = tu),
                        (this.clickOutsideItemEvent = (t) => {
                            if (!t.target.matches(ae) && !t.target.closest(ae)) {
                                let e = this.container.querySelectorAll(ae);
                                e.length &&
                                    e.forEach((t) => {
                                        let e = t.querySelector(ai);
                                        e && (e.classList.remove(an), this.changeTabIndex(e)), t.classList.remove(aa);
                                    });
                            }
                        }),
                        this.bindButtons(),
                        this.listen();
                }
            })(this);
        },
        onUnload(t) {
            o7[this.id].onUnload(t);
        },
        onBlockSelect(t) {
            o7[this.id].onBlockSelect(t);
        },
    });
    let ac = "[data-slide]",
        ad = "data-style",
        au = "data-current-style",
        ap = {};
    K("slider", [
        {
            onLoad() {
                ap[this.id] = new (class {
                    initSlider() {
                        let t = this.container.querySelectorAll(ac).length,
                            i = parseInt(this.container.dataset.duration),
                            s = (parseInt(this.container.dataset.sliderGroupcount), "true" === this.container.dataset.pageDots && t > 1),
                            r = "true" === this.container.dataset.navArrows && t > 1,
                            o = "true" === this.container.dataset.autoplay;
                        if ((o && (o = i), t > 1))
                            (this.flkty = new e(this.container, {
                                fade: !0,
                                cellSelector: ac,
                                autoPlay: o,
                                wrapAround: !0,
                                adaptiveHeight: !0,
                                setGallerySize: !0,
                                imagesLoaded: !0,
                                pageDots: s,
                                prevNextButtons: r,
                                on: {
                                    ready: () => {
                                        let t = this.container.querySelector(`${ac}[data-slide-position="1"]`).getAttribute(ad);
                                        this.container.setAttribute(au, t), requestAnimationFrame(this.resizeEvent), document.addEventListener("theme:vars", this.resizeEvent);
                                    },
                                    change: (t) => {
                                        let e = this.flkty.selectedElement.getAttribute(ad);
                                        this.container.setAttribute(au, e),
                                            this.flkty.cells.forEach((e, i) => {
                                                e.element.querySelectorAll("a, button").forEach((e) => {
                                                    e.setAttribute("tabindex", i === t ? "0" : "-1");
                                                });
                                            });
                                    },
                                },
                            })),
                                tf(this.container);
                        else if (1 === t) {
                            let a = this.container.querySelector(ac).getAttribute(ad);
                            this.container.setAttribute(au, a);
                        }
                    }
                    bindScrollButton() {
                        let t = this.container.querySelector("[data-scroll-down]");
                        t &&
                            t.addEventListener("click", (t) => {
                                t.preventDefault();
                                let e = this.header.classList.contains("site-header--fixed") ? 60 : 0,
                                    i = parseInt(Math.ceil(this.container.offsetTop + this.container.offsetHeight - e));
                                window.scrollTo({ top: i, left: 0, behavior: "smooth" });
                            });
                    }
                    onBlockSelect(t) {
                        let e = parseInt([...t.target.parentNode.children].indexOf(t.target));
                        null !== this.flkty && (this.flkty.select(e), this.flkty.pausePlayer());
                    }
                    onBlockDeselect(t) {
                        "true" === t.target.closest("[data-slider]").dataset.autoplay && null !== this.flkty && this.flkty.playPlayer();
                    }
                    onReorder() {
                        null !== this.flkty && this.flkty.resize();
                    }
                    onUnload() {
                        null !== this.flkty && (document.removeEventListener("theme:vars", this.resizeEvent), this.flkty.destroy(), (this.flkty = null));
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.header = document.querySelector("[data-site-header]")),
                            (this.flkty = null),
                            (this.resizeEvent = () => {
                                this.flkty.resize();
                            }),
                            this.initSlider(),
                            this.bindScrollButton();
                    }
                })(this);
            },
            onReorder(t) {
                ap[this.id].onReorder(t);
            },
            onUnload(t) {
                ap[this.id].onUnload(t);
            },
            onBlockSelect(t) {
                ap[this.id].onBlockSelect(t);
            },
            onBlockDeselect(t) {
                ap[this.id].onBlockDeselect(t);
            },
        },
        rm,
        ry,
    ]),
        K("subcollections", rW),
        K("tab-collections", [eo, rW, e2]);
    let am = {},
        ag = "[data-item]";
    K("testimonials", {
        onLoad() {
            am[this.id] = new (class {
                initSlider() {
                    let t = this.slider.querySelectorAll(ag).length,
                        i = this.slider.classList.contains("flickity-enabled");
                    (2 == t && window.innerWidth >= theme.sizes.small) || 1 == t || window.innerWidth < theme.sizes.small
                        ? i && this.flkty.destroy()
                        : ((this.flkty = new e(this.slider, { cellSelector: ag, prevNextButtons: !0, pageDots: !1, groupCells: !0, cellAlign: "left", contain: !0, adaptiveHeight: !1 })),
                          this.flkty.resize(),
                          this.flkty.slideableWidth > this.flkty.size.width || this.flkty.destroy());
                }
                onBlockSelect(t) {
                    if (null !== this.flkty) {
                        let e = parseInt([...t.target.parentNode.children].indexOf(t.target)),
                            i = parseInt(this.flkty.slides[0].cells.length);
                        this.flkty.select(Math.floor(e / i));
                    } else {
                        let s = this.slider.currentStyle || window.getComputedStyle(this.slider),
                            r = parseInt(s.paddingLeft),
                            o = t.target.offsetLeft - r;
                        this.slider.scrollTo({ top: 0, left: o, behavior: "smooth" });
                    }
                }
                onUnload() {
                    document.removeEventListener("theme:resize:width", this.sliderResizeEvent);
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.sectionId = this.container.getAttribute("data-section-id")),
                        (this.slider = this.container.querySelector("[data-slider]")),
                        (this.sliderResizeEvent = () => this.initSlider()),
                        (this.flkty = null),
                        this.initSlider(),
                        document.addEventListener("theme:resize:width", this.sliderResizeEvent);
                }
            })(this);
        },
        onUnload(t) {
            am[this.id].onUnload(t);
        },
        onBlockSelect(t) {
            am[this.id].onBlockSelect(t);
        },
    });
    let ay = "no-outline";
    document.documentElement.style.setProperty(
        "--scrollbar-width",
        `${(() => {
            let t = document.createElement("div");
            (t.style.visibility = "hidden"), (t.style.overflow = "scroll"), (t.style.msOverflowStyle = "scrollbar"), document.body.appendChild(t);
            let e = document.createElement("div");
            t.appendChild(e);
            let i = t.offsetWidth - e.offsetWidth;
            return t.parentNode.removeChild(t), i;
        })()}px`
    ),
        document.addEventListener("DOMContentLoaded", function () {
            Q("*"),
                "true" === document.body.dataset.animations && r.init({ once: !0, offset: 50, duration: 600, startEvent: "load" }),
                new (class {
                    init() {
                        (this.body = document.body),
                            (this.inPageLink = document.querySelector("[data-skip-content]")),
                            (this.linkesWithOnlyHash = document.querySelectorAll('a[href="#"]')),
                            (this.isFocused = !1),
                            this.focusHash(),
                            this.bindInPageLinks(),
                            this.clickEvents(),
                            this.focusEvents(),
                            this.focusEventsOff();
                    }
                    clickEvents() {
                        this.inPageLink &&
                            this.inPageLink.addEventListener("click", (t) => {
                                t.preventDefault();
                            }),
                            this.linkesWithOnlyHash &&
                                this.linkesWithOnlyHash.forEach((t) => {
                                    t.addEventListener("click", (t) => {
                                        t.preventDefault();
                                    });
                                });
                    }
                    focusEvents() {
                        document.addEventListener("keyup", (t) => {
                            t.code === theme.keyboardKeys.TAB && (this.body.classList.remove(ay), (this.isFocused = !0));
                        });
                    }
                    focusEventsOff() {
                        document.addEventListener("mousedown", () => {
                            this.body.classList.add(ay), (this.isFocused = !1);
                        });
                    }
                    forceFocus(t, e) {
                        e = e || {};
                        var i = t.tabIndex;
                        (t.tabIndex = -1),
                            (t.dataset.tabIndex = i),
                            t.focus(),
                            void 0 !== e.className && t.classList.add(e.className),
                            t.addEventListener("blur", function s(r) {
                                r.target.removeEventListener(r.type, s), (t.tabIndex = i), delete t.dataset.tabIndex, void 0 !== e.className && t.classList.remove(e.className);
                            });
                    }
                    focusHash(t) {
                        t = t || {};
                        let e = window.location.hash;
                        void 0 !== theme.settings.newHash && ((e = theme.settings.newHash), (window.location.hash = `#${e}`));
                        let i = document.getElementById(e.slice(1));
                        if (i && t.ignore && i.matches(t.ignore)) return !1;
                        e && i && this.forceFocus(i, t);
                    }
                    bindInPageLinks(t) {
                        return (
                            (t = t || {}),
                            Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]')).filter((e) => {
                                if ("#" === e.hash || "" === e.hash || (t.ignore && e.matches(t.ignore)) || ((i = e.hash.substr(1)), null === document.getElementById(i))) return !1;
                                var i,
                                    s = document.querySelector(e.hash);
                                return (
                                    !!s &&
                                    (e.addEventListener("click", () => {
                                        this.forceFocus(s, t);
                                    }),
                                    !0)
                                );
                            })
                        );
                    }
                    constructor() {
                        this.init();
                    }
                })(),
                !customElements.get("product-grid-item-swatch") && window.theme.settings.enableColorSwatchesCollection && customElements.define("product-grid-item-swatch", t2),
                "scrollBehavior" in document.documentElement.style || tm({ url: theme.assets.smoothscroll });
        });
  })(themeVendor.ScrollLock, themeVendor.Flickity, themeVendor.themeCurrency, themeVendor.ajaxinate, themeVendor.AOS);
  